"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9164],{

/***/ 20140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var application__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(430);
/* harmony import */ var components_Loading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38879);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26365);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35299);








var textButtonCart = "text-button-cart";
var ButtonCart = function(param) {
    var mediaScaleBottom = param.mediaScaleBottom, _textVisibleMobile = param.textVisibleMobile, textVisibleMobile = _textVisibleMobile === void 0 ? false : _textVisibleMobile, sendingItemToCart = param.sendingItemToCart, actionButton = param.actionButton, sizeProps = param.sizeProps, buttonInTheFixedHeader = param.buttonInTheFixedHeader;
    var handleClick = function() {
        if (!sendingItemToCart) {
            actionButton();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("button-cart")), {
        className: "add-to-cart",
        width: "100%",
        scaleMedia: mediaScaleBottom,
        onClick: handleClick,
        disabled: sendingItemToCart,
        sizeProps: sizeProps,
        children: sizeProps && textVisibleMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
            children: sendingItemToCart ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .CartIconWrapper */ .dR, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Loading__WEBPACK_IMPORTED_MODULE_2__/* .Loading */ .g, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("component-button-submit-loading")), {
                            size: "medium"
                        }))
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .TextButtonCart */ .Y0, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)(textButtonCart)), {
                        textVisibleMobile: textVisibleMobile,
                        children: "Adicionando..."
                    }))
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .CartIconWrapper */ .dR, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui__WEBPACK_IMPORTED_MODULE_4__.CartIcon, {
                            color: ui__WEBPACK_IMPORTED_MODULE_4__.theme.colors.neutral.white,
                            width: 28
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .TextButtonCart */ .Y0, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)(textButtonCart)), {
                        textVisibleMobile: textVisibleMobile,
                        children: "Adicionar"
                    }))
                ]
            })
        }, "add-cart") : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
            children: sendingItemToCart ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Loading__WEBPACK_IMPORTED_MODULE_2__/* .Loading */ .g, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("component-button-submit-loading")), {
                        size: "medium"
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .TextButtonCart */ .Y0, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)(textButtonCart)), {
                        textVisibleMobile: textVisibleMobile,
                        children: "Adicionando ao carrinho..."
                    }))
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui__WEBPACK_IMPORTED_MODULE_4__.CartIcon, {
                        color: ui__WEBPACK_IMPORTED_MODULE_4__.theme.colors.neutral.white,
                        width: 28
                    }),
                    buttonInTheFixedHeader ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .TextButtonCart */ .Y0, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)(textButtonCart)), {
                        textVisibleMobile: textVisibleMobile,
                        children: "Adicionar ao carrinho"
                    }))
                ]
            })
        }, "add-cart")
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (ButtonCart);


/***/ }),

/***/ 35299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y0": function() { return /* binding */ TextButtonCart; },
/* harmony export */   "dR": function() { return /* binding */ CartIconWrapper; },
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63356);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26365);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 1.25rem;\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  border: none;\n  border-radius: 4px;\n  gap: 8px;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  width: ",
        ";\n  background-color: ",
        ";\n  z-index: 1;\n  position: relative;\n\n  &:not(:disabled):hover {\n    filter: brightness(0.9);\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    pointer-events: none;\n    opacity: 0.5;\n  }\n\n  padding: 1rem;\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  transition: filter 0.2s ease-in-out;\n\n  @media ",
        " {\n    transform: scale(",
        ");\n    padding: 1.2rem 3rem;\n  }\n\n  @media ",
        " {\n    padding: 1rem;\n    width: 20rem;\n  }\n\n  @media ",
        " {\n    transform: scale(1);\n    height: ",
        ";\n    width: ",
        ";\n    border-radius: 4px;\n    padding: 0.75rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-height: 18px;\n  min-width: 18px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var TextButtonCart = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__TextButtonCart",
    componentId: "sc-67c75dfb-0"
})(_templateObject(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileL, function(param) {
    var textVisibleMobile = param.textVisibleMobile;
    return textVisibleMobile ? "1.15rem" : "1.25rem";
});
var Button = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "styles__Button",
    componentId: "sc-67c75dfb-1"
})(_templateObject1(), function(param) {
    var width = param.width;
    return width || ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x32;
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.secondary[300], function(param) {
    var color = param.color;
    return color || ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white;
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize !== null && fontSize !== void 0 ? fontSize : "1.5rem";
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight.bold, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.laptop, function(param) {
    var scaleMedia = param.scaleMedia;
    return scaleMedia !== null && scaleMedia !== void 0 ? scaleMedia : 1;
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.tabletS, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileXL, function(param) {
    var sizeProps = param.sizeProps;
    return sizeProps ? "36px" : "48px";
}, function(param) {
    var sizeProps = param.sizeProps;
    return sizeProps ? "116px" : "initial";
});
var CartIconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__CartIconWrapper",
    componentId: "sc-67c75dfb-2"
})(_templateObject2());


/***/ }),

/***/ 9164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ screens_Product; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/components/index.tsx + 205 modules
var components = __webpack_require__(88033);
// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./src/utils/constants/index.ts
var keyZipCodeStr = "@FC:Ecom:Dropdown:Cep";
var keyRegionLocation = "@FC:Ecom:Dropdown:Region";
var cookieBranchLocationStr = "@FC:Ecom:Dropdown:BranchLocation";
var cookieAccessToken = "@FC:Ecom:Token:Access";
var SECTIONS_ITEMS_MENU = [
    {
        description: "Sobre o Produto",
        idReference: "AboutTheProduct"
    },
    {
        description: "Ficha t\xe9cnica",
        idReference: "ProductSpec"
    },
    {
        description: "Veja Tamb\xe9m",
        idReference: "AlsoSee"
    }, 
];
var LIST_ENVIRONMENT_DEFAULT = -1;

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/ui/themes/index.ts + 15 modules
var themes = __webpack_require__(27814);
;// CONCATENATED MODULE: ./src/screens/Product/components/BoxCoupons/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  width: 100%;\n  max-width: 444px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  max-width: 37.85rem;\n  flex-direction: column;\n  gap: 1.35rem;\n  min-height: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: 1.4125rem;\n  font-weight: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 10px;\n  border: 1.5px solid ",
        ";\n  background: ",
        ";\n  width: 100%;\n  height: 8.5rem;\n  padding: 0 0.675rem;\n\n  @media (min-width: 768px) and (max-width: 1144px) {\n    padding: 0;\n  }\n\n  @media ",
        " {\n    height: auto;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 3.5rem;\n  align-items: center;\n  align-self: stretch;\n\n  padding: 0rem 0.65rem 0rem 1.35rem;\n  min-height: 100%;\n\n  @media ",
        " {\n    padding: 0;\n    gap: 1rem;\n  }\n\n  @media ",
        " {\n    padding: 0rem 0.65rem 0rem 0.35rem;\n  }\n\n  @media ",
        " {\n    padding: 0rem 0.65rem 0rem 1.35rem;\n  }\n\n  @media ",
        " {\n    padding: 0rem 0.65rem 0rem 0.35rem;\n    gap: 1.5rem;\n  }\n\n  @media ",
        " {\n    padding: 0.65rem;\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-width: 96px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: 2rem;\n  font-weight: ",
        ";\n\n  @media (min-width: 768px) and (max-width: 1144px) {\n    font-size: 1.75rem;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: 0.835rem;\n  font-weight: ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  bottom: 22px;\n  right: 6px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 184px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 184px;\n  max-height: 40px;\n\n  @media (min-width: 768px) and (max-width: 1144px) {\n    min-width: auto;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 2;\n  position: relative;\n  top: 6px;\n  left: ",
        ";\n\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: 1.15rem;\n  font-weight: ",
        ";\n  text-align: center;\n  user-select: none;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: 1.35rem;\n  font-weight: ",
        ";\n  text-align: center;\n  text-transform: uppercase;\n  user-select: none;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  cursor: pointer;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: 1.15rem;\n  font-weight: ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}



var BoxCouponsContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__BoxCouponsContainer",
    componentId: "sc-2476d1be-0"
})(_templateObject());
var BoxCouponsContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxCouponsContent",
    componentId: "sc-2476d1be-1"
})(_templateObject1());
var BoxCouponsTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "styles__BoxCouponsTitle",
    componentId: "sc-2476d1be-2"
})(_templateObject2(), themes/* theme.colors.neutral.720 */.rS.colors.neutral[720], themes/* theme.typography.fontFamily.chivo */.rS.typography.fontFamily.chivo, themes/* theme.typography.fontWeight.500 */.rS.typography.fontWeight[500]);
var CouponCardContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__CouponCardContainer",
    componentId: "sc-2476d1be-3"
})(_templateObject3(), themes/* theme.colors.neutral.105 */.rS.colors.neutral[105], themes/* theme.colors.neutral.white-075 */.rS.colors.neutral["white-075"], themes/* theme.device.desktopFirst.mobileM */.rS.device.desktopFirst.mobileM);
var CouponCardContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CouponCardContent",
    componentId: "sc-2476d1be-4"
})(_templateObject4(), themes/* theme.device.desktopFirst.laptop */.rS.device.desktopFirst.laptop, themes/* theme.device.desktopFirst.tabletXL */.rS.device.desktopFirst.tabletXL, themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet, themes/* theme.device.desktopFirst.mobileL */.rS.device.desktopFirst.mobileL, themes/* theme.device.desktopFirst.mobileM */.rS.device.desktopFirst.mobileM);
var CouponDiscountWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CouponDiscountWrapper",
    componentId: "sc-2476d1be-5"
})(_templateObject5());
var CouponDiscount = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__CouponDiscount",
    componentId: "sc-2476d1be-6"
})(_templateObject6(), themes/* theme.colors.primary.350 */.rS.colors.primary[350], themes/* theme.typography.fontFamily.chivo */.rS.typography.fontFamily.chivo, themes/* theme.typography.fontWeight.600 */.rS.typography.fontWeight[600]);
var CouponDiscountDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "styles__CouponDiscountDescription",
    componentId: "sc-2476d1be-7"
})(_templateObject7(), themes/* theme.colors.neutral.999 */.rS.colors.neutral[999], themes/* theme.typography.fontFamily.chivo */.rS.typography.fontFamily.chivo, themes/* theme.typography.fontWeight.400 */.rS.typography.fontWeight[400]);
var CouponNameWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CouponNameWrapper",
    componentId: "sc-2476d1be-8"
})(_templateObject8());
var CouponTicketIconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CouponTicketIconWrapper",
    componentId: "sc-2476d1be-9"
})(_templateObject9());
var CouponTicketIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.CouponTicket).attrs({
    width: "100%"
}).withConfig({
    displayName: "styles__CouponTicketIcon",
    componentId: "sc-2476d1be-10"
})(_templateObject10());
var CouponTicketWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CouponTicketWrapper",
    componentId: "sc-2476d1be-11"
})(_templateObject11());
var CouponName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__CouponName",
    componentId: "sc-2476d1be-12"
})(_templateObject12(), function(param) {
    var couponNameLengthGreaterThanTen = param.couponNameLengthGreaterThanTen;
    return couponNameLengthGreaterThanTen ? "calc(100% - calc(37.25% + calc(196px / 2)))" : "calc(100% - calc(23.8% + calc(196px / 2)))";
}, themes/* theme.colors.neutral.white-075 */.rS.colors.neutral["white-075"], themes/* theme.typography.fontFamily.chivo */.rS.typography.fontFamily.chivo, themes/* theme.typography.fontWeight.400 */.rS.typography.fontWeight[400]);
var CouponNameBold = styled_components_browser_esm/* default.strong.withConfig */.ZP.strong.withConfig({
    displayName: "styles__CouponNameBold",
    componentId: "sc-2476d1be-13"
})(_templateObject13(), themes/* theme.colors.neutral.white-075 */.rS.colors.neutral["white-075"], themes/* theme.typography.fontFamily.chivo */.rS.typography.fontFamily.chivo, themes/* theme.typography.fontWeight.600 */.rS.typography.fontWeight[600]);
var CopyCouponContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CopyCouponContainer",
    componentId: "sc-2476d1be-14"
})(_templateObject14());
var CopyCouponIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.Copy).withConfig({
    displayName: "styles__CopyCouponIcon",
    componentId: "sc-2476d1be-15"
})(_templateObject15());
var CopyCouponText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__CopyCouponText",
    componentId: "sc-2476d1be-16"
})(_templateObject16(), themes/* theme.colors.primary.350 */.rS.colors.primary[350], themes/* theme.typography.fontFamily.chivo */.rS.typography.fontFamily.chivo, themes/* theme.typography.fontWeight.500 */.rS.typography.fontWeight[500]);

;// CONCATENATED MODULE: ./src/screens/Product/components/BoxCoupons/index.tsx






var BoxCoupons = function(param) {
    var coupons = param.coupons, useToast = param.useToast;
    var addToast = useToast().addToast;
    var copyToClipboard = (0,react.useCallback)(function(couponName) {
        if (couponName) {
            var ref;
            navigator === null || navigator === void 0 ? void 0 : (ref = navigator.clipboard) === null || ref === void 0 ? void 0 : ref.writeText(couponName);
            addToast({
                isNewToast: true,
                newToastTheme: "light",
                type: "success",
                title: "Cupom copiado!",
                description: "O cupom ".concat(couponName, " foi copiado!")
            });
        }
    }, [
        addToast
    ]);
    return (coupons === null || coupons === void 0 ? void 0 : coupons.length) === 0 ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxCouponsContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-coupons-container")), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxCouponsContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-coupons-content")), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxCouponsTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-coupons-title")), {
                    children: (coupons === null || coupons === void 0 ? void 0 : coupons.length) === 1 ? "Cupom dispon\xedvel" : "Cupons dispon\xedveis"
                })),
                coupons === null || coupons === void 0 ? void 0 : coupons.map(function(coupon, index) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(CouponCardContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("coupon-card-container-".concat(coupon.couponName, "-").concat(coupon.productId))), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponCardContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("coupon-card-content-".concat(coupon.couponName, "-").concat(coupon.productId))), {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponDiscountWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("coupon-discount-wrapper-".concat(coupon.couponName, "-").concat(coupon.productId))), {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponDiscount, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("coupon-discount-".concat(coupon.couponName, "-").concat(coupon.productId))), {
                                            children: (0,application/* getDiscountMessage */.rYd)(coupon)
                                        })),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponDiscountDescription, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("coupon-discount-description-".concat(coupon.couponName, "-").concat(coupon.productId))), {
                                            children: "* Dispon\xedvel para produtos selecionados"
                                        }))
                                    ]
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponNameWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("coupon-name-wrapper-".concat(coupon.couponName, "-").concat(coupon.productId))), {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponTicketWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("coupon-ticket-wrapper-".concat(coupon.couponName, "-").concat(coupon.productId))), {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponName, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("coupon-name-".concat(coupon.couponName, "-").concat(coupon.productId))), {
                                                    couponNameLengthGreaterThanTen: (coupon === null || coupon === void 0 ? void 0 : (ref = coupon.couponName) === null || ref === void 0 ? void 0 : ref.length) > 10,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponNameBold, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("coupon-name-bold-".concat(coupon.couponName, "-").concat(coupon.productId))), {
                                                        children: coupon === null || coupon === void 0 ? void 0 : coupon.couponName
                                                    }))
                                                })),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponTicketIconWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("coupon-ticket-icon-wrapper-".concat(coupon.couponName, "-").concat(coupon.productId))), {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponTicketIcon, {})
                                                }))
                                            ]
                                        })),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CopyCouponContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("copy-coupon-container-".concat(coupon.couponName, "-").concat(coupon.productId))), {
                                            onClick: function() {
                                                return copyToClipboard(coupon === null || coupon === void 0 ? void 0 : coupon.couponName);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyCouponIcon, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyCouponText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("copy-coupon-text-".concat(coupon.couponName, "-").concat(coupon.productId))), {
                                                    children: "copiar cupom"
                                                }))
                                            ]
                                        }))
                                    ]
                                }))
                            ]
                        }))
                    }), (coupon === null || coupon === void 0 ? void 0 : coupon.couponName) || "coupon-".concat(index));
                })
            ]
        }))
    }));
};


;// CONCATENATED MODULE: ./src/screens/Product/components/PaymentMethods/subcomponents/PixPayment/PixPayment.styles.ts

function PixPayment_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: ",
        ";\n"
    ]);
    PixPayment_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PixPayment_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  gap: ",
        ";\n  padding: ",
        " ",
        ";\n  height: ",
        ";\n"
    ]);
    PixPayment_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PixPayment_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    PixPayment_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PixPayment_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    PixPayment_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PixPayment_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    PixPayment_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PixPayment_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    PixPayment_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function PixPayment_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    PixPayment_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PixPayment.styles__Container",
    componentId: "sc-b5fa1d6e-0"
})(PixPayment_styles_templateObject(), ui.theme.space.x4);
var Indicator = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PixPayment.styles__Indicator",
    componentId: "sc-b5fa1d6e-1"
})(PixPayment_styles_templateObject1(), ui.theme.space["x1.5"], ui.theme.space.x0, ui.theme.space.x2, ui.theme.space.x11);
var Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "PixPayment.styles__Title",
    componentId: "sc-b5fa1d6e-2"
})(PixPayment_styles_templateObject2(), ui.theme.typography.fontSize.sm.x3, ui.theme.typography.fontWeight[400]);
var Icon = (0,styled_components_browser_esm/* default */.ZP)(ui.PixIcon).withConfig({
    displayName: "PixPayment.styles__Icon",
    componentId: "sc-b5fa1d6e-3"
})(PixPayment_styles_templateObject3());
var Info = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PixPayment.styles__Info",
    componentId: "sc-b5fa1d6e-4"
})(PixPayment_styles_templateObject4(), ui.theme.space.x1);
var Label = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "PixPayment.styles__Label",
    componentId: "sc-b5fa1d6e-5"
})(PixPayment_styles_templateObject5(), ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[500], ui.theme.colors.neutral[550]);
var Price = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "PixPayment.styles__Price",
    componentId: "sc-b5fa1d6e-6"
})(PixPayment_styles_templateObject6(), ui.theme.typography.fontSize.sm.x7, ui.theme.typography.fontWeight[700], ui.theme.colors.secondary[230]);

;// CONCATENATED MODULE: ./src/screens/Product/components/PaymentMethods/subcomponents/PixPayment/PixPayment.component.tsx






var PixPayment = function(param) {
    var _discount = param.discount, discount = _discount === void 0 ? 0 : _discount, _price = param.price, price = _price === void 0 ? 0 : _price;
    var formatedPrice = price.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("pix-payment-container")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Indicator, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("pix-payment-indicator")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("pix-payment-title")), {
                        children: "Pix"
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                        width: ui.theme.space.x6,
                        height: ui.theme.space.x6
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Info, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("pix-payment-info")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("pix-payment-label")), {
                        children: "Pague no PIX ".concat(discount ? "com desconto" : "")
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Price, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("pix-payment-price")), {
                        children: [
                            formatedPrice,
                            " ",
                            discount ? "(".concat(discount, "% de desconto)") : ""
                        ]
                    }))
                ]
            }))
        ]
    }));
};
/* harmony default export */ var PixPayment_component = (PixPayment);

;// CONCATENATED MODULE: ./src/screens/Product/components/PaymentMethods/subcomponents/CardsFlags/CardsFlags.styles.tsx

function CardsFlags_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    CardsFlags_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CardsFlags_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n"
    ]);
    CardsFlags_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CardsFlags_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    CardsFlags_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CardsFlags_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    CardsFlags_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var CardsFlags_styles_Title = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    displayName: "CardsFlags.styles__Title",
    componentId: "sc-4c07a465-0"
})(CardsFlags_styles_templateObject(), ui.theme.typography.fontSize.sm.x3, ui.theme.typography.fontWeight[700], ui.theme.colors.neutral[520]);
var Flags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CardsFlags.styles__Flags",
    componentId: "sc-4c07a465-1"
})(CardsFlags_styles_templateObject1(), ui.theme.space.x1);
var CardsFlags_styles_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CardsFlags.styles__Container",
    componentId: "sc-4c07a465-2"
})(CardsFlags_styles_templateObject2(), ui.theme.space["x3.5"]);
var Card = (0,styled_components_browser_esm/* default */.ZP)(components/* Image */.Ee).withConfig({
    displayName: "CardsFlags.styles__Card",
    componentId: "sc-4c07a465-3"
})(CardsFlags_styles_templateObject3());

;// CONCATENATED MODULE: ./src/screens/Product/components/PaymentMethods/subcomponents/CardsFlags/CardsFlags.component.tsx







var CardsFlags = function() {
    var ref;
    var payments = (0,application/* getPaymentOptions */.V7P)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsFlags_styles_Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("cards-flags-container")), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flags, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("cards-flags")), {
            children: payments && (payments === null || payments === void 0 ? void 0 : (ref = payments.creditCards) === null || ref === void 0 ? void 0 : ref.map(function(payment) {
                return /*#__PURE__*/ (0,react.createElement)(Card, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("card-flag-".concat(payment.alt))), {
                    key: payment.alt,
                    src: payment.src,
                    alt: payment.alt,
                    width: ui.theme.space.x9,
                    height: ui.theme.space.x7
                }));
            }))
        }))
    }));
};

;// CONCATENATED MODULE: ./src/screens/Product/components/PaymentMethods/subcomponents/Installment/installment.styles.ts

function installment_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 588px;\n  background-color: ",
        ";\n  padding: ",
        ";\n"
    ]);
    installment_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function installment_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    installment_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function installment_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n"
    ]);
    installment_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function installment_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    installment_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function installment_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n\n  @media ",
        " {\n    font-weight: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    installment_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function installment_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  align-items: flex-start;\n\n  @media ",
        " {\n    flex-direction: row;\n    gap: ",
        ";\n    align-items: center;\n  }\n"
    ]);
    installment_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var installment_styles_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "installment.styles__Container",
    componentId: "sc-72a821ce-0"
})(installment_styles_templateObject(), function(param) {
    var isHighlighted = param.isHighlighted;
    return isHighlighted ? ui.theme.colors.neutral["white-075"] : "transparent";
}, ui.theme.space.x2);
var InstallmentPrice = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "installment.styles__InstallmentPrice",
    componentId: "sc-72a821ce-1"
})(installment_styles_templateObject1(), ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[300], ui.theme.colors.neutral[550]);
var InstallmentTitle = (0,styled_components_browser_esm/* default */.ZP)(InstallmentPrice).withConfig({
    displayName: "installment.styles__InstallmentTitle",
    componentId: "sc-72a821ce-2"
})(installment_styles_templateObject2(), ui.theme.typography.fontWeight[500]);
var SpotTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "installment.styles__SpotTitle",
    componentId: "sc-72a821ce-3"
})(installment_styles_templateObject3(), ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[500], ui.theme.colors.neutral[550]);
var FeeLegend = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "installment.styles__FeeLegend",
    componentId: "sc-72a821ce-4"
})(installment_styles_templateObject4(), ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[300], ui.theme.colors.neutral[550], ui.theme.device.mobileFirst.mobileXL, ui.theme.typography.fontWeight[400], ui.theme.colors.neutral[350]);
var InfoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "installment.styles__InfoContainer",
    componentId: "sc-72a821ce-5"
})(installment_styles_templateObject5(), ui.theme.space.x1, ui.theme.device.mobileFirst.mobileXL, ui.theme.space.x2);

;// CONCATENATED MODULE: ./src/screens/Product/components/PaymentMethods/subcomponents/Installment/Installment.component.tsx





var Installment = function(param) {
    var _hasFees = param.hasFees, hasFees = _hasFees === void 0 ? false : _hasFees, _price = param.price, price = _price === void 0 ? 0 : _price, _quantity = param.quantity, quantity = _quantity === void 0 ? 1 : _quantity, _totalPrice = param.totalPrice, totalPrice = _totalPrice === void 0 ? 0 : _totalPrice, _isHighlighted = param.isHighlighted, isHighlighted = _isHighlighted === void 0 ? false : _isHighlighted;
    var installmentPrice = price.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL"
    });
    var totalInstallmentPrice = totalPrice.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL"
    });
    var feeText = hasFees ? "com juros" : "sem juros";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(installment_styles_Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isHighlighted: isHighlighted
    }, (0,application/* buildTestIds */.Fek)("installment-container")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("installment-info-container")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InstallmentPrice, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("installment-price")), {
                        children: "".concat(quantity, "x de ").concat(installmentPrice)
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FeeLegend, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("installment-fee-legend")), {
                        children: feeText
                    }))
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SpotTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("installment-spot-title")), {
                children: totalInstallmentPrice
            }))
        ]
    }));
};

;// CONCATENATED MODULE: ./src/screens/Product/components/PaymentMethods/subcomponents/Installments/Installments.styles.tsx

function Installments_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 648px;\n  overflow-y: auto;\n"
    ]);
    Installments_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Installments_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    Installments_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Installments_styles_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Installments.styles__Container",
    componentId: "sc-5b692da8-0"
})(Installments_styles_templateObject());
var InstallmentsTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    displayName: "Installments.styles__InstallmentsTitle",
    componentId: "sc-5b692da8-1"
})(Installments_styles_templateObject1(), ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[600], ui.theme.colors.neutral[550]);

;// CONCATENATED MODULE: ./src/screens/Product/components/PaymentMethods/subcomponents/Installments/Installments.component.tsx






var Installments = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Installments_styles_Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("installments-container")), {
        children: data && data.map(function(param, index) {
            var hasFees = param.hasFees, price = param.price, totalPrice = param.totalPrice;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Installment, {
                price: price,
                quantity: index + 1,
                hasFees: hasFees,
                totalPrice: totalPrice,
                isHighlighted: index % 2 === 0
            }, "installment-".concat(price));
        })
    }));
};

;// CONCATENATED MODULE: ./src/screens/Product/components/PaymentMethods/PaymentMethods.styles.ts

function PaymentMethods_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  max-width: 588px;\n  min-width: ",
        ";\n  flex-direction: column;\n  gap: ",
        ";\n\n  @media ",
        " {\n    width: 530px !important;\n  }\n\n  @media ",
        " {\n    width: 400px;\n  }\n"
    ]);
    PaymentMethods_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PaymentMethods_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    PaymentMethods_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PaymentMethods_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    PaymentMethods_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PaymentMethods_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    PaymentMethods_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PaymentMethods_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: transparent;\n  display: flex;\n  align-items: center;\n  border: none;\n  padding-bottom: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n  gap: ",
        ";\n  cursor: pointer;\n"
    ]);
    PaymentMethods_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PaymentMethods_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    PaymentMethods_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var RootContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PaymentMethods.styles__RootContainer",
    componentId: "sc-7f8ca6d5-0"
})(PaymentMethods_styles_templateObject(), ui.theme.space.x90, ui.theme.space.x6, ui.theme.device.mobileFirst.tablet, ui.theme.device.mobileFirst.tabletS);
var CreditCardContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PaymentMethods.styles__CreditCardContainer",
    componentId: "sc-7f8ca6d5-1"
})(PaymentMethods_styles_templateObject1(), ui.theme.space.x4);
var SubTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "PaymentMethods.styles__SubTitle",
    componentId: "sc-7f8ca6d5-2"
})(PaymentMethods_styles_templateObject2(), ui.theme.typography.fontSize.sm.x3, ui.theme.typography.fontWeight[400]);
var MobileContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PaymentMethods.styles__MobileContainer",
    componentId: "sc-7f8ca6d5-3"
})(PaymentMethods_styles_templateObject3());
var BackButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "PaymentMethods.styles__BackButton",
    componentId: "sc-7f8ca6d5-4"
})(PaymentMethods_styles_templateObject4(), ui.theme.space.x3, ui.theme.typography.fontSize.sm.x5, ui.theme.colors.neutral[550], ui.theme.space.x1);
var BackIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.ArrowLeftIcon).withConfig({
    displayName: "PaymentMethods.styles__BackIcon",
    componentId: "sc-7f8ca6d5-5"
})(PaymentMethods_styles_templateObject5());

;// CONCATENATED MODULE: ./src/screens/Product/components/PaymentMethods/subcomponents/Root.tsx





var Root = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RootContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("payment-methods")), {
        children: children
    }));
};

;// CONCATENATED MODULE: ./src/screens/Product/components/PaymentMethods/subcomponents/index.tsx








;// CONCATENATED MODULE: ./src/screens/Product/components/PaymentMethods/PaymentMethods.component.tsx


/**
 * @description PaymentMethods component is used to display the payment methods available on the product page. The  product price with discount, credit card price with the installment fees and the credit card flags accepted..
 * @param data - The payment methods data that contains the price, discount and installments
 * @example
 * <PaymentMethods data={data} />
 * @see https://ferreiracosta.atlassian.net/browse/ECOMDGT-13084
 */ var PaymentMethods = function(param) {
    var data = param.data;
    var discount = data.discount, price = data.price, installments = data.installments, priceWithDiscount = data.priceWithDiscount;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Root, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PixPayment_component, {
                discount: discount,
                price: priceWithDiscount || price
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* HorizontalDivider */.EL, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CreditCardContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                        children: "Cart\xe3o de Cr\xe9dito"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Installments, {
                        data: installments
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsFlags, {})
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/screens/Product/components/PaymentMethods/index.tsx








/**
 * @description PaymentMethods component is used to display the payment methods available on the product page. The  product price with discount, credit card price with the installment fees and the credit card flags accepted..
 * @param data - The payment methods data that contains the price, discount and installments
 * @param onClickBackButton - function to be called when the back button is clicked
 * @param isMobile - boolean value to check if the device is mobile
 * @param isOpen - boolean value to check if the modal is open
 * @example
 * Mobile:
 *
 * <PaymentMethods isMobile={isClientMobile} data={data} onClickBackButton={() => confirm("Você tem certeza?")} />
 *
 * Desktop:
 *
 * <PaymentMethods data={data} isOpen={shouldOpenPaymentMethods} />
 * @see https://ferreiracosta.atlassian.net/browse/ECOMDGT-13084
 */ var PaymentMethods_PaymentMethods = function(param) {
    var data = param.data, onClickBackButton = param.onClickBackButton, onCloseModal = param.onCloseModal, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, _isOpen = param.isOpen, isOpen = _isOpen === void 0 ? false : _isOpen;
    if (!isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ModalGeneral */.CQ, {
            title: "Formas de pagamento",
            centeredTitle: true,
            bodyContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethods, {
                data: data
            }),
            isOpen: isOpen,
            ariaLabelForModal: "payment-methods",
            closeButtonSize: 24,
            hasTitleBorder: false,
            padding: "1.35rem 2rem 2rem 2rem",
            maxWidth: "588px",
            titleFontSize: ui.theme.typography.fontSize.md.x1,
            shouldCloseOnOverlayClick: true,
            fontWeight: ui.theme.typography.fontWeight[500],
            containerGap: "0",
            contentGap: ui.theme.space.x5,
            onCloseModal: onCloseModal
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("payment-methods")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BackButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("payment-methods-back-button")), {
                onClick: onClickBackButton,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BackIcon, {
                        color: ui.theme.colors.neutral[315],
                        width: ui.theme.space.x4,
                        height: ui.theme.space.x4
                    }),
                    "Formas de pagamento"
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethods, {
                data: data
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/screens/Product/components/ViewPaymentMethods/ViewPaymentMethods.service.tsx

var useViewPaymentMethods = function(param) {
    var discountPercentage = param.discountPercentage, maxNumberInstallments = param.maxNumberInstallments, salePrice = param.salePrice, spotPrice = param.spotPrice;
    var installmentsList = [];
    var newInstallmentList = new Set();
    var ref = (0,application/* useAppContext */.bp4)(), isClientMobile = ref.isClientMobile, isViewMorePaymentMethodsOpen = ref.isViewMorePaymentMethodsOpen, setIsViewMorePaymentMethodsOpen = ref.setIsViewMorePaymentMethodsOpen;
    for(var i = 0; i < maxNumberInstallments; i += 1){
        var installmentIndex = i + 1;
        var isInstallmentWithDiscount = discountPercentage && spotPrice && installmentIndex === 1;
        var installmentPrice = salePrice / installmentIndex;
        newInstallmentList.add({
            hasFees: false,
            price: isInstallmentWithDiscount ? spotPrice : installmentPrice,
            totalPrice: isInstallmentWithDiscount ? spotPrice : salePrice,
            quantity: installmentIndex
        });
        installmentsList.push("".concat(installmentIndex, "x ").concat((0,application/* formatCurrency */.xGv)(installmentPrice), " ").concat(!i && +discountPercentage ? "(".concat(discountPercentage, "% de desconto)") : "sem juros"));
    }
    var paymentMethodsData = {
        discount: Number(discountPercentage),
        price: salePrice,
        priceWithDiscount: spotPrice,
        installments: Array.from(newInstallmentList)
    };
    return {
        installmentsList: installmentsList,
        paymentMethodsData: paymentMethodsData,
        isViewMoreModalOpen: isViewMorePaymentMethodsOpen && !isClientMobile,
        isViewMoreComponentOpen: isViewMorePaymentMethodsOpen && isClientMobile,
        setIsViewMorePaymentMethodsOpen: setIsViewMorePaymentMethodsOpen,
        isClientMobile: isClientMobile
    };
};

;// CONCATENATED MODULE: ./src/screens/Product/components/ViewPaymentMethods/ViewPaymentMethods.styles.ts

function ViewPaymentMethods_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: fit-content;\n  display: flex;\n  position: relative;\n  z-index: 2;\n\n  @media ",
        " {\n    margin-bottom: 2rem;\n  }\n"
    ]);
    ViewPaymentMethods_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ViewPaymentMethods_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-size: 1.2rem;\n  font-weight: ",
        ";\n  cursor: pointer;\n  user-select: none;\n  text-decoration: underline;\n  color: ",
        ";\n  font-size: 1.125rem;\n"
    ]);
    ViewPaymentMethods_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var ViewPaymentMethods_styles_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ViewPaymentMethods.styles__Container",
    componentId: "sc-443293a7-0"
})(ViewPaymentMethods_styles_templateObject(), themes/* theme.device.desktopFirst.mobileL */.rS.device.desktopFirst.mobileL);
var Text = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ViewPaymentMethods.styles__Text",
    componentId: "sc-443293a7-1"
})(ViewPaymentMethods_styles_templateObject1(), themes/* theme.typography.fontWeight.500 */.rS.typography.fontWeight[500], themes/* theme.colors.neutral.670 */.rS.colors.neutral[670]);

;// CONCATENATED MODULE: ./src/screens/Product/components/ViewPaymentMethods/NewViewMore.component.tsx





var ViewPaymentMethods = function(param) {
    var maxNumberInstallments = param.maxNumberInstallments, discountPercentage = param.discountPercentage, salePrice = param.salePrice, spotPrice = param.spotPrice, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var ref = useViewPaymentMethods({
        discountPercentage: discountPercentage,
        maxNumberInstallments: maxNumberInstallments,
        salePrice: salePrice,
        spotPrice: spotPrice
    }), paymentMethodsData = ref.paymentMethodsData, isViewMoreModalOpen = ref.isViewMoreModalOpen, setIsViewMorePaymentMethodsOpen = ref.setIsViewMorePaymentMethodsOpen;
    var viewMoreTextCallback = (0,react.useCallback)(function() {
        if (isMobile) {
            setTimeout(function() {
                window.scrollTo(0, 0);
            }, 100);
        }
        setIsViewMorePaymentMethodsOpen(true);
    }, [
        isMobile,
        setIsViewMorePaymentMethodsOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewPaymentMethods_styles_Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                    onClick: viewMoreTextCallback,
                    children: "ver op\xe7\xf5es de pagamento"
                })
            }),
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethods_PaymentMethods, {
                data: paymentMethodsData,
                isOpen: isViewMoreModalOpen,
                onCloseModal: function() {
                    return setIsViewMorePaymentMethodsOpen(false);
                }
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/screens/Product/components/ViewPaymentMethods/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    opacity: 0;\n    top: 26px;\n  }\n  to {\n    opacity: 1;\n    top: 30px;\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: fit-content;\n  display: flex;\n  position: relative;\n  z-index: 2;\n\n  @media ",
        " {\n    margin-bottom: 2rem;\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-size: 1.2rem;\n  font-weight: ",
        ";\n  cursor: pointer;\n  user-select: none;\n  text-decoration: underline;\n  color: ",
        ";\n  font-size: 1.125rem;\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  display: ",
        ";\n  box-shadow: 0 4px 12px 0 rgb(35 35 35 / 20%);\n  padding: 0.8rem 0.7rem;\n  font-weight: ",
        ";\n  border-radius: 8px !important;\n  width: max-content;\n\n  position: absolute;\n  z-index: 7;\n\n  top: 30px;\n  left: -90%;\n  animation: ",
        " 0.2s ease-in;\n\n  @media ",
        " {\n    left: -20%;\n  }\n\n  @media ",
        " {\n    left: -10%;\n  }\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  height: 0.9rem;\n  width: 0.9rem;\n  position: absolute;\n  top: -6px;\n  left: 45%;\n  border-top: 0.05rem solid rgb(35 35 35 / 20%);\n  border-right: 0.05rem solid rgb(35 35 35 / 20%);\n  transform: rotate(-45deg);\n\n  @media ",
        " {\n    left: 22.5%;\n  }\n\n  @media ",
        " {\n    left: 20%;\n  }\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 0.2rem;\n  font-size: 1rem;\n  padding-bottom: 0.2rem;\n  font-weight: ",
        ";\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var showMoreSoftly = (0,styled_components_browser_esm/* keyframes */.F4)(styles_templateObject());
var styles_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Container",
    componentId: "sc-87cd800b-0"
})(styles_templateObject1(), themes/* theme.device.desktopFirst.mobileL */.rS.device.desktopFirst.mobileL);
var ViewMore = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ViewMore",
    componentId: "sc-87cd800b-1"
})(styles_templateObject2(), themes/* theme.typography.fontWeight.500 */.rS.typography.fontWeight[500], themes/* theme.colors.neutral.670 */.rS.colors.neutral[670]);
var Modal = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Modal",
    componentId: "sc-87cd800b-2"
})(styles_templateObject3(), themes/* theme.colors.neutral.white */.rS.colors.neutral.white, function(param) {
    var isVisibled = param.isVisibled;
    return isVisibled ? "block" : "none";
}, themes/* theme.typography.fontWeight.200 */.rS.typography.fontWeight[200], showMoreSoftly, themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet, themes/* theme.device.desktopFirst.tabletS */.rS.device.desktopFirst.tabletS);
var ModalArrow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ModalArrow",
    componentId: "sc-87cd800b-3"
})(styles_templateObject4(), themes/* theme.colors.neutral.white */.rS.colors.neutral.white, themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet, themes/* theme.device.desktopFirst.tabletS */.rS.device.desktopFirst.tabletS);
var ParcelPrice = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "styles__ParcelPrice",
    componentId: "sc-87cd800b-4"
})(styles_templateObject5(), themes/* theme.typography.fontWeight.500 */.rS.typography.fontWeight[500]);

;// CONCATENATED MODULE: ./src/screens/Product/components/ViewPaymentMethods/OldViewMore.component.tsx





var OldViewMore_component_ViewMore = function(param) {
    var maxNumberInstallments = param.maxNumberInstallments, discountPercentage = param.discountPercentage, salePrice = param.salePrice;
    var ref = (0,react.useState)(false), isModalOpen = ref[0], setIsModalOpen = ref[1];
    var ModalViewMoreComponentsRef = (0,react.useRef)(null);
    (0,application/* useClickOutside */.O8h)({
        ref: ModalViewMoreComponentsRef,
        callback: function() {
            if (isModalOpen) {
                setIsModalOpen(false);
            }
        }
    });
    var installmentsList = useViewPaymentMethods({
        discountPercentage: discountPercentage,
        maxNumberInstallments: maxNumberInstallments,
        salePrice: salePrice
    }).installmentsList;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Container, {
        ref: ModalViewMoreComponentsRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewMore, {
                onClick: function() {
                    return setIsModalOpen(!isModalOpen);
                },
                children: "ver mais"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
                isVisibled: isModalOpen,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalArrow, {}),
                    installmentsList === null || installmentsList === void 0 ? void 0 : installmentsList.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ParcelPrice, {
                            children: item
                        }, item);
                    })
                ]
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/screens/Product/components/ViewPaymentMethods/index.tsx




var ViewPaymentMethods_ViewPaymentMethods = function(param) {
    var discountPercentage = param.discountPercentage, isMobile = param.isMobile, maxNumberInstallments = param.maxNumberInstallments, salePrice = param.salePrice, spotPrice = param.spotPrice;
    var allConfigs = (0,application/* useEnvs */.HSW)().allConfigs;
    var showNewComponent = (allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isOldViewMoreComponentAvailable) === "false";
    return showNewComponent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewPaymentMethods, {
        discountPercentage: discountPercentage,
        isMobile: isMobile,
        maxNumberInstallments: maxNumberInstallments,
        salePrice: salePrice,
        spotPrice: spotPrice
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(OldViewMore_component_ViewMore, {
        discountPercentage: discountPercentage,
        isMobile: isMobile,
        maxNumberInstallments: maxNumberInstallments,
        salePrice: salePrice,
        spotPrice: spotPrice
    });
};


;// CONCATENATED MODULE: ./src/screens/Product/components/BoxPriceProduct/styles.ts

function BoxPriceProduct_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    BoxPriceProduct_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BoxPriceProduct_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          width: 100%;\n          text-align: end;\n        "
    ]);
    BoxPriceProduct_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BoxPriceProduct_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          display: flex;\n          flex-direction: ",
        ";\n          align-items: center;\n        "
    ]);
    BoxPriceProduct_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BoxPriceProduct_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    BoxPriceProduct_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function BoxPriceProduct_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 4rem;\n"
    ]);
    BoxPriceProduct_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function BoxPriceProduct_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  font-weight: 500;\n  margin-bottom: 0.5rem;\n  max-width: ",
        ";\n"
    ]);
    BoxPriceProduct_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var BoxPriceProductContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__BoxPriceProductContainer",
    componentId: "sc-6e6c9f4d-0"
})(BoxPriceProduct_styles_templateObject(), function(param) {
    var removeGap = param.removeGap;
    return removeGap ? "0" : "0.5rem";
});
var View = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__View",
    componentId: "sc-6e6c9f4d-1"
})(BoxPriceProduct_styles_templateObject3(), function(param) {
    var notShouldShowOldPrice = param.notShouldShowOldPrice, flexDirection = param.flexDirection;
    return notShouldShowOldPrice ? (0,styled_components_browser_esm/* css */.iv)(BoxPriceProduct_styles_templateObject1()) : (0,styled_components_browser_esm/* css */.iv)(BoxPriceProduct_styles_templateObject2(), flexDirection !== null && flexDirection !== void 0 ? flexDirection : "row");
});
var Margin4 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Margin4",
    componentId: "sc-6e6c9f4d-2"
})(BoxPriceProduct_styles_templateObject4());
var DescriptionParcels = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "styles__DescriptionParcels",
    componentId: "sc-6e6c9f4d-3"
})(BoxPriceProduct_styles_templateObject5(), function(param) {
    var fontSizeDescriptionParcels = param.fontSizeDescriptionParcels;
    return fontSizeDescriptionParcels !== null && fontSizeDescriptionParcels !== void 0 ? fontSizeDescriptionParcels : "1.4rem";
}, function(param) {
    var fontColor = param.fontColor;
    return fontColor || themes/* theme.colors.neutral.999 */.rS.colors.neutral[999];
}, function(param) {
    var maxWidth = param.maxWidth;
    return maxWidth !== null && maxWidth !== void 0 ? maxWidth : "100%";
});

;// CONCATENATED MODULE: ./src/screens/Product/components/BoxPriceProduct/index.tsx









var BoxPriceProduct = function(param) {
    var packageCurrentState = param.packageCurrentState, measuredUnity = param.measuredUnity, _modalViewMore = param.modalViewMore, modalViewMore = _modalViewMore === void 0 ? true : _modalViewMore, fontSizeDiscount = param.fontSizeDiscount, fontSizeDescriptionParcels = param.fontSizeDescriptionParcels, fontSizePrice = param.fontSizePrice, marginBottomPrice = param.marginBottomPrice, maxWidth = param.maxWidth, _installmentsIsVisibled = param.installmentsIsVisibled, installmentsIsVisibled = _installmentsIsVisibled === void 0 ? true : _installmentsIsVisibled, fontSizeDetailsValue = param.fontSizeDetailsValue, notShouldShowOldPrice = param.notShouldShowOldPrice, _notShouldShowOldPriceAndDiscount = param.notShouldShowOldPriceAndDiscount, notShouldShowOldPriceAndDiscount = _notShouldShowOldPriceAndDiscount === void 0 ? false : _notShouldShowOldPriceAndDiscount, notShouldShowTagOff = param.notShouldShowTagOff, shouldShowTextSpotPriceOnHeaderFixedMobile = param.shouldShowTextSpotPriceOnHeaderFixedMobile, isBlackFriday = param.isBlackFriday, descriptionParcelsFontColor = param.descriptionParcelsFontColor;
    var priceProduct = (0,application/* valueProduct */.zrv)(packageCurrentState);
    var renderDetailsValue = (0,react.useCallback)(function() {
        if ((packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.spotPrice) && (packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.spotPrice) <= (packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.salePrice)) {
            return shouldShowTextSpotPriceOnHeaderFixedMobile ? "\xe0 vista" : "\xe0 vista no pix ou no cart\xe3o";
        }
        if (measuredUnity) {
            return (0,application/* getMeasuredUnit */.pYZ)(measuredUnity);
        }
        return "";
    }, [
        measuredUnity,
        packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.salePrice,
        packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.spotPrice,
        shouldShowTextSpotPriceOnHeaderFixedMobile, 
    ]);
    if (!priceProduct) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Skeleton */.Od, {
            count: 1,
            width: 170
        });
    }
    var returnOldPriceAndDiscount = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                (packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.priceList) !== (packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.salePrice) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.OldPrice, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-price-product-old-price")), {
                    notShouldShowOldPrice: notShouldShowOldPrice,
                    fontSizeDiscount: fontSizeDiscount,
                    children: (0,application/* formatCurrency */.xGv)((packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.priceList) || 0)
                })),
                !notShouldShowTagOff && (packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.discountPercentage) !== "0" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.DiscountTagContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-price-product-discount-tag-container")), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.DiscountTagDot, (0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-price-product-discount-tag-dot"))),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.DiscountTagText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-price-product-discount-tag")), {
                            fontSizeDiscount: fontSizeDiscount,
                            children: [
                                packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.discountPercentage,
                                "% OFF"
                            ]
                        }))
                    ]
                }))
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxPriceProductContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        removeGap: shouldShowTextSpotPriceOnHeaderFixedMobile
    }, (0,application/* buildTestIds */.Fek)("box-price-product-container")), {
        children: [
            notShouldShowOldPriceAndDiscount ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(View, {
                notShouldShowOldPrice: notShouldShowOldPrice,
                children: returnOldPriceAndDiscount()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.PriceValue, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                isBlackTheme: !!isBlackFriday
            }, (0,application/* buildTestIds */.Fek)("box-price-product-price-value")), {
                isFlexDirectionColumn: !!(packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.spotPrice),
                fontSize: fontSizePrice,
                children: [
                    (0,application/* formatCurrency */.xGv)(priceProduct || 0),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.PriceValueDetail, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-price-product-price-value-detail")), {
                        isBlackTheme: isBlackFriday,
                        fontSize: fontSizeDetailsValue,
                        children: renderDetailsValue()
                    }))
                ]
            })),
            installmentsIsVisibled && (packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.maxNumberInstallments) && (packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.maxNumberInstallments) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionParcels, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        fontColor: descriptionParcelsFontColor,
                        isBlackTheme: isBlackFriday
                    }, (0,application/* buildTestIds */.Fek)("box-price-product-description-parcels")), {
                        maxWidth: maxWidth,
                        fontSizeDescriptionParcels: fontSizeDescriptionParcels,
                        children: (0,application/* descriptionParcelsText */.mVl)({
                            maxNumberInstallments: packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.maxNumberInstallments,
                            salePrice: packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.salePrice,
                            spotPrice: packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.spotPrice
                        })
                    })),
                    modalViewMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewPaymentMethods_ViewPaymentMethods, (0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-price-product-view-more-components"), packageCurrentState))
                ]
            }) || marginBottomPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Margin4, (0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-price-product-margin-bottom-price")))
        ]
    }));
};
/* harmony default export */ var components_BoxPriceProduct = (BoxPriceProduct);

;// CONCATENATED MODULE: ./src/screens/Product/components/BreadcrumbProduct/styles.ts

function BreadcrumbProduct_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    BreadcrumbProduct_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BreadcrumbProduct_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n\n  @media ",
        " {\n    a {\n      padding-bottom: 0.25rem;\n    }\n  }\n"
    ]);
    BreadcrumbProduct_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BreadcrumbProduct_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    BreadcrumbProduct_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BreadcrumbProduct_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    BreadcrumbProduct_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function BreadcrumbProduct_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.15rem;\n  color: ",
        ";\n  text-align: center;\n  font-weight: 400;\n"
    ]);
    BreadcrumbProduct_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function BreadcrumbProduct_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    BreadcrumbProduct_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var BreadcrumbsContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__BreadcrumbsContainer",
    componentId: "sc-8d836b9b-0"
})(BreadcrumbProduct_styles_templateObject(), ui.theme.space.x1);
var BreadcrumbsContentMobile = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__BreadcrumbsContentMobile",
    componentId: "sc-8d836b9b-1"
})(BreadcrumbProduct_styles_templateObject1(), ui.theme.device.desktopFirst.mobileXL);
var DescriptionItemWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__DescriptionItemWrapper",
    componentId: "sc-8d836b9b-2"
})(BreadcrumbProduct_styles_templateObject2());
var DescriptionItemWrapperLink = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__DescriptionItemWrapperLink",
    componentId: "sc-8d836b9b-3"
})(BreadcrumbProduct_styles_templateObject3());
var DescriptionItem = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__DescriptionItem",
    componentId: "sc-8d836b9b-4"
})(BreadcrumbProduct_styles_templateObject4(), ui.theme.colors.neutral[400]);
var SeparatorIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__SeparatorIcon",
    componentId: "sc-8d836b9b-5"
})(BreadcrumbProduct_styles_templateObject5());

;// CONCATENATED MODULE: ./src/screens/Product/components/BreadcrumbProduct/index.tsx






var BreadcrumbProduct = function(breadcrumbProductProps) {
    var ref;
    var isClientMobile = (0,application/* useAppContext */.bp4)().isClientMobile;
    if (!(breadcrumbProductProps === null || breadcrumbProductProps === void 0 ? void 0 : breadcrumbProductProps.items)) {
        return null;
    }
    var _items = breadcrumbProductProps.items, common = _items.common, mobile = _items.mobile;
    var ref1 = {
        commonIncludesUrl: common.filter(function(item) {
            var ref;
            return !(item === null || item === void 0 ? void 0 : (ref = item.url) === null || ref === void 0 ? void 0 : ref.includes("null"));
        }),
        mobileIncludesUrl: !(mobile === null || mobile === void 0 ? void 0 : (ref = mobile.url) === null || ref === void 0 ? void 0 : ref.includes("null"))
    }, commonIncludesUrl = ref1.commonIncludesUrl, mobileIncludesUrl = ref1.mobileIncludesUrl;
    var _target, _target1;
    return commonIncludesUrl.length > 1 || mobileIncludesUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbsContainer, {
        children: isClientMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(BreadcrumbsContentMobile, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SeparatorIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowLeft, {
                        color: ui.theme.colors.neutral[300],
                        width: 20,
                        height: 20
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                    href: (mobile === null || mobile === void 0 ? void 0 : mobile.url) || "",
                    target: (_target = mobile.target) !== null && _target !== void 0 ? _target : "_self",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionItem, {
                        children: mobile.description
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                    href: "/",
                    target: "_self",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Home, {
                        color: ui.theme.colors.neutral[385],
                        width: 17,
                        height: 17
                    })
                }),
                commonIncludesUrl === null || commonIncludesUrl === void 0 ? void 0 : commonIncludesUrl.map(function(item) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeparatorIcon, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowRight, {
                                    color: ui.theme.colors.neutral[300],
                                    width: 20,
                                    height: 20
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionItemWrapper, {
                                as: (item === null || item === void 0 ? void 0 : item.url) ? components/* Link */.rU : DescriptionItemWrapperLink,
                                href: item.url,
                                target: (_target1 = item.target) !== null && _target1 !== void 0 ? _target1 : "_self",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionItem, {
                                    children: item.description
                                })
                            })
                        ]
                    }, item === null || item === void 0 ? void 0 : item.url);
                })
            ]
        })
    }) : null;
};
/* harmony default export */ var components_BreadcrumbProduct = (BreadcrumbProduct);

;// CONCATENATED MODULE: ./src/screens/Product/components/ButtonAddProductToWeddingList/styles.ts

function ButtonAddProductToWeddingList_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: ",
        ";\n  font-size: 1.2rem;\n  @media ",
        " {\n    display: ",
        ";\n  }\n"
    ]);
    ButtonAddProductToWeddingList_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ButtonAddProductToWeddingList_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border-color: ",
        " !important;\n      ",
        " {\n        color: ",
        " !important;\n      }\n\n      &:hover {\n        background-color: ",
        ";\n      }\n    "
    ]);
    ButtonAddProductToWeddingList_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ButtonAddProductToWeddingList_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 0.5rem;\n  justify-content: center;\n  align-items: center;\n  padding: 1rem;\n  cursor: pointer;\n  font-size: ",
        ";\n\n  border: ",
        ";\n  border-color: ",
        ";\n  border-radius: 4px;\n\n  background: none;\n  transition: background-color 300ms;\n\n  :hover {\n    background-color: ",
        ";\n  }\n\n  @media ",
        " {\n    transform: scale(",
        ");\n    padding: 1.2rem 3rem;\n  }\n\n  @media ",
        " {\n    padding: 1rem;\n  }\n\n  @media ",
        " {\n    border-radius: 4px;\n    padding: 1rem 1.8rem;\n  }\n\n  ",
        "\n"
    ]);
    ButtonAddProductToWeddingList_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var DescriptionButton = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__DescriptionButton",
    componentId: "sc-b09d7584-0"
})(ButtonAddProductToWeddingList_styles_templateObject(), themes/* theme.colors.primary.200 */.rS.colors.primary[200], themes/* theme.typography.fontWeight.bold */.rS.typography.fontWeight.bold, themes/* theme.device.desktopFirst.mobileXL */.rS.device.desktopFirst.mobileXL, function(param) {
    var textVisibleMobile = param.textVisibleMobile;
    return textVisibleMobile ? "none" : "inline";
});
var ContainerButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__ContainerButton",
    componentId: "sc-b09d7584-1"
})(ButtonAddProductToWeddingList_styles_templateObject2(), function(param) {
    var fontSize = param.fontSize;
    return fontSize !== null && fontSize !== void 0 ? fontSize : "1.5rem";
}, function(param) {
    var borderLine = param.borderLine;
    return borderLine ? "1px solid" : "none";
}, themes/* theme.colors.primary.200 */.rS.colors.primary[200], themes/* theme.colors.primary.10 */.rS.colors.primary[10], themes/* theme.device.desktopFirst.laptop */.rS.device.desktopFirst.laptop, function(param) {
    var scaleMedia = param.scaleMedia;
    return scaleMedia !== null && scaleMedia !== void 0 ? scaleMedia : 1;
}, themes/* theme.device.desktopFirst.tabletS */.rS.device.desktopFirst.tabletS, themes/* theme.device.desktopFirst.mobileXL */.rS.device.desktopFirst.mobileXL, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme && (0,styled_components_browser_esm/* css */.iv)(ButtonAddProductToWeddingList_styles_templateObject1(), themes/* theme.colors.blackFriday.white */.rS.colors.blackFriday.white, DescriptionButton, themes/* theme.colors.blackFriday.white */.rS.colors.blackFriday.white, themes/* theme.colors.primary.200 */.rS.colors.primary[200]);
});

;// CONCATENATED MODULE: ./src/screens/Product/components/ButtonAddProductToWeddingList/index.tsx



var ButtonAddProductToWeddingList = function(param) {
    var borderLine = param.borderLine, textVisibleMobile = param.textVisibleMobile, fontSize = param.fontSize, scaleMedia = param.scaleMedia, isBlackTheme = param.isBlackTheme, actionAddToGift = param.actionAddToGift;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerButton, {
        isBlackTheme: isBlackTheme,
        borderLine: borderLine,
        fontSize: fontSize,
        scaleMedia: scaleMedia,
        onClick: actionAddToGift,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Gift, {
                color: isBlackTheme ? ui.theme.colors.blackFriday.white : ui.theme.colors.primary[200],
                height: 26
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionButton, {
                textVisibleMobile: textVisibleMobile,
                children: "Adicionar \xe0 minha lista"
            })
        ]
    });
};
/* harmony default export */ var components_ButtonAddProductToWeddingList = (ButtonAddProductToWeddingList);

// EXTERNAL MODULE: ./src/screens/Product/components/ButtonCart/index.tsx
var ButtonCart = __webpack_require__(20140);
;// CONCATENATED MODULE: ./src/screens/Product/components/ModalVoltage/styles.ts

function ModalVoltage_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  width: 100vw;\n  top: 0;\n  right: 0;\n\n  z-index: 999999;\n  position: fixed;\n\n  background-color: ",
        ";\n"
    ]);
    ModalVoltage_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalVoltage_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: 0.15rem;\n  position: relative;\n\n  padding: 2rem;\n  padding-right: 4rem;\n  padding-left: 4rem;\n"
    ]);
    ModalVoltage_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalVoltage_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 1rem;\n"
    ]);
    ModalVoltage_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModalVoltage_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0.6rem;\n  right: 0.6rem;\n  cursor: ",
        ";\n"
    ]);
    ModalVoltage_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ModalVoltage_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0.2rem 2rem;\n  background-color: ",
        ";\n  border: none;\n  border-radius: 0.3rem;\n  color: ",
        ";\n  font-weight: 600;\n  font-size: 1.2rem;\n  cursor: pointer;\n  transition: filter 0.2s ease-in-out;\n\n  &:hover {\n    filter: brightness(0.9);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: initial;\n  }\n"
    ]);
    ModalVoltage_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ModalVoltage_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 1rem;\n  border: none;\n  background: none;\n  color: ",
        ";\n  font-size: 1.2rem;\n  text-decoration: underline;\n  border-radius: 0.3rem;\n  cursor: pointer;\n\n  &:hover {\n    background-color: ",
        ";\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: initial;\n  }\n"
    ]);
    ModalVoltage_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  padding: 1rem 1.5rem;\n  margin-bottom: 0.5rem;\n  text-align: center;\n  h3 {\n    font-size: 1.4rem;\n    font-weight: 500;\n\n    span {\n      color: ",
        ";\n      font-weight: 600;\n      font-size: 1.45rem;\n    }\n  }\n\n  span {\n    font-size: 1.26rem;\n    padding-top: 1rem;\n  }\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 1.6rem;\n  padding: 1.8rem 1.6rem;\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var ContainerModal = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ContainerModal",
    componentId: "sc-78d4639c-0"
})(ModalVoltage_styles_templateObject(), function(param) {
    var stateModal = param.stateModal;
    return stateModal ? "flex" : "none";
}, themes/* theme.colors.neutral.820 */.rS.colors.neutral[820]);
var BoxModal = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxModal",
    componentId: "sc-78d4639c-1"
})(ModalVoltage_styles_templateObject1(), themes/* theme.colors.neutral.white */.rS.colors.neutral.white);
var BoxActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxActions",
    componentId: "sc-78d4639c-2"
})(ModalVoltage_styles_templateObject2());
var ButtonClose = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ButtonClose",
    componentId: "sc-78d4639c-3"
})(ModalVoltage_styles_templateObject3(), function(param) {
    var isSendingItemToCart = param.isSendingItemToCart;
    return isSendingItemToCart ? "initial" : "pointer";
});
var ButtonSuccess = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__ButtonSuccess",
    componentId: "sc-78d4639c-4"
})(ModalVoltage_styles_templateObject4(), themes/* theme.colors.secondary.265 */.rS.colors.secondary[265], themes/* theme.colors.neutral.white */.rS.colors.neutral.white);
var ButtonCancel = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__ButtonCancel",
    componentId: "sc-78d4639c-5"
})(ModalVoltage_styles_templateObject5(), themes/* theme.colors.neutral.900 */.rS.colors.neutral[900], themes/* theme.colors.neutral.80 */.rS.colors.neutral[80]);
var Description = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Description",
    componentId: "sc-78d4639c-6"
})(styles_templateObject6(), themes/* theme.colors.neutral.520 */.rS.colors.neutral[520], themes/* theme.colors.primary.50 */.rS.colors.primary[50]);
var TextCe = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TextCe",
    componentId: "sc-78d4639c-7"
})(styles_templateObject7(), themes/* theme.colors.neutral.520 */.rS.colors.neutral[520]);

;// CONCATENATED MODULE: ./src/screens/Product/components/ModalVoltage/index.tsx






var ModalVoltage = function(param) {
    var actionCloseModal = param.actionCloseModal, actionSuccess = param.actionSuccess, _stateModal = param.stateModal, stateModal = _stateModal === void 0 ? false : _stateModal, infoText = param.infoText, sendingItemToCart = param.sendingItemToCart;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerModal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-voltage")), {
        stateModal: stateModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxModal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-voltage-box")), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonClose, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-voltage-button-close")), {
                    isSendingItemToCart: sendingItemToCart,
                    onClick: function() {
                        if (!sendingItemToCart) {
                            actionCloseModal();
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CloseIcon, {
                        alt: "Fechar modal de voltagem",
                        width: 32,
                        height: 32,
                        strokeWidth: "0.8",
                        color: ui.theme.colors.primary[100]
                    })
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Description, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-voltage-description")), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-voltage-description-title")), {
                            children: [
                                "Voltagem escolhida:",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("info-text")), {
                                    children: infoText
                                }))
                            ]
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-voltage-description-text")), {
                            children: "Tudo certo?"
                        }))
                    ]
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxActions, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-voltage-box-actions")), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCancel, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-voltage-button-cancel")), {
                            onClick: actionCloseModal,
                            disabled: sendingItemToCart,
                            children: "Voltar para o produto"
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSuccess, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-voltage-button-success")), {
                            onClick: actionSuccess,
                            disabled: sendingItemToCart,
                            children: "Sim, continuar"
                        }))
                    ]
                }))
            ]
        }))
    }));
};
/* harmony default export */ var components_ModalVoltage = (ModalVoltage);

;// CONCATENATED MODULE: ./src/screens/Product/components/index.ts









// EXTERNAL MODULE: ../../packages/components/ButtonSubmit/style.ts
var style = __webpack_require__(46644);
;// CONCATENATED MODULE: ./src/screens/Product/Product.styles.ts

function Product_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    Product_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Product_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  overflow: hidden;\n\n  @media ",
        " {\n    padding: 0 1.34rem;\n  }\n"
    ]);
    Product_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Product_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 0.625rem;\n  display: flex;\n  justify-content: center;\n  margin-bottom: 3rem;\n  position: fixed;\n  bottom: ",
        ";\n  right: 0;\n  z-index: 9999999;\n\n  ",
        " {\n    flex-direction: row-reverse;\n    background-color: ",
        ";\n\n    opacity: 1;\n\n    border-radius: 12.5rem;\n\n    ",
        " {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    Product_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Product_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  padding: ",
        ";\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    Product_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Product_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 2rem;\n  font-weight: bold;\n  letter-spacing: -1px;\n  margin-bottom: 1.3rem;\n  color: ",
        ";\n"
    ]);
    Product_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Product_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: uppercase;\n  font-size: 1.1rem;\n  font-weight: bold;\n  color: ",
        ";\n"
    ]);
    Product_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Product_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 20% 80%;\n  padding: ",
        ";\n"
    ]);
    Product_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Product_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Product_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Product_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: start;\n  position: relative;\n  z-index: 5;\n\n  label {\n    margin: 0.5rem 0 0.5rem 1rem;\n    color: ",
        ";\n  }\n\n  .react-select {\n    &__control {\n      width: 180px;\n      border-radius: 4px;\n      height: 3.5rem;\n      position: relative;\n      border: thin solid ",
        ";\n      background-color: transparent;\n      appearance: none;\n      font-size: 1.3rem;\n      color: ",
        ";\n      outline: none;\n      cursor: pointer;\n\n      &:hover {\n        border-color: ",
        ";\n      }\n    }\n\n    &__single-value {\n      color: ",
        ";\n    }\n\n    &__indicator-separator {\n      opacity: 0;\n    }\n\n    &__indicator {\n      color: ",
        ";\n    }\n\n    &__option {\n      font-size: 1.3rem;\n    }\n  }\n"
    ]);
    Product_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function Product_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2rem 1rem 8rem 1rem;\n"
    ]);
    Product_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var MainProductContainer = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "Product.styles__MainProductContainer",
    componentId: "sc-22b4bd41-0"
})(Product_styles_templateObject(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday[185]) : "".concat(ui.theme.colors.blackFriday[10]);
});
var ProductContainer = (0,styled_components_browser_esm/* default */.ZP)(ui.Container).withConfig({
    displayName: "Product.styles__ProductContainer",
    componentId: "sc-22b4bd41-1"
})(Product_styles_templateObject1(), ui.theme.device.desktopFirst.tabletS);
var WrapperLoading = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "Product.styles__WrapperLoading",
    componentId: "sc-22b4bd41-2"
})(Product_styles_templateObject2(), function(param) {
    var isClientMobile = param.isClientMobile;
    return isClientMobile ? "15rem" : "4rem";
}, style/* StyledButtonSubmit */.N, ui.theme.colors.neutral.white, style/* ButtonSubmitText */.k, ui.theme.colors.neutral[999]);
var SearchResultHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Product.styles__SearchResultHeader",
    componentId: "sc-22b4bd41-3"
})(Product_styles_templateObject3(), function(param) {
    var padding = param.padding;
    return padding || "0 0";
}, ui.theme.colors.neutral[95]);
var SearchResultTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Product.styles__SearchResultTitle",
    componentId: "sc-22b4bd41-4"
})(Product_styles_templateObject4(), ui.theme.colors.neutral[520]);
var SearchResultCounter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Product.styles__SearchResultCounter",
    componentId: "sc-22b4bd41-5"
})(Product_styles_templateObject5(), ui.theme.colors.neutral[520]);
var SearchResultContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Product.styles__SearchResultContent",
    componentId: "sc-22b4bd41-6"
})(Product_styles_templateObject6(), function(param) {
    var padding = param.padding;
    return padding || "0 0";
});
var BoxSelect = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Product.styles__BoxSelect",
    componentId: "sc-22b4bd41-7"
})(Product_styles_templateObject7());
var SelectSortBy = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Product.styles__SelectSortBy",
    componentId: "sc-22b4bd41-8"
})(Product_styles_templateObject8(), ui.theme.colors.neutral[520], ui.theme.colors.primary[200], ui.theme.colors.primary[200], ui.theme.colors.primary[300], ui.theme.colors.primary[200], ui.theme.colors.primary[200]);
var PaymentMethodsMobileContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "Product.styles__PaymentMethodsMobileContainer",
    componentId: "sc-22b4bd41-9"
})(Product_styles_templateObject9());

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
;// CONCATENATED MODULE: ./src/screens/Product/sections/AboutTheProduct/styles.ts

function AboutTheProduct_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 1.5rem;\n  margin-top: 1.5rem;\n"
    ]);
    AboutTheProduct_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AboutTheProduct_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  background-color: ",
        ";\n  border-radius: 2px;\n  margin-bottom: 3rem;\n  border: thin solid ",
        ";\n  border-radius: 8px;\n"
    ]);
    AboutTheProduct_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AboutTheProduct_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 500;\n\n  color: ",
        ";\n\n  @media ",
        " {\n    font-size: 1.5rem;\n  }\n"
    ]);
    AboutTheProduct_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AboutTheProduct_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n\n  background-color: ",
        ";\n\n  font-size: 1.4rem;\n  padding: 1.8rem 1.6rem;\n  font-weight: normal;\n  white-space: pre-wrap;\n"
    ]);
    AboutTheProduct_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var AboutTheProduct_styles_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Container",
    componentId: "sc-e897ddf7-0"
})(AboutTheProduct_styles_templateObject());
var Box = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__Box",
    componentId: "sc-e897ddf7-1"
})(AboutTheProduct_styles_templateObject1(), themes/* theme.colors.neutral.white */.rS.colors.neutral.white, themes/* theme.colors.neutral.95 */.rS.colors.neutral[95]);
var styles_Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "styles__Title",
    componentId: "sc-e897ddf7-2"
})(AboutTheProduct_styles_templateObject2(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(themes/* theme.colors.neutral.white */.rS.colors.neutral.white) : "".concat(themes/* theme.colors.blackFriday.115 */.rS.colors.blackFriday[115]);
}, themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet);
var styles_Description = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Description",
    componentId: "sc-e897ddf7-3"
})(AboutTheProduct_styles_templateObject3(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(themes/* theme.colors.blackFriday.white */.rS.colors.blackFriday.white) : "".concat(themes/* theme.colors.blackFriday.115 */.rS.colors.blackFriday[115]);
}, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(themes/* theme.colors.blackFriday.175 */.rS.colors.blackFriday[175]) : "";
});

;// CONCATENATED MODULE: ./src/screens/Product/sections/AboutTheProduct/index.tsx






var AboutTheProduct = function(param) {
    var productDetails = param.productDetails, idSection = param.idSection, isBlackTheme = param.isBlackTheme;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Collapsed */.Hr, {
        id: idSection,
        isBlackTheme: isBlackTheme,
        titleComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Title, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("about-the-product-title")), {
            isBlackTheme: isBlackTheme,
            children: "Sobre o produto"
        })),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Description, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            isBlackTheme: isBlackTheme
        }, (0,application/* buildTestIds */.Fek)("about-the-product-description")), {
            dangerouslySetInnerHTML: {
                __html: productDetails
            }
        }))
    });
};
/* harmony default export */ var sections_AboutTheProduct = (AboutTheProduct);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../packages/components/Playlist/index.tsx + 1 modules
var Playlist = __webpack_require__(57073);
;// CONCATENATED MODULE: ./src/screens/Product/sections/AlsoSee/styles.ts

function AlsoSee_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    AlsoSee_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AlsoSee_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    AlsoSee_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AlsoSee_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    AlsoSee_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AlsoSee_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    AlsoSee_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function AlsoSee_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 2rem;\n  color: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    AlsoSee_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function AlsoSee_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin: 1.115rem 0 2.08rem;\n\n  gap: 0.5rem;\n  ",
        "\n"
    ]);
    AlsoSee_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function AlsoSee_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  border-radius: 2px;\n  border: thin solid\n    ",
        ";\n"
    ]);
    AlsoSee_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function AlsoSee_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.1rem;\n  color: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    AlsoSee_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 279px;\n  background-color: ",
        ";\n  border-radius: 2px;\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          background-color: ",
        ";\n\n          ",
        " {\n            color: ",
        ";\n          }\n        "
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          background-color: ",
        ";\n\n          ",
        " {\n            color: ",
        ";\n          }\n        "
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 3.825rem;\n  padding: 0 1rem;\n  cursor: pointer;\n\n  background-color: ",
        ";\n\n  ",
        "\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: -webkit-box;\n  -webkit-box-orient: horizontal;\n  overflow-x: scroll;\n  gap: 8px;\n  height: fit-content;\n  justify-content: start;\n"
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n\n  font-size: 1.08rem;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n\n  display: -moz-box;\n  -moz-box-orient: vertical;\n\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          background-color: ",
        ";\n        "
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          background-color: ",
        ";\n        "
    ]);
    styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin: 0.6rem 0;\n  height: 42px;\n  text-align: center;\n  padding: 0.5rem 0.83rem;\n  white-space: normal;\n  max-width: 205px;\n  border-radius: 10px;\n  background-color: ",
        ";\n\n  ",
        "\n"
    ]);
    styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 0;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n\n  @media ",
        " {\n    font-size: 1.5rem;\n    padding-left: ",
        ";\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  box-shadow: 0px 3px 6px ",
        ";\n  padding: ",
        ";\n  background-color: ",
        ";\n  border: thin solid\n    ",
        ";\n  border-radius: 2px;\n  -webkit-tap-highlight-color: transparent !important;\n\n  &:hover {\n    background-color: initial;\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: ",
        ";\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}


var ArrowUpIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.ArrowUp).withConfig({
    displayName: "styles__ArrowUpIcon",
    componentId: "sc-f16b09b5-0"
})(AlsoSee_styles_templateObject());
var ArrowDownIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.ArrowDown).withConfig({
    displayName: "styles__ArrowDownIcon",
    componentId: "sc-f16b09b5-1"
})(AlsoSee_styles_templateObject1());
var ArrowRightIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.ArrowRight).attrs({
    width: 20,
    height: 20
}).withConfig({
    displayName: "styles__ArrowRightIcon",
    componentId: "sc-f16b09b5-2"
})(AlsoSee_styles_templateObject2());
var AlsoSeeContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__AlsoSeeContainer",
    componentId: "sc-f16b09b5-3"
})(AlsoSee_styles_templateObject3());
var AlsoSee_styles_Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "styles__Title",
    componentId: "sc-f16b09b5-4"
})(AlsoSee_styles_templateObject4(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday.white) : "".concat(ui.theme.colors.blackFriday[115]);
}, ui.theme.typography.fontWeight[500]);
var AlsoSeeContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__AlsoSeeContent",
    componentId: "sc-f16b09b5-5"
})(AlsoSee_styles_templateObject5(), function(param) {
    var collapse = param.collapse;
    return collapse ? "\n        display: none;\n      " : "\n        display: flex;\n\n        @media ".concat(ui.theme.device.desktopFirst.tablet, " {\n          flex-direction: column;\n        }\n        ");
});
var ProductsSideMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ProductsSideMenu",
    componentId: "sc-f16b09b5-6"
})(AlsoSee_styles_templateObject6(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday[100]) : "".concat(ui.theme.colors.blackFriday[30]);
});
var TitleItem = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__TitleItem",
    componentId: "sc-f16b09b5-7"
})(AlsoSee_styles_templateObject7(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday.white) : "".concat(ui.theme.colors.blackFriday[115]);
}, ui.theme.typography.fontWeight[500]);
var ProductSideMenuItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ProductSideMenuItem",
    componentId: "sc-f16b09b5-8"
})(styles_templateObject8(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday[175]) : "".concat(ui.theme.colors.blackFriday.white);
});
var SideMenuItems = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SideMenuItems",
    componentId: "sc-f16b09b5-9"
})(styles_templateObject11(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday[175]) : "".concat(ui.theme.colors.neutral.white);
}, function(param) {
    var isSelected = param.isSelected, isBlackTheme = param.isBlackTheme;
    return isBlackTheme && isSelected ? (0,styled_components_browser_esm/* css */.iv)(styles_templateObject9(), ui.theme.colors.blackFriday[100], TitleItem, ui.theme.colors.blackFriday.white) : isSelected && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject10(), ui.theme.colors.blackFriday[400], TitleItem, ui.theme.colors.blackFriday[480]);
});
var CategoriesSliderWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CategoriesSliderWrapper",
    componentId: "sc-f16b09b5-10"
})(styles_templateObject12());
var ItemsTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__ItemsTitle",
    componentId: "sc-f16b09b5-11"
})(styles_templateObject13(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday.white) : " ".concat(ui.theme.colors.neutral[530]);
});
var CategoriesItems = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CategoriesItems",
    componentId: "sc-f16b09b5-12"
})(styles_templateObject16(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday[175]) : "".concat(ui.theme.colors.blackFriday.white);
}, function(param) {
    var isSelected = param.isSelected, isBlackTheme = param.isBlackTheme;
    return isBlackTheme && isSelected ? (0,styled_components_browser_esm/* css */.iv)(styles_templateObject14(), ui.theme.colors.blackFriday[420]) : isSelected && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject15(), ui.theme.colors.blackFriday[400]);
});
var AggregatorCustom = (0,styled_components_browser_esm/* default */.ZP)(ui.Aggregator).withConfig({
    displayName: "styles__AggregatorCustom",
    componentId: "sc-f16b09b5-13"
})(_templateObject17());
var TextCustom = (0,styled_components_browser_esm/* default */.ZP)(ui.Text).withConfig({
    displayName: "styles__TextCustom",
    componentId: "sc-f16b09b5-14"
})(_templateObject18(), ui.theme.colors.neutral[520], ui.theme.typography.fontSize.md.x3, ui.theme.typography.fontWeight[500], function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday.white) : "".concat(ui.theme.colors.neutral[520]);
}, ui.theme.device.desktopFirst.tablet, ui.theme.space["x2.5"]);
var ButtonCustom = (0,styled_components_browser_esm/* default */.ZP)(ui.Button).withConfig({
    displayName: "styles__ButtonCustom",
    componentId: "sc-f16b09b5-15"
})(_templateObject19(), ui.theme.colors.neutral["999-opacity-10"], ui.theme.space.x1, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday[175]) : "".concat(ui.theme.colors.blackFriday.white);
}, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday[100]) : "".concat(ui.theme.colors.neutral[95]);
});
var SkeletonContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__SkeletonContainer",
    componentId: "sc-f16b09b5-16"
})(_templateObject20(), ui.theme.space.x2);

;// CONCATENATED MODULE: ./src/screens/Product/sections/AlsoSee/ui.tsx









var AlsoSeeUI = function(param) {
    var idSection = param.idSection, isBlackTheme = param.isBlackTheme, isLoadingRelatedProducts = param.isLoadingRelatedProducts, isLoadingProductCards = param.isLoadingProductCards, productsData = param.productsData, relatedCategoryData = param.relatedCategoryData, isClientTablet = param.isClientTablet, alsoSeeContainerRef = param.alsoSeeContainerRef, isAlsoSeeCollapsed = param.isAlsoSeeCollapsed, totalProductCardsRows = param.totalProductCardsRows, selectedCategoryId = param.selectedCategoryId, isToShowPaginator = param.isToShowPaginator, productIdsListLength = param.productIdsListLength, pageSize = param.pageSize, currentPage = param.currentPage, onToggleShowCollapsible = param.onToggleShowCollapsible, handleOnClickOnCategoryItem = param.handleOnClickOnCategoryItem, onSetCurrentPage = param.onSetCurrentPage, onScrollToAlsoSeeContainer = param.onScrollToAlsoSeeContainer;
    var arrowColor = isBlackTheme ? ui.theme.colors.blackFriday.white : ui.theme.colors.primary[200];
    var indexBased = 1;
    var isLoadingProducts = !relatedCategoryData || isLoadingProductCards;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AlsoSeeContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("also-see-container")), {
        id: idSection,
        ref: alsoSeeContainerRef,
        children: [
            isClientTablet ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AggregatorCustom, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonCustom, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("also-see-button")), {
                    onClick: onToggleShowCollapsible,
                    isBlackTheme: isBlackTheme,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextCustom, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("also-see-button-text")), {
                            isBlackTheme: isBlackTheme,
                            children: "Veja tamb\xe9m"
                        })),
                        isAlsoSeeCollapsed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUpIcon, {
                            color: arrowColor
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDownIcon, {
                            color: arrowColor
                        })
                    ]
                }))
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AlsoSee_styles_Title, {
                isBlackTheme: isBlackTheme,
                children: "Veja tamb\xe9m"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AlsoSeeContent, {
                collapse: isClientTablet && !isAlsoSeeCollapsed,
                children: [
                    isClientTablet ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesSliderWrapper, {
                        children: relatedCategoryData === null || relatedCategoryData === void 0 ? void 0 : relatedCategoryData.map(function(item, index) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(CategoriesItems, {
                                isBlackTheme: isBlackTheme,
                                isSelected: (item === null || item === void 0 ? void 0 : item.category) === (selectedCategoryId || (relatedCategoryData === null || relatedCategoryData === void 0 ? void 0 : (ref = relatedCategoryData[0]) === null || ref === void 0 ? void 0 : ref.category)),
                                onClick: function() {
                                    return handleOnClickOnCategoryItem(item === null || item === void 0 ? void 0 : item.category);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsTitle, {
                                    isBlackTheme: isBlackTheme,
                                    children: item === null || item === void 0 ? void 0 : item.name
                                })
                            }, "".concat(item === null || item === void 0 ? void 0 : item.category, "#").concat(index + 1));
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsSideMenu, {
                        isBlackTheme: isBlackTheme,
                        children: relatedCategoryData === null || relatedCategoryData === void 0 ? void 0 : relatedCategoryData.map(function(item, index) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProductSideMenuItem, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SideMenuItems, {
                                    isBlackTheme: isBlackTheme,
                                    isSelected: (item === null || item === void 0 ? void 0 : item.category) === (selectedCategoryId || (relatedCategoryData === null || relatedCategoryData === void 0 ? void 0 : (ref = relatedCategoryData[0]) === null || ref === void 0 ? void 0 : ref.category)),
                                    onClick: function() {
                                        return handleOnClickOnCategoryItem(item === null || item === void 0 ? void 0 : item.category);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleItem, {
                                            isBlackTheme: isBlackTheme,
                                            children: item === null || item === void 0 ? void 0 : item.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightIcon, {
                                            color: !isBlackTheme && (item === null || item === void 0 ? void 0 : item.category) === selectedCategoryId ? ui.theme.colors.blackFriday.black : arrowColor
                                        })
                                    ]
                                })
                            }, "".concat(item === null || item === void 0 ? void 0 : item.category, "#").concat(index + 1));
                        })
                    }),
                    isLoadingProductCards || isLoadingRelatedProducts ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Skeleton */.Od, {
                            type: "card",
                            hasMargin: false,
                            count: 3,
                            height: 350,
                            width: isClientTablet ? 200 : 250
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.SpaceWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Playlist/* default */.Z, {
                                productCards: (0,_to_consumable_array/* default */.Z)((ref = productsData === null || productsData === void 0 ? void 0 : productsData.map(function(product, index) {
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                                        index: (0,application/* getProductPosition */.E8Y)(index + 1, pageSize, currentPage)
                                    });
                                })) !== null && ref !== void 0 ? ref : [])
                            }),
                            isToShowPaginator && productIdsListLength > pageSize && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paginator */.Ds, {
                                justifyContent: "center",
                                visiblePages: 5,
                                pageSize: pageSize,
                                totalRows: totalProductCardsRows,
                                loading: isLoadingProducts,
                                page: currentPage !== null && currentPage !== void 0 ? currentPage : indexBased,
                                pageChangeHandler: function(newCurrentPage) {
                                    onSetCurrentPage(newCurrentPage);
                                },
                                pageClickHandler: function() {
                                    onScrollToAlsoSeeContainer();
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./src/screens/Product/sections/AlsoSee/index.tsx






var AlsoSee = function(param) {
    var idProduct = param.idProduct, idSection = param.idSection, isBlackTheme = param.isBlackTheme;
    var ref, ref1;
    var ref2 = (0,application/* useAppContext */.bp4)(), isClientTablet = ref2.isClientTablet, isClientMobile = ref2.isClientMobile;
    var ref3 = (0,react.useState)(0), selectedCategoryId = ref3[0], setSelectedCategoryId = ref3[1];
    var ref4 = (0,react.useState)(1), currentPage = ref4[0], setCurrentPage = ref4[1];
    var ref5 = (0,react.useState)(false), isAlsoSeeCollapsed = ref5[0], setIsAlsoSeeCollapsed = ref5[1];
    var pageSize = isClientMobile ? 14 : 15;
    var ref6 = (0,react.useState)(0), totalProductCardsRows = ref6[0], setTotalProductCardsRows = ref6[1];
    var branchId = (0,application/* getClientBranchId */.R0G)(implementations/* cookie */.pR);
    var toggleShowCollapsible = (0,react.useCallback)(function() {
        setIsAlsoSeeCollapsed(function(state) {
            return !state;
        });
    }, []);
    var alsoSeeContainerRef = (0,react.useRef)(null);
    var scrollToAlsoSeeContainer = (0,react.useCallback)(function() {
        if (alsoSeeContainerRef === null || alsoSeeContainerRef === void 0 ? void 0 : alsoSeeContainerRef.current) {
            var yPosition = alsoSeeContainerRef.current.offsetTop - 200;
            window.scrollTo({
                top: yPosition,
                behavior: "smooth"
            });
        }
    }, []);
    var ref7 = implementations/* catalogApi.getRelatedCategory */.dZ.getRelatedCategory(idProduct, branchId), relatedCategoryData = ref7.data, isLoadingRelatedCategory = ref7.isLoading;
    (0,react.useEffect)(function() {
        var ref;
        setSelectedCategoryId(relatedCategoryData === null || relatedCategoryData === void 0 ? void 0 : (ref = relatedCategoryData[0]) === null || ref === void 0 ? void 0 : ref.category);
    }, [
        relatedCategoryData
    ]);
    var ref8 = implementations/* catalogApi.getRelatedProducts */.dZ.getRelatedProducts(idProduct, branchId, String(selectedCategoryId || (relatedCategoryData === null || relatedCategoryData === void 0 ? void 0 : (ref = relatedCategoryData[0]) === null || ref === void 0 ? void 0 : ref.category)), currentPage, pageSize, !!(selectedCategoryId || (relatedCategoryData === null || relatedCategoryData === void 0 ? void 0 : (ref1 = relatedCategoryData[0]) === null || ref1 === void 0 ? void 0 : ref1.category))), relatedProducts = ref8.data, isLoadingRelatedProducts = ref8.isLoading;
    var productIdsList = relatedProducts === null || relatedProducts === void 0 ? void 0 : relatedProducts.map(function(relatedProduct) {
        return (relatedProduct === null || relatedProduct === void 0 ? void 0 : relatedProduct.code) || "0";
    });
    var ref9 = implementations/* catalogApi.getProductCards */.dZ.getProductCards(Number(branchId), productIdsList, currentPage, pageSize, selectedCategoryId, !!(selectedCategoryId && (productIdsList === null || productIdsList === void 0 ? void 0 : productIdsList.length))), products = ref9.data, isLoadingProductCards = ref9.isLoading;
    (0,react.useEffect)(function() {
        if (products) {
            var ref, ref1;
            setTotalProductCardsRows((products === null || products === void 0 ? void 0 : (ref = products[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.headers) === null || ref1 === void 0 ? void 0 : ref1.totalResults) || (productIdsList === null || productIdsList === void 0 ? void 0 : productIdsList.length));
        }
    }, [
        products,
        productIdsList === null || productIdsList === void 0 ? void 0 : productIdsList.length
    ]);
    var handleOnClickOnCategoryItem = (0,react.useCallback)(function(categoryId) {
        setSelectedCategoryId(categoryId);
        setCurrentPage(1);
        scrollToAlsoSeeContainer();
    }, [
        scrollToAlsoSeeContainer
    ]);
    var isToShowPaginator = Array.isArray(products) && (products === null || products === void 0 ? void 0 : products.length) > 11 || currentPage > 1;
    if (isLoadingRelatedCategory) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Skeleton */.Od, {
            type: "basic",
            count: 4,
            height: 100,
            width: isClientMobile ? 360 : isClientTablet ? 480 : 760
        });
    }
    if (!isLoadingRelatedCategory && !(relatedCategoryData === null || relatedCategoryData === void 0 ? void 0 : relatedCategoryData.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AlsoSeeUI, {
        idSection: idSection,
        isBlackTheme: !!isBlackTheme,
        isLoadingRelatedProducts: isLoadingRelatedProducts,
        isLoadingProductCards: isLoadingProductCards,
        productsData: products,
        relatedCategoryData: relatedCategoryData,
        isClientTablet: isClientTablet,
        alsoSeeContainerRef: alsoSeeContainerRef,
        isAlsoSeeCollapsed: isAlsoSeeCollapsed,
        totalProductCardsRows: totalProductCardsRows,
        selectedCategoryId: selectedCategoryId,
        isToShowPaginator: isToShowPaginator,
        pageSize: pageSize,
        currentPage: currentPage,
        productIdsListLength: (0,application/* getObjectLength */.Wuf)(productIdsList),
        onToggleShowCollapsible: toggleShowCollapsible,
        handleOnClickOnCategoryItem: handleOnClickOnCategoryItem,
        onSetCurrentPage: setCurrentPage,
        onScrollToAlsoSeeContainer: scrollToAlsoSeeContainer
    });
};
/* harmony default export */ var sections_AlsoSee = (AlsoSee);

// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/screens/Product/sections/BoxProduct/styles.ts



function BoxProduct_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: ",
        ";\n  margin-top: 0;\n  overflow: hidden;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  margin-top: 1rem;\n  justify-content: space-between;\n"
    ]);
    BoxProduct_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BoxProduct_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: ",
        ";\n  margin-top: 0;\n  overflow: hidden;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  margin-top: 1rem;\n  justify-content: space-between;\n"
    ]);
    BoxProduct_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BoxProduct_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n"
    ]);
    BoxProduct_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BoxProduct_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    BoxProduct_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function BoxProduct_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  @media ",
        " {\n    display: block;\n  }\n"
    ]);
    BoxProduct_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function BoxProduct_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 5rem;\n  margin-top: 0;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n"
    ]);
    BoxProduct_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function BoxProduct_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 0;\n  margin-left: 2rem;\n  overflow: hidden;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n\n  @media ",
        " {\n    order: ",
        ";\n    gap: 1rem;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n  }\n  /* align-items: center; */\n"
    ]);
    BoxProduct_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function BoxProduct_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    BoxProduct_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function BoxProduct_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    BoxProduct_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function BoxProduct_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: relative;\n  background-color: ",
        ";\n  border-radius: 2px;\n  margin-bottom: 3rem;\n  border: thin solid ",
        ";\n  border-radius: 8px;\n\n  ",
        ":first-child {\n    flex: 1.4;\n    // padding-top:3rem;\n\n    display: flex;\n  }\n\n  ",
        ":last-child {\n    flex: 0.8;\n    padding: 1.65rem 2.5rem 2.5rem 2.5rem;\n  }\n\n  @media ",
        " {\n    flex-direction: column;\n\n    ",
        ":first-child {\n      flex: 1;\n      // padding-top:3rem;\n      flex-direction: column;\n      display: flex;\n    }\n\n    ",
        ":last-child {\n      flex: 1;\n      padding: 15px;\n    }\n  }\n"
    ]);
    BoxProduct_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function BoxProduct_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.2rem;\n  font-weight: ",
        ";\n  margin-left: 0.5rem;\n  color: ",
        ";\n"
    ]);
    BoxProduct_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function BoxProduct_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: relative;\n  margin-bottom: 1rem;\n  min-height: 2rem;\n"
    ]);
    BoxProduct_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function BoxProduct_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 8px;\n"
    ]);
    BoxProduct_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function BoxProduct_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* display: flex;\n  padding: 0.65rem;\n  align-items: flex-start;\n  gap: 0.875rem;\n  margin-top: 0.25rem;\n  border-radius: 0.35rem; */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.65rem;\n  border-radius: 8px;\n  background: ",
        ";\n  max-width: fit-content;\n  min-height: 2.875rem;\n"
    ]);
    BoxProduct_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function BoxProduct_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* color: ",
        "; */\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: 1.125rem;\n  font-weight: ",
        ";\n  line-height: 0.92rem;\n  user-select: none;\n"
    ]);
    BoxProduct_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function BoxProduct_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 0.5rem;\n  display: flex;\n"
    ]);
    BoxProduct_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function BoxProduct_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 0.65rem;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n  border: 1px solid\n    ",
        ";\n  background: ",
        ";\n"
    ]);
    BoxProduct_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: 1.15rem;\n  font-weight: ",
        ";\n  user-select: none;\n"
    ]);
    styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.9rem;\n  font-weight: ",
        ";\n"
    ]);
    styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function styles_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 2rem;\n  margin-bottom: 10px;\n  line-height: normal;\n  font-weight: ",
        ";\n  font-family: ",
        ";\n  color: ",
        ";\n\n  padding-top: ",
        ";\n"
    ]);
    styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function styles_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1rem;\n  font-weight: ",
        ";\n  font-family: ",
        ";\n  color: ",
        ";\n  line-height: normal;\n"
    ]);
    styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.2rem;\n  color: ",
        ";\n  margin-right: 0.5rem;\n  text-decoration: line-through;\n  font-weight: ",
        ";\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.2rem;\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 3rem;\n  margin-bottom: 10px;\n  margin-top: 1rem;\n  line-height: 35px;\n  font-weight: 700;\n  color: ",
        ";\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.4rem;\n  color: ",
        ";\n  font-weight: 500;\n  margin-bottom: 0.5rem;\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 100px;\n  width: 3rem;\n  height: 3rem;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  background-color: ",
        ";\n  right: 0;\n\n  @media ",
        " {\n    width: 32px;\n    height: 32px;\n    background-color: ",
        ";\n    top: ",
        ";\n    right: ",
        ";\n    z-index: 1;\n  }\n\n  @media ",
        " {\n    top: ",
        ";\n    right: ",
        ";\n  }\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: ",
        ";\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}



var heartColors = function(param) {
    var isClicked = param.isClicked, isHovered = param.isHovered;
    if (isClicked) {
        return {
            color: themes/* theme.colors.primary.350 */.rS.colors.primary[350],
            secondColor: themes/* theme.colors.primary.350 */.rS.colors.primary[350]
        };
    }
    if (isHovered) {
        return {
            color: themes/* theme.colors.primary.60 */.rS.colors.primary[60]
        };
    }
    return {
        color: "transparent",
        secondColor: themes/* theme.colors.neutral.240 */.rS.colors.neutral[240]
    };
};
var ContainerSkeletonTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ContainerSkeletonTitle",
    componentId: "sc-c3e89460-0"
})(BoxProduct_styles_templateObject(), function(param) {
    var maxHeight = param.maxHeight;
    return maxHeight !== null && maxHeight !== void 0 ? maxHeight : "9rem";
});
var ContainerSkeletonTagLine = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ContainerSkeletonTagLine",
    componentId: "sc-c3e89460-1"
})(BoxProduct_styles_templateObject1(), function(param) {
    var maxHeight = param.maxHeight;
    return maxHeight !== null && maxHeight !== void 0 ? maxHeight : "9rem";
});
var BoxButtons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxButtons",
    componentId: "sc-c3e89460-2"
})(BoxProduct_styles_templateObject2());
var BoxDesktop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxDesktop",
    componentId: "sc-c3e89460-3"
})(BoxProduct_styles_templateObject3(), themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet);
var BoxMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxMobile",
    componentId: "sc-c3e89460-4"
})(BoxProduct_styles_templateObject4(), themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet);
var ButtonSkeleton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ButtonSkeleton",
    componentId: "sc-c3e89460-5"
})(BoxProduct_styles_templateObject5());
var ContainerBoxSkeleton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ContainerBoxSkeleton",
    componentId: "sc-c3e89460-6"
})(BoxProduct_styles_templateObject6(), themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet, function(param) {
    var responsiveOrder = param.responsiveOrder;
    return responsiveOrder !== null && responsiveOrder !== void 0 ? responsiveOrder : 1;
});
var SectionBox = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__SectionBox",
    componentId: "sc-c3e89460-7"
})(BoxProduct_styles_templateObject7());
var HeaderBox = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    displayName: "styles__HeaderBox",
    componentId: "sc-c3e89460-8"
})(BoxProduct_styles_templateObject8());
var BoxProduct_styles_Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__Container",
    componentId: "sc-c3e89460-9"
})(BoxProduct_styles_templateObject9(), themes/* theme.colors.neutral.white */.rS.colors.neutral.white, themes/* theme.colors.neutral.95 */.rS.colors.neutral[95], SectionBox, SectionBox, themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet, SectionBox, SectionBox);
var NameMarketplace = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    displayName: "styles__NameMarketplace",
    componentId: "sc-c3e89460-10"
})(BoxProduct_styles_templateObject10(), themes/* theme.typography.fontWeight.bold */.rS.typography.fontWeight.bold, themes/* theme.colors.neutral.999 */.rS.colors.neutral[999]);
var BoxTags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxTags",
    componentId: "sc-c3e89460-11"
})(BoxProduct_styles_templateObject11());
var TagProductWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TagProductWrapper",
    componentId: "sc-c3e89460-12"
})(BoxProduct_styles_templateObject12());
var TagProductPriceOnlySiteContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TagProductPriceOnlySiteContainer",
    componentId: "sc-c3e89460-13"
})(BoxProduct_styles_templateObject13(), themes/* theme.colors.secondary.250 */.rS.colors.secondary[250]);
var TagProductPriceOnlySiteText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__TagProductPriceOnlySiteText",
    componentId: "sc-c3e89460-14"
})(BoxProduct_styles_templateObject14(), themes/* theme.colors.secondary.250 */.rS.colors.secondary[250], themes/* theme.colors.neutral.white */.rS.colors.neutral.white, themes/* theme.typography.fontFamily.chivo */.rS.typography.fontFamily.chivo, themes/* theme.typography.fontWeight.500 */.rS.typography.fontWeight[500]);
var TagIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__TagIcon",
    componentId: "sc-c3e89460-15"
})(BoxProduct_styles_templateObject15());
var TagCampaignBoxProduct = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__TagCampaignBoxProduct",
    componentId: "sc-c3e89460-16"
})(BoxProduct_styles_templateObject16(), function(param) {
    var borderColor = param.borderColor;
    return borderColor || "".concat(themes/* theme.colors.neutral.750 */.rS.colors.neutral[750]);
}, function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor || "".concat(themes/* theme.colors.neutral.490 */.rS.colors.neutral[490]);
});
var TagTextCampaignBoxProduct = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__TagTextCampaignBoxProduct",
    componentId: "sc-c3e89460-17"
})(styles_templateObject17(), function(param) {
    var color = param.color;
    return color || themes/* theme.colors.neutral.white */.rS.colors.neutral.white;
}, themes/* theme.typography.fontFamily.chivo */.rS.typography.fontFamily.chivo, themes/* theme.typography.fontWeight.500 */.rS.typography.fontWeight[500]);
var SpanTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__SpanTitle",
    componentId: "sc-c3e89460-18"
})(styles_templateObject18(), themes/* theme.typography.fontWeight.bold */.rS.typography.fontWeight.bold);
var Title1 = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    displayName: "styles__Title1",
    componentId: "sc-c3e89460-19"
})(styles_templateObject19(), themes/* theme.typography.fontWeight.600 */.rS.typography.fontWeight[600], themes/* theme.typography.fontFamily.chivo */.rS.typography.fontFamily.chivo, themes/* theme.colors.neutral.520 */.rS.colors.neutral[520], function(param) {
    var existSomeTag = param.existSomeTag;
    return existSomeTag ? "0px" : "16px";
});
var styles_SubTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SubTitle",
    componentId: "sc-c3e89460-20"
})(styles_templateObject20(), themes/* theme.typography.fontWeight.400 */.rS.typography.fontWeight[400], themes/* theme.typography.fontFamily.chivo */.rS.typography.fontFamily.chivo, themes/* theme.colors.neutral.450 */.rS.colors.neutral[450]);
var FlexBoxCenter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__FlexBoxCenter",
    componentId: "sc-c3e89460-21"
})(_templateObject21());
var Title4 = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    displayName: "styles__Title4",
    componentId: "sc-c3e89460-22"
})(_templateObject22());
var BoxValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxValue",
    componentId: "sc-c3e89460-23"
})(_templateObject23(), function(param) {
    var margin = param.margin;
    return margin;
});
var DiscountValue = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__DiscountValue",
    componentId: "sc-c3e89460-24"
})(_templateObject24(), themes/* theme.colors.neutral.400 */.rS.colors.neutral[400], themes/* theme.typography.fontWeight.600 */.rS.typography.fontWeight[600]);
var DiscountTag = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__DiscountTag",
    componentId: "sc-c3e89460-25"
})(_templateObject25(), themes/* theme.typography.fontWeight.600 */.rS.typography.fontWeight[600], themes/* theme.colors.secondary.300 */.rS.colors.secondary[300]);
var ValueDesc = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    displayName: "styles__ValueDesc",
    componentId: "sc-c3e89460-26"
})(_templateObject26(), themes/* theme.colors.primary.200 */.rS.colors.primary[200]);
var styles_DescriptionParcels = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "styles__DescriptionParcels",
    componentId: "sc-c3e89460-27"
})(_templateObject27(), themes/* theme.colors.neutral.999 */.rS.colors.neutral[999]);
var FavoriteContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__FavoriteContainer",
    componentId: "sc-c3e89460-28"
})(_templateObject28(), themes/* theme.colors.neutral.white-075 */.rS.colors.neutral["white-075"], themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet, themes/* theme.colors.neutral.white */.rS.colors.neutral.white, themes/* theme.space.x2 */.rS.space.x2, themes/* theme.space.x2 */.rS.space.x2, themes/* theme.device.desktopFirst.mobileXL */.rS.device.desktopFirst.mobileXL, themes/* theme.space.x4 */.rS.space.x4, themes/* theme.space.x4 */.rS.space.x4);
var Heart = (0,styled_components_browser_esm/* default */.ZP)(ui.HeartIcon).attrs(function(param) {
    var isHovered = param.isHovered, isClicked = param.isClicked;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, heartColors({
        isClicked: isClicked,
        isHovered: isHovered
    })), {
        height: 28,
        width: 28
    });
}).withConfig({
    displayName: "styles__Heart",
    componentId: "sc-c3e89460-29"
})(_templateObject29(), function(param) {
    var isClicked = param.isClicked;
    return isClicked ? "0.5s ease-in-out" : "none";
});

;// CONCATENATED MODULE: ./src/screens/Product/sections/BoxProduct/SkeletonProduct.tsx



var SkeletonProduct = function() {
    var skeletonFakeList = [
        0,
        1,
        2,
        3,
        4
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerBoxSkeleton, {
                        responsiveOrder: 2,
                        children: skeletonFakeList.map(function(skeletonFakeItem) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Skeleton */.Od, {
                                count: 1,
                                height: 40,
                                width: 40
                            }, skeletonFakeItem);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerBoxSkeleton, {
                        responsiveOrder: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxMobile, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Skeleton */.Od, {
                                    count: 1,
                                    height: "35rem",
                                    width: "35rem"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxDesktop, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Skeleton */.Od, {
                                    count: 1,
                                    height: "45rem",
                                    width: "45rem"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerSkeletonTagLine, {
                        maxHeight: "9rem",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Skeleton */.Od, {
                            count: 2,
                            height: 40,
                            width: "40rem"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerSkeletonTagLine, {
                        maxHeight: "3rem",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Skeleton */.Od, {
                            count: 1,
                            height: 20,
                            width: "25rem"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerSkeletonTagLine, {
                        maxHeight: "3rem",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Skeleton */.Od, {
                            count: 1,
                            height: 20,
                            width: "15rem"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerSkeletonTagLine, {
                        maxHeight: "3rem",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Skeleton */.Od, {
                            count: 1,
                            height: 50,
                            width: "10rem"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerSkeletonTagLine, {
                        maxHeight: "3rem",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Skeleton */.Od, {
                            count: 1,
                            height: 20,
                            width: "20rem"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSkeleton, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Skeleton */.Od, {
                            count: 1,
                            height: 100,
                            width: "40rem"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerSkeletonTagLine, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerSkeletonTagLine, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Skeleton */.Od, {
                                    count: 2,
                                    height: 25,
                                    width: "15rem"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Skeleton */.Od, {
                                count: 1,
                                height: "5rem",
                                width: "15rem"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var BoxProduct_SkeletonProduct = (SkeletonProduct);

;// CONCATENATED MODULE: ./src/screens/Product/sections/BoxProduct/components/SelectPricePackage/styles.ts

function SelectPricePackage_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 2rem 0;\n\n  transition: all 0.2s ease-in-out;\n  .active {\n    border: 2px solid ",
        ";\n  }\n  .disabled:hover {\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    SelectPricePackage_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SelectPricePackage_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  box-sizing: border-box;\n  padding-bottom: 0.4rem;\n  min-height: 8rem;\n"
    ]);
    SelectPricePackage_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SelectPricePackage_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-bottom: 0.5rem;\n  margin-top: 0.5rem;\n"
    ]);
    SelectPricePackage_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SelectPricePackage_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-bottom: 4px;\n  text-align: left;\n  font-size: 1.15rem;\n  line-height: normal;\n  font-weight: ",
        ";\n  font-family: ",
        ";\n"
    ]);
    SelectPricePackage_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SelectPricePackage_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 0.65rem;\n  color: ",
        ";\n  line-height: normal;\n  font-size: 1.15rem;\n  font-weight: ",
        ";\n  font-family: ",
        ";\n"
    ]);
    SelectPricePackage_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SelectPricePackage_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: 1rem;\n  font-weight: ",
        ";\n  line-height: 150%;\n  letter-spacing: -0.02rem;\n"
    ]);
    SelectPricePackage_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SelectPricePackage_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: 0.85rem;\n  font-weight: ",
        ";\n  line-height: 150%;\n  letter-spacing: -0.0165rem;\n"
    ]);
    SelectPricePackage_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SelectPricePackage_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    SelectPricePackage_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SelectPricePackage_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    SelectPricePackage_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function SelectPricePackage_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* color: ",
        ";\n  padding: 0.2rem 0.5rem;\n  border: 1px solid ",
        ";\n  border-radius: 1rem;\n  margin-left: 0.2rem; */\n  display: flex;\n  padding: 0rem 0.35rem;\n  align-items: flex-start;\n  align-self: stretch;\n  margin-left: 8px;\n  background: ",
        ";\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: 0.85rem;\n  font-weight: ",
        ";\n  line-height: 150%;\n  letter-spacing: -0.0165rem;\n  border-radius: 8px;\n"
    ]);
    SelectPricePackage_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function SelectPricePackage_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0.65rem;\n  border-radius: 6px;\n  max-width: 8.65rem;\n  min-height: 5.65rem;\n  max-height: 5.65rem;\n  border: 1px solid ",
        ";\n\n  box-sizing: content-box;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  /* justify-content: center; */\n  /* align-items: center; */\n  cursor: pointer;\n"
    ]);
    SelectPricePackage_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var SelectPricePackage_styles_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Container",
    componentId: "sc-52edd911-0"
})(SelectPricePackage_styles_templateObject(), ui.theme.colors.secondary[250], ui.theme.colors.secondary[250], ui.theme.colors.secondary[250]);
var BoxOptions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxOptions",
    componentId: "sc-52edd911-1"
})(SelectPricePackage_styles_templateObject1());
var BoxTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxTitle",
    componentId: "sc-52edd911-2"
})(SelectPricePackage_styles_templateObject2());
var TextTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "styles__TextTitle",
    componentId: "sc-52edd911-3"
})(SelectPricePackage_styles_templateObject3(), ui.theme.colors.neutral[720], ui.theme.typography.fontWeight[400], ui.theme.typography.fontFamily.chivo);
var SelectPricePackage_styles_SubTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "styles__SubTitle",
    componentId: "sc-52edd911-4"
})(SelectPricePackage_styles_templateObject4(), ui.theme.colors.neutral[750], ui.theme.typography.fontWeight[700], ui.theme.typography.fontFamily.chivo);
var TitleHighlight = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__TitleHighlight",
    componentId: "sc-52edd911-5"
})(SelectPricePackage_styles_templateObject5(), ui.theme.colors.neutral[550], ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontWeight[900]);
var TextHighlight = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "styles__TextHighlight",
    componentId: "sc-52edd911-6"
})(SelectPricePackage_styles_templateObject6(), ui.theme.colors.neutral[330], ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontWeight[400]);
var TextHighlightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TextHighlightWrapper",
    componentId: "sc-52edd911-7"
})(SelectPricePackage_styles_templateObject7());
var TextHighlightWrapperRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TextHighlightWrapperRow",
    componentId: "sc-52edd911-8"
})(SelectPricePackage_styles_templateObject8());
var FlagDiscount = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__FlagDiscount",
    componentId: "sc-52edd911-9"
})(SelectPricePackage_styles_templateObject9(), ui.theme.colors.secondary[400], ui.theme.colors.secondary[400], ui.theme.colors.secondary[250], ui.theme.colors.neutral.white, ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontWeight[500]);
var styles_Box = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Box",
    componentId: "sc-52edd911-10"
})(SelectPricePackage_styles_templateObject10(), ui.theme.colors.neutral[95]);

;// CONCATENATED MODULE: ./src/screens/Product/sections/BoxProduct/components/SelectPricePackage/index.tsx






var SelectPricePackage = function(param) {
    var measuredUnity = param.measuredUnity, _PACKAGES_PRODUCT = param.PACKAGES_PRODUCT, PACKAGES_PRODUCT = _PACKAGES_PRODUCT === void 0 ? [] : _PACKAGES_PRODUCT, packingSelection = param.packingSelection, setSelectPackage = param.setSelectPackage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectPricePackage_styles_Container, {
        children: [
            packingSelection ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxTitle, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextTitle, {
                        children: "Embalagem: "
                    }),
                    (packingSelection === null || packingSelection === void 0 ? void 0 : packingSelection.packingQuantity) === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectPricePackage_styles_SubTitle, {
                        children: [
                            packingSelection === null || packingSelection === void 0 ? void 0 : packingSelection.packingQuantity,
                            " ",
                            (packingSelection === null || packingSelection === void 0 ? void 0 : packingSelection.packingQuantity) === 1 ? packingSelection === null || packingSelection === void 0 ? void 0 : packingSelection.descriptionPackagingUnitSingular : packingSelection === null || packingSelection === void 0 ? void 0 : packingSelection.descriptionPackagingUnitPlural
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectPricePackage_styles_SubTitle, {
                        children: "".concat(packingSelection === null || packingSelection === void 0 ? void 0 : packingSelection.descriptionPackagingUnitSingular, " de ").concat(packingSelection === null || packingSelection === void 0 ? void 0 : packingSelection.packingQuantity, " ").concat(measuredUnity === null || measuredUnity === void 0 ? void 0 : measuredUnity.toLowerCase(), ".")
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Skeleton */.Od, {
                count: 1,
                width: 115,
                height: 20
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxOptions, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("packaging-options")), {
                children: PACKAGES_PRODUCT === null || PACKAGES_PRODUCT === void 0 ? void 0 : PACKAGES_PRODUCT.map(function(item) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(styles_Box, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        className: (item === null || item === void 0 ? void 0 : item.packingLevel) === (packingSelection === null || packingSelection === void 0 ? void 0 : packingSelection.packingLevel) ? "active" : "disabled",
                        onClick: function() {
                            return setSelectPackage(item);
                        }
                    }, (0,application/* buildTestIds */.Fek)("select-package-box")), {
                        children: [
                            (item === null || item === void 0 ? void 0 : item.packingQuantity) === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleHighlight, {
                                children: "".concat(item === null || item === void 0 ? void 0 : item.packingQuantity, " ").concat((item === null || item === void 0 ? void 0 : item.packingQuantity) === 1 ? item === null || item === void 0 ? void 0 : item.descriptionPackagingUnitSingular : item === null || item === void 0 ? void 0 : item.descriptionPackagingUnitPlural)
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleHighlight, {
                                children: "".concat(item === null || item === void 0 ? void 0 : item.descriptionPackagingUnitSingular, " de ").concat(item === null || item === void 0 ? void 0 : item.packingQuantity, " ").concat(measuredUnity === null || measuredUnity === void 0 ? void 0 : measuredUnity.toLowerCase(), ".")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextHighlightWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextHighlightWrapperRow, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextHighlight, {
                                                children: (0,application/* formatCurrency */.xGv)(item === null || item === void 0 ? void 0 : item.salePrice)
                                            }),
                                            +item.discountPercentage > 0 && (item === null || item === void 0 ? void 0 : item.packingLevel) !== (packingSelection === null || packingSelection === void 0 ? void 0 : packingSelection.packingLevel) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlagDiscount, {
                                                children: [
                                                    item === null || item === void 0 ? void 0 : item.discountPercentage,
                                                    "% OFF"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextHighlight, {
                                        children: [
                                            (0,application/* formatCurrency */.xGv)(item === null || item === void 0 ? void 0 : item.unitaryValue),
                                            " / cada"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }), "".concat(item === null || item === void 0 ? void 0 : item.unitaryValue, "#").concat(item === null || item === void 0 ? void 0 : item.unitaryValue));
                })
            }))
        ]
    });
};
/* harmony default export */ var components_SelectPricePackage = (SelectPricePackage);

;// CONCATENATED MODULE: ./src/screens/Product/sections/BoxProduct/components/SelectorOptions/styles.ts

function SelectorOptions_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 1rem;\n  margin-top: 2rem;\n\n  transition: all 0.2s ease-in-out;\n\n  .active {\n    border: 2px solid\n      ",
        ";\n  }\n\n  .disabled:hover {\n    border: 1px solid\n      ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    SelectorOptions_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SelectorOptions_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-bottom: 4px;\n  text-align: left;\n  font-size: 1.15rem;\n  line-height: normal;\n  font-weight: ",
        ";\n  font-family: ",
        ";\n"
    ]);
    SelectorOptions_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SelectorOptions_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 0.65rem;\n  color: ",
        ";\n  line-height: normal;\n  font-size: 1.15rem;\n  font-weight: ",
        ";\n  font-family: ",
        ";\n"
    ]);
    SelectorOptions_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SelectorOptions_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 0.8rem;\n  flex-wrap: wrap;\n  box-sizing: border-box;\n  padding-bottom: 0.4rem;\n"
    ]);
    SelectorOptions_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SelectorOptions_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-bottom: 0.5rem;\n  margin-top: 0.5rem;\n"
    ]);
    SelectorOptions_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SelectorOptions_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 200;\n  margin-bottom: 0.5rem;\n  margin-right: 0.4rem;\n"
    ]);
    SelectorOptions_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SelectorOptions_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  margin-bottom: 0.5rem;\n"
    ]);
    SelectorOptions_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SelectorOptions_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 500;\n  transition: all 0.2s ease-in-out;\n  color: ",
        ";\n"
    ]);
    SelectorOptions_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SelectorOptions_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    SelectorOptions_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function SelectorOptions_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0.65rem;\n  border-radius: 8px;\n  max-width: 10rem;\n  max-height: 2.5rem;\n  border: 1px solid ",
        ";\n\n  box-sizing: content-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  cursor: pointer;\n\n  transition: all 0.2s ease-in-out;\n\n  &:hover {\n    ",
        " {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    SelectorOptions_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function SelectorOptions_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 50%;\n  width: 2.65rem;\n  height: 2.65rem;\n  max-width: 2.65rem;\n  max-height: 2.65rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  cursor: pointer;\n  overflow: hidden;\n  box-shadow: 0px 1.5px 2px 0px ",
        ";\n\n  transition: all 0.2s ease-in-out;\n\n  div {\n    background: ",
        ";\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    background-color: ",
        ";\n  }\n"
    ]);
    SelectorOptions_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function SelectorOptions_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    SelectorOptions_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}


var SelectorOptions_styles_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Container",
    componentId: "sc-3d2ad09d-0"
})(SelectorOptions_styles_templateObject(), function(param) {
    var hasBackgroundColor = param.hasBackgroundColor;
    return hasBackgroundColor ? ui.theme.colors.primary[200] : ui.theme.colors.secondary[250];
}, function(param) {
    var hasBackgroundColor = param.hasBackgroundColor;
    return hasBackgroundColor ? ui.theme.colors.primary[200] : ui.theme.colors.secondary[250];
}, ui.theme.colors.secondary[250]);
var TitleBox = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    displayName: "styles__TitleBox",
    componentId: "sc-3d2ad09d-1"
})(SelectorOptions_styles_templateObject1(), ui.theme.colors.neutral[720], ui.theme.typography.fontWeight[400], ui.theme.typography.fontFamily.chivo);
var Attribute = styled_components_browser_esm/* default.b.withConfig */.ZP.b.withConfig({
    displayName: "styles__Attribute",
    componentId: "sc-3d2ad09d-2"
})(SelectorOptions_styles_templateObject2(), ui.theme.colors.neutral[750], ui.theme.typography.fontWeight[700], ui.theme.typography.fontFamily.chivo);
var styles_BoxOptions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxOptions",
    componentId: "sc-3d2ad09d-3"
})(SelectorOptions_styles_templateObject3());
var styles_BoxTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxTitle",
    componentId: "sc-3d2ad09d-4"
})(SelectorOptions_styles_templateObject4());
var styles_TextTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "styles__TextTitle",
    componentId: "sc-3d2ad09d-5"
})(SelectorOptions_styles_templateObject5());
var SelectorOptions_styles_SubTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "styles__SubTitle",
    componentId: "sc-3d2ad09d-6"
})(SelectorOptions_styles_templateObject6(), ui.theme.typography.fontWeight[700]);
var styles_TextHighlight = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__TextHighlight",
    componentId: "sc-3d2ad09d-7"
})(SelectorOptions_styles_templateObject7(), function(param) {
    var isSelected = param.isSelected;
    return isSelected ? ui.theme.colors.secondary[250] : ui.theme.colors.neutral[330];
});
var TextSub = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__TextSub",
    componentId: "sc-3d2ad09d-8"
})(SelectorOptions_styles_templateObject8(), ui.theme.colors.neutral[400]);
var SelectorOptions_styles_Box = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Box",
    componentId: "sc-3d2ad09d-9"
})(SelectorOptions_styles_templateObject9(), ui.theme.colors.neutral[88], styles_TextHighlight, ui.theme.colors.secondary[250]);
var BoxColor = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxColor",
    componentId: "sc-3d2ad09d-10"
})(SelectorOptions_styles_templateObject10(), ui.theme.colors.neutral[810], ui.theme.colors.primary[25], function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor;
});
// No momento é necessário utilizar o link padrão (tag a) para que a exibição alternada das cores seja feita da forma correta, pois o Magic Zoom Lib não consegue atualizar a imagem quando a tela permanece estática, o que acontece com o Link (Next) - Wellington.Braga
var ColorsContainer = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    displayName: "styles__ColorsContainer",
    componentId: "sc-3d2ad09d-11"
})(SelectorOptions_styles_templateObject11());

;// CONCATENATED MODULE: ./src/screens/Product/sections/BoxProduct/components/SelectorOptions/index.tsx


var SelectorOptions = function(param) {
    var title = param.title, data = param.data;
    var ITEM_SELECT_CURRENT = data === null || data === void 0 ? void 0 : data.find(function(familyItem) {
        return familyItem.selectedValue;
    });
    var hasBackgroundColor = data === null || data === void 0 ? void 0 : data.some(function(item) {
        return item.category === "Cor";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectorOptions_styles_Container, {
        hasBackgroundColor: hasBackgroundColor,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_BoxTitle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleBox, {
                    children: [
                        title,
                        ":",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Attribute, {
                            children: (ITEM_SELECT_CURRENT === null || ITEM_SELECT_CURRENT === void 0 ? void 0 : ITEM_SELECT_CURRENT.category) === "Cor" ? ITEM_SELECT_CURRENT === null || ITEM_SELECT_CURRENT === void 0 ? void 0 : ITEM_SELECT_CURRENT.color.name : ITEM_SELECT_CURRENT === null || ITEM_SELECT_CURRENT === void 0 ? void 0 : ITEM_SELECT_CURRENT.attribute
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_BoxOptions, {
                children: data === null || data === void 0 ? void 0 : data.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorsContainer, {
                        // Depois encontrar uma solução melhor de navegar que funcione junto com o MagicZoom
                        href: "/produto/".concat(item.productCode),
                        target: "_self",
                        children: item.category === "Cor" && /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxColor, {
                            className: item.selectedValue ? "active" : "disabled",
                            backgroundColor: item.color.hexadecimal,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                        }) || /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectorOptions_styles_Box, {
                            className: item.selectedValue ? "active" : "disabled",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_TextHighlight, {
                                isSelected: item.selectedValue,
                                children: item.attribute
                            })
                        })
                    }, item === null || item === void 0 ? void 0 : item.productCode);
                })
            })
        ]
    });
};
/* harmony default export */ var components_SelectorOptions = (SelectorOptions);

// EXTERNAL MODULE: ../../packages/application/hooks/validateClientBranchChange/pageReload.ts
var pageReload = __webpack_require__(33757);
;// CONCATENATED MODULE: ./src/screens/Product/sections/BoxProduct/components/ViewZipCodeSearch/hooks/viewShippingOptions/index.ts

var cleanShippingText = function(value) {
    return value.replace(/ias úteis/g, "").replace(/ia útil/g, "").replace(/ora útil/g, "").replace(/oras úteis/g, "").replace(/ /g, "");
};
var removeQuotationAndBrackets = function(value) {
    if (!value) {
        return "";
    }
    return value.replace(/"/g, "").replace(/[[\]]/g, "");
};
var findStoreId = function(branch) {
    switch(branch){
        case "GARANHUNS":
            return "1";
        case "IMBIRIBEIRA":
            return "2";
        case "PARALELA":
            return "3";
        case "TAMARINEIRA":
            return "4";
        case "ARACAJU":
            return "5";
        case "JOAO PESSOA":
            return "6";
        case "PONTA NEGRA":
            return "7";
        case "CARUARU":
            return "8";
        case "BARRIS":
            return "9";
        default:
            return "0";
    }
};
var calculateDaysUntilArrival = function(arrivalDate) {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var arrivalDateFormatted = new Date(arrivalDate);
    var timeDifference = arrivalDateFormatted.getTime() - today.getTime();
    var daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
    var daysDifferenceWithoutToday = daysDifference - 1;
    return daysDifference > 0 ? "".concat(daysDifferenceWithoutToday.toString(), "d") : "0";
};
var useGtagViewShippingOptions = function(gtag, data, zipCode, description, idProduct) {
    (0,react.useEffect)(function() {
        if (data !== undefined) {
            var fcShippingOptions = (data === null || data === void 0 ? void 0 : data.length) && data.map(function(item) {
                var ref, ref1, ref2, ref3, ref4;
                // v: valor, l: loja, p: prazo, t: tipo de entrega
                return (item === null || item === void 0 ? void 0 : item.pickUpInStore) ? {
                    l: findStoreId(item === null || item === void 0 ? void 0 : (ref = item.pickUpInStoreLocation) === null || ref === void 0 ? void 0 : ref.store),
                    p: cleanShippingText((item === null || item === void 0 ? void 0 : item.arrivesTextShort) || "")
                } : (item === null || item === void 0 ? void 0 : (ref1 = item.arrivesTextShort) === null || ref1 === void 0 ? void 0 : ref1.includes("dias")) || (item === null || item === void 0 ? void 0 : (ref2 = item.arrivesTextShort) === null || ref2 === void 0 ? void 0 : ref2.includes("dia")) ? {
                    v: item === null || item === void 0 ? void 0 : item.value,
                    p: calculateDaysUntilArrival((item === null || item === void 0 ? void 0 : item.arrives) || ""),
                    t: item === null || item === void 0 ? void 0 : (ref3 = item.description) === null || ref3 === void 0 ? void 0 : ref3.substring(0, 2)
                } : {
                    v: item === null || item === void 0 ? void 0 : item.value,
                    p: cleanShippingText((item === null || item === void 0 ? void 0 : item.arrivesTextShort) || ""),
                    t: item === null || item === void 0 ? void 0 : (ref4 = item.description) === null || ref4 === void 0 ? void 0 : ref4.substring(0, 2)
                };
            });
            var fcShippingOptionsString = (data === null || data === void 0 ? void 0 : data.length) ? JSON.stringify(fcShippingOptions) : "Sem op\xe7\xf5es de entrega e retirada";
            gtag === null || gtag === void 0 ? void 0 : gtag.viewProductShipping(String(idProduct), String(description), String(zipCode), removeQuotationAndBrackets(fcShippingOptionsString));
        }
    }, [
        data,
        zipCode,
        description,
        idProduct,
        gtag
    ]);
};

;// CONCATENATED MODULE: ./src/screens/Product/sections/BoxProduct/components/ViewZipCodeSearch/styles.ts

function ViewZipCodeSearch_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    ViewZipCodeSearch_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ViewZipCodeSearch_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: center;\n  gap: 2rem;\n  margin-top: 3rem;\n  height: 2rem;\n  margin-bottom: 2rem;\n"
    ]);
    ViewZipCodeSearch_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ViewZipCodeSearch_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  @media ",
        " {\n    gap: 0.5rem;\n    flex-direction: column;\n    align-items: start;\n  }\n"
    ]);
    ViewZipCodeSearch_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ViewZipCodeSearch_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 0.58;\n  font-size: 1.4rem;\n  font-weight: ",
        ";\n  max-width: 12rem;\n"
    ]);
    ViewZipCodeSearch_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ViewZipCodeSearch_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 2rem;\n  margin-bottom: 1rem;\n"
    ]);
    ViewZipCodeSearch_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ViewZipCodeSearch_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-right: 1.75rem;\n"
    ]);
    ViewZipCodeSearch_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ViewZipCodeSearch_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: 1.15rem;\n"
    ]);
    ViewZipCodeSearch_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ViewZipCodeSearch_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-family: ",
        ";\n  font-size: 1.15rem;\n  max-width: 6rem;\n  color: ",
        ";\n"
    ]);
    ViewZipCodeSearch_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ViewZipCodeSearch_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 2rem;\n  color: ",
        ";\n  font-weight: 500;\n  font-size: 1.4rem;\n  margin-bottom: 0.5rem;\n"
    ]);
    ViewZipCodeSearch_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function ViewZipCodeSearch_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: 400;\n  font-size: 1.2rem;\n"
    ]);
    ViewZipCodeSearch_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function ViewZipCodeSearch_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 0.5rem;\n  flex-direction: column;\n  margin-top: 0.5rem;\n"
    ]);
    ViewZipCodeSearch_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function ViewZipCodeSearch_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: 400;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 120%;\n\n  @media ",
        " {\n    font-size: ",
        ";\n    line-height: 120%;\n  }\n"
    ]);
    ViewZipCodeSearch_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}


var ViewZipCodeSearch_styles_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Container",
    componentId: "sc-590ee44d-0"
})(ViewZipCodeSearch_styles_templateObject());
var FlexCenterRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__FlexCenterRow",
    componentId: "sc-590ee44d-1"
})(ViewZipCodeSearch_styles_templateObject1());
var BoxMain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxMain",
    componentId: "sc-590ee44d-2"
})(ViewZipCodeSearch_styles_templateObject2(), themes/* theme.device.desktopFirst.laptop */.rS.device.desktopFirst.laptop);
var TextDescription = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__TextDescription",
    componentId: "sc-590ee44d-3"
})(ViewZipCodeSearch_styles_templateObject3(), themes/* theme.typography.fontWeight.600 */.rS.typography.fontWeight[600]);
var BoxInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxInfo",
    componentId: "sc-590ee44d-4"
})(ViewZipCodeSearch_styles_templateObject4());
// artur.castro, solućão feia, o correto deve ser corrigir como está sendo utilizado os componentes estilizados atualmente
var TitleColumnTableWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TitleColumnTableWrapper",
    componentId: "sc-590ee44d-5"
})(ViewZipCodeSearch_styles_templateObject5());
var TitleColumnTable = styled_components_browser_esm/* default.th.withConfig */.ZP.th.withConfig({
    displayName: "styles__TitleColumnTable",
    componentId: "sc-590ee44d-6"
})(ViewZipCodeSearch_styles_templateObject6(), themes/* theme.colors.neutral.999 */.rS.colors.neutral[999], themes/* theme.typography.fontFamily.chivo */.rS.typography.fontFamily.chivo);
var ColumnTable = styled_components_browser_esm/* default.td.withConfig */.ZP.td.withConfig({
    displayName: "styles__ColumnTable",
    componentId: "sc-590ee44d-7"
})(ViewZipCodeSearch_styles_templateObject7(), themes/* theme.typography.fontWeight.600 */.rS.typography.fontWeight[600], themes/* theme.typography.fontFamily.chivo */.rS.typography.fontFamily.chivo, function(param) {
    var color = param.color;
    return color || themes/* theme.colors.neutral.999 */.rS.colors.neutral[999];
});
var TitleInvalidZipCode = styled_components_browser_esm/* default.h6.withConfig */.ZP.h6.withConfig({
    displayName: "styles__TitleInvalidZipCode",
    componentId: "sc-590ee44d-8"
})(ViewZipCodeSearch_styles_templateObject8(), themes/* theme.colors.primary.300 */.rS.colors.primary[300]);
var TextInvalidZipCode = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "styles__TextInvalidZipCode",
    componentId: "sc-590ee44d-9"
})(ViewZipCodeSearch_styles_templateObject9(), themes/* theme.colors.neutral.520 */.rS.colors.neutral[520]);
var ShippingConditionsTexts = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ShippingConditionsTexts",
    componentId: "sc-590ee44d-10"
})(ViewZipCodeSearch_styles_templateObject10());
var ConditionText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "styles__ConditionText",
    componentId: "sc-590ee44d-11"
})(ViewZipCodeSearch_styles_templateObject11(), themes/* theme.colors.neutral.585 */.rS.colors.neutral[585], themes/* theme.typography.fontFamily.chivo */.rS.typography.fontFamily.chivo, themes/* theme.typography.fontSize.sm.x1 */.rS.typography.fontSize.sm.x1, themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet, themes/* theme.typography.fontSize.sm.x3 */.rS.typography.fontSize.sm.x3);

;// CONCATENATED MODULE: ./src/screens/Product/sections/BoxProduct/components/ViewZipCodeSearch/subComponents/ InfoShippingBox/styles.tsx

function _InfoShippingBox_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 3rem;\n  background-color: ",
        ";\n  border-radius: 4px;\n  border: 1px solid ",
        ";\n  height: fit-content;\n  min-width: ",
        ";\n  max-width: ",
        ";\n  min-height: ",
        ";\n"
    ]);
    _InfoShippingBox_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _InfoShippingBox_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  max-height: 2.5rem;\n  width: fit-content;\n  background: ",
        ";\n  margin: -1.5rem 0 0 2rem;\n  padding-right: ",
        ";\n  border-radius: 0 4px 4px 0;\n  border: 1px solid ",
        ";\n"
    ]);
    _InfoShippingBox_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _InfoShippingBox_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: thin solid ",
        ";\n  border-radius: 50%;\n  margin-left: -1rem;\n  background: ",
        ";\n  overflow: hidden;\n  height: 3.5rem;\n  width: 3.5rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _InfoShippingBox_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _InfoShippingBox_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-family: ",
        ";\n  font-size: 1.15rem;\n  color: ",
        ";\n  /* width: fit-content; */\n"
    ]);
    _InfoShippingBox_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _InfoShippingBox_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  width: 100%;\n  padding: 2rem 1.35rem 2rem 1.35rem;\n"
    ]);
    _InfoShippingBox_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _InfoShippingBox_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  @media ",
        " {\n    gap: 1.35rem;\n  }\n\n  @media ",
        " {\n    gap: 2.25rem;\n  }\n"
    ]);
    _InfoShippingBox_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _InfoShippingBox_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: flex-start;\n"
    ]);
    _InfoShippingBox_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _InfoShippingBox_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: ",
        ";\n  font-family: ",
        ";\n  font-size: 1rem;\n"
    ]);
    _InfoShippingBox_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _InfoShippingBox_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: ",
        ";\n  font-family: ",
        ";\n  font-size: 1rem;\n"
    ]);
    _InfoShippingBox_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _InfoShippingBox_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  font-family: ",
        ";\n  /* max-width: ",
        "; */\n"
    ]);
    _InfoShippingBox_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _InfoShippingBox_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-family: ",
        ";\n  max-width: 6rem;\n  color: ",
        ";\n"
    ]);
    _InfoShippingBox_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _InfoShippingBox_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0rem 0.65rem;\n  border-radius: 16px;\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  height: fit-content;\n"
    ]);
    _InfoShippingBox_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}


var BoxInfoShipping = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxInfoShipping",
    componentId: "sc-f8925971-0"
})(_InfoShippingBox_styles_templateObject(), ui.theme.colors.neutral.white, ui.theme.colors.neutral[105], ui.theme.space.x64, ui.theme.space.x194, ui.theme.space.x20);
var FlagShipping = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__FlagShipping",
    componentId: "sc-f8925971-1"
})(_InfoShippingBox_styles_templateObject1(), ui.theme.colors.neutral.white, ui.theme.space.x6, ui.theme.colors.neutral[105]);
var ShippingCircleIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ShippingCircleIcon",
    componentId: "sc-f8925971-2"
})(_InfoShippingBox_styles_templateObject2(), ui.theme.colors.neutral[95], ui.theme.colors.neutral.white);
var TitleFlag = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TitleFlag",
    componentId: "sc-f8925971-3"
})(_InfoShippingBox_styles_templateObject3(), ui.theme.typography.fontWeight[600], ui.theme.typography.fontFamily.chivo, ui.theme.colors.neutral[999]);
var InfoTableShipping = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    displayName: "styles__InfoTableShipping",
    componentId: "sc-f8925971-4"
})(_InfoShippingBox_styles_templateObject4());
var LineTable = styled_components_browser_esm/* default.tr.withConfig */.ZP.tr.withConfig({
    displayName: "styles__LineTable",
    componentId: "sc-f8925971-5"
})(_InfoShippingBox_styles_templateObject5(), ui.theme.device.desktopFirst.tablet, ui.theme.device.desktopFirst.mobileXL);
var ColumnArrivesTextWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ColumnArrivesTextWrapper",
    componentId: "sc-f8925971-6"
})(_InfoShippingBox_styles_templateObject6());
var ColumnArrivesText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__ColumnArrivesText",
    componentId: "sc-f8925971-7"
})(_InfoShippingBox_styles_templateObject7(), ui.theme.colors.neutral[550], ui.theme.typography.fontWeight[400], ui.theme.typography.fontFamily.chivo);
var DescriptionText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "styles__DescriptionText",
    componentId: "sc-f8925971-8"
})(_InfoShippingBox_styles_templateObject8(), ui.theme.colors.neutral[680], ui.theme.typography.fontWeight[400], ui.theme.typography.fontFamily.chivo);
var ShippingText = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    displayName: "styles__ShippingText",
    componentId: "sc-f8925971-9"
})(_InfoShippingBox_styles_templateObject9(), ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[500], ui.theme.typography.fontFamily.chivo, ui.theme.space.x44);
var styles_ColumnTable = styled_components_browser_esm/* default.td.withConfig */.ZP.td.withConfig({
    displayName: "styles__ColumnTable",
    componentId: "sc-f8925971-10"
})(_InfoShippingBox_styles_templateObject10(), ui.theme.typography.fontWeight[600], ui.theme.typography.fontFamily.chivo, function(param) {
    var color = param.color;
    return color || ui.theme.colors.neutral[999];
});
var ColumnTableFreeShipping = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ColumnTableFreeShipping",
    componentId: "sc-f8925971-11"
})(_InfoShippingBox_styles_templateObject11(), ui.theme.colors.secondary[250], ui.theme.colors.secondary[380]);

;// CONCATENATED MODULE: ./src/screens/Product/sections/BoxProduct/components/ViewZipCodeSearch/subComponents/ InfoShippingBox/data.tsx

var useFormatShippingText = function(shippingText) {
    return shippingText.split(" ").map(function(word, index, arr) {
        if (![
            "Receba",
            "Chegar\xe1",
            "at\xe9",
            "Retire"
        ].includes(word)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: word
                    }, word),
                    index !== arr.length - 1 && " "
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: word
                }, word),
                index !== arr.length - 1 && " "
            ]
        });
    });
};

;// CONCATENATED MODULE: ./src/screens/Product/sections/BoxProduct/components/ViewZipCodeSearch/subComponents/ InfoShippingBox/index.tsx








var InfoShippingRow = /*#__PURE__*/ (0,react.memo)(function(param) {
    var shipping = param.shipping, shippingType = param.shippingType;
    var ref, // eslint-disable-next-line no-unsafe-optional-chaining
    ref1, // eslint-disable-next-line no-unsafe-optional-chaining
    ref2;
    var shippingTextContent = useFormatShippingText((shipping === null || shipping === void 0 ? void 0 : shipping.arrivesText) || "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineTable, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("shipping-line-table")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ColumnArrivesTextWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShippingText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("title-column-table-product-description")), {
                        children: shippingTextContent
                    })),
                    shippingType === "pickUpInStore" && (shipping === null || shipping === void 0 ? void 0 : (ref = shipping.pickUpInStoreLocation) === null || ref === void 0 ? void 0 : ref.store) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ColumnArrivesText, {
                        children: "Unidade ".concat((shipping === null || shipping === void 0 ? void 0 : (ref1 = shipping.pickUpInStoreLocation) === null || ref1 === void 0 ? void 0 : ref1.store.charAt(0).toUpperCase()) + (shipping === null || shipping === void 0 ? void 0 : (ref2 = shipping.pickUpInStoreLocation) === null || ref2 === void 0 ? void 0 : ref2.store.slice(1).toLowerCase()))
                    })
                ]
            }, shipping === null || shipping === void 0 ? void 0 : shipping.arrivesText),
            (shipping === null || shipping === void 0 ? void 0 : shipping.value) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ColumnTableFreeShipping, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_ColumnTable, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("title-column-table-free")), {
                    color: ui.theme.colors.neutral.white,
                    children: "Gr\xe1tis"
                }))
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_ColumnTable, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("column-table-price-value")), {
                children: (0,application/* formatCurrency */.xGv)(shipping === null || shipping === void 0 ? void 0 : shipping.value)
            }))
        ]
    }));
});
var InfoShippingBox = /*#__PURE__*/ (0,react.memo)(function(param) {
    var shippingType = param.shippingType, shippingInfo = param.shippingInfo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxInfoShipping, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("view-zipcode-search-box-info-shipping")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlagShipping, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("view-zipcode-search-flag-shipping")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShippingCircleIcon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("zipcode-search-shipping-circle-icon")), {
                        children: shippingType === "delivery" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.TruckFC, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.IconStore, {})
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleFlag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("view-zipcode-search-title-flag")), {
                        children: shippingType === "delivery" ? "Receba em casa" : "Retire na loja"
                    }))
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTableShipping, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("view-zipcode-search-info-table-shipping")), {
                children: shippingInfo === null || shippingInfo === void 0 ? void 0 : shippingInfo.map(function(shipping) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(InfoShippingRow, {
                        shippingType: shippingType,
                        shipping: shipping
                    }, shipping === null || shipping === void 0 ? void 0 : shipping.deliveryTypeId);
                })
            }))
        ]
    }));
});
InfoShippingRow.displayName = "Info Shipping Row";
InfoShippingBox.displayName = "Info Shipping Box";

;// CONCATENATED MODULE: ./src/screens/Product/sections/BoxProduct/components/ViewZipCodeSearch/subComponents/index.tsx


;// CONCATENATED MODULE: ./src/screens/Product/sections/BoxProduct/components/ViewZipCodeSearch/index.tsx












var ViewZipCodeSearch = function(param) {
    var _quantityProductSelected = param.quantityProductSelected, quantityProductSelected = _quantityProductSelected === void 0 ? 0 : _quantityProductSelected, _packingLevel = param.packingLevel, packingLevel = _packingLevel === void 0 ? 0 : _packingLevel, idProduct = param.idProduct, sellerId = param.sellerId, description = param.description;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)(""), zipCode = ref4[0], setZipCode = ref4[1];
    var ref5 = (0,react.useState)(false), isToFetchZipCode = ref5[0], setIsToFetchZipCode = ref5[1];
    var ref6 = (0,react.useState)(), setHasData = ref6[1];
    var branchId = (0,application/* getClientBranchId */.R0G)(implementations/* cookie */.pR);
    var formattedZipCode = zipCode === null || zipCode === void 0 ? void 0 : zipCode.replace(/\D/g, "");
    var ref7 = (0,application/* useValidateClientBranchChange */.B8K)(formattedZipCode, implementations/* shippingApi */.JK, implementations/* cookie */.pR), branchIdByZipCode = ref7.branchIdByZipCode, isToReloadPage = ref7.isToReloadPage, isChangingClientLocation = ref7.isChangingClientLocation;
    var isToGetZipCodeAvailability = Boolean((zipCode || isToFetchZipCode || Boolean((0,pageReload/* isPageReloadByZipCodeSearch */.q)())) && /\d{5}-?\d{3}/.test(zipCode) && branchIdByZipCode && !isToReloadPage && !isChangingClientLocation);
    var ref8 = implementations/* shippingApi.getZipCodeAvailability */.JK.getZipCodeAvailability(String(idProduct), String(quantityProductSelected), String(packingLevel), formattedZipCode, branchId, sellerId, isToGetZipCodeAvailability), data = ref8.data, isLoading = ref8.isLoading, getShippingOptionsError = ref8.error;
    var sortListData = {
        delivery: [],
        pickUpAtTheStore: []
    };
    if (data === null || data === void 0 ? void 0 : data.length) {
        sortListData = (0,application/* sortListShipping */.ES0)(data);
    }
    var handleStatusUpdate = (0,react.useCallback)(function() {
        setIsToFetchZipCode(false);
        if (isLoading) {
            setHasData(true);
        } else if (!(data === null || data === void 0 ? void 0 : data.length)) {
            setHasData(false);
        }
    }, [
        data === null || data === void 0 ? void 0 : data.length,
        isLoading
    ]);
    (0,react.useEffect)(function() {
        setIsToFetchZipCode(true);
    }, [
        quantityProductSelected
    ]);
    (0,react.useEffect)(function() {
        handleStatusUpdate();
    }, [
        handleStatusUpdate,
        isLoading
    ]);
    var isConsultingZipCodeAvailability = (formattedZipCode === null || formattedZipCode === void 0 ? void 0 : formattedZipCode.length) === 8 && (isLoading || (0,pageReload/* isPageReloadByZipCodeSearch */.q)() || !branchIdByZipCode || isToReloadPage);
    useGtagViewShippingOptions(implementations/* gtag */.SX, data, zipCode.replace("-", ""), description, idProduct);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ViewZipCodeSearch_styles_Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("view-zipcode-search")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxMain, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("view-zipcode-search-box-main")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextDescription, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("view-zipcode-search-text-description")), {
                        children: "Consultar prazo e valor do frete"
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ButtonSearchZipCode */.Jm, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("view-zipcode-search-button-search")), {
                        returnInfoClickButton: setZipCode,
                        isLoading: isLoading,
                        returnWithHyphen: true
                    }))
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxInfo, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("view-zipcode-search-box-info")), {
                children: isConsultingZipCodeAvailability ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxInfoShipping, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("zipcode-search-box-info-shipping")), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlagShipping, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("view-zipcode-search-flag-shipping")), {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShippingCircleIcon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("view-zipcode-search-shipping-circle-icon")), {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Skeleton */.Od, {
                                        count: 1,
                                        height: 50,
                                        width: 50
                                    })
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexCenterRow, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Skeleton */.Od, {
                                        count: 1,
                                        height: 15,
                                        width: 150
                                    })
                                })
                            ]
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexCenterRow, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Skeleton */.Od, {
                                    type: "basic",
                                    count: 1,
                                    height: 30,
                                    width: 80
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Skeleton */.Od, {
                                    type: "basic",
                                    count: 1,
                                    height: 30,
                                    width: 80
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Skeleton */.Od, {
                                    type: "basic",
                                    count: 1,
                                    height: 30,
                                    width: 80
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexCenterRow, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Skeleton */.Od, {
                                    type: "basic",
                                    count: 1,
                                    height: 30,
                                    width: 80
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Skeleton */.Od, {
                                    type: "basic",
                                    count: 1,
                                    height: 30,
                                    width: 80
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Skeleton */.Od, {
                                    type: "basic",
                                    count: 1,
                                    height: 30,
                                    width: 80
                                })
                            ]
                        })
                    ]
                })) : (sortListData === null || sortListData === void 0 ? void 0 : (ref = sortListData.pickUpAtTheStore) === null || ref === void 0 ? void 0 : ref.length) || (sortListData === null || sortListData === void 0 ? void 0 : (ref1 = sortListData.delivery) === null || ref1 === void 0 ? void 0 : ref1.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        (sortListData === null || sortListData === void 0 ? void 0 : (ref2 = sortListData.pickUpAtTheStore) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoShippingBox, {
                            shippingInfo: sortListData.pickUpAtTheStore,
                            shippingType: "pickUpInStore"
                        }),
                        (sortListData === null || sortListData === void 0 ? void 0 : (ref3 = sortListData.delivery) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoShippingBox, {
                            shippingInfo: sortListData.delivery,
                            shippingType: "delivery"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShippingConditionsTexts, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("freight-description-text")), {
                                    children: "A data estimada de entrega pode variar com a aprova\xe7\xe3o do pagamento, que costuma ser processado em at\xe9 3 horas, mas pode levar at\xe9 72 horas."
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("freight-description-text")), {
                                    children: "O frete \xe9 estimado para sua regi\xe3o. Confira o valor final na conclus\xe3o do pedido."
                                }))
                            ]
                        })
                    ]
                }) : getShippingOptionsError ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleInvalidZipCode, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("title-invalid-zipcode")), {
                            children: "Consulte o frete ao finalizar o pedido"
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInvalidZipCode, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("text-invalid-zipcode")), {
                            children: "Devido ao alto volume de acessos, verifique as op\xe7\xf5es de frete na p\xe1gina de finaliza\xe7\xe3o da compra."
                        }))
                    ]
                }) : !isLoading && (formattedZipCode === null || formattedZipCode === void 0 ? void 0 : formattedZipCode.length) === 8 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleInvalidZipCode, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("title-invalid-zipcode")), {
                            children: "Frete n\xe3o encontrado"
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInvalidZipCode, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("text-invalid-zipcode")), {
                            children: "Infelizmente n\xe3o foram encontradas formas de entrega dispon\xedveis para esse CEP."
                        }))
                    ]
                }) : null
            }))
        ]
    }));
};
/* harmony default export */ var components_ViewZipCodeSearch = (ViewZipCodeSearch);

;// CONCATENATED MODULE: ./src/screens/Product/sections/BoxProduct/components/index.ts




;// CONCATENATED MODULE: ./src/screens/Product/sections/BoxProduct/index.tsx














var BoxProduct_ButtonCart = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 20140)).then(function(module) {
        return module;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20140)
            ];
        }
    }
});
var ButtonCartUnavailable = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3650).then(__webpack_require__.bind(__webpack_require__, 13650)).then(function(module) {
        return module;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(13650)
            ];
        }
    }
});
var BoxProduct = function(param) {
    var description = param.description, tmp = param.prices, PACKAGES_PRODUCT = tmp === void 0 ? [] : tmp, _mediaLinks = param.mediaLinks, mediaLinks = _mediaLinks === void 0 ? [] : _mediaLinks, measuredUnity = param.measuredUnity, factPackaged = param.factPackaged, productFamilies = param.productFamilies, tag = param.tag, idProduct = param.idProduct, packageCurrentState = param.packageCurrentState, setPackageCurrent = param.setPackageCurrent, actionAddItemCart = param.actionAddItemCart, setProductQuantity = param.setProductQuantity, totalStockFC = param.totalStockFC, maximumStockPerBranch = param.maximumStockPerBranch, actionAddToGift = param.actionAddToGift, _activeButtonWeddingList = param.activeButtonWeddingList, activeButtonWeddingList = _activeButtonWeddingList === void 0 ? false : _activeButtonWeddingList, limitTotalQuantityItem = param.limitTotalQuantityItem, coupons = param.coupons, sendingItemToCart = param.sendingItemToCart, isBlackTheme = param.isBlackTheme, isBlackFriday = param.isBlackFriday;
    var ref, ref1, ref2;
    // const { isClientTablet } = useAppContext();
    var ref3 = (0,react.useState)(1), quantityProductSelected = ref3[0], setQuantityProductSelected = ref3[1];
    // const [isHovered, setIsHovered] = useState<boolean>(false);
    // const [isClicked, setIsClicked] = useState<boolean>(false);
    (0,react.useEffect)(function() {
        if (PACKAGES_PRODUCT === null || PACKAGES_PRODUCT === void 0 ? void 0 : PACKAGES_PRODUCT.length) {
            setPackageCurrent(PACKAGES_PRODUCT[0]);
        }
    }, [
        PACKAGES_PRODUCT,
        setPackageCurrent
    ]);
    (0,react.useEffect)(function() {
        setProductQuantity(quantityProductSelected);
    }, [
        quantityProductSelected,
        setProductQuantity
    ]);
    if (!idProduct) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage("O produto n\xe3o possui um idProduct vinculado.");
    }
    (0,application/* handleProductTag */.Rnl)(idProduct, tag, implementations/* appMonitoringClient */.pE);
    if (!description) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxProduct_styles_Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxProduct_SkeletonProduct, {})
        });
    }
    var notShouldShowOldPriceAndDiscount = (packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.priceList) < (packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.salePrice);
    var ref4;
    // const handleMouseEnter = () => {
    //   setIsHovered(true);
    // };
    // const handleMouseLeave = () => {
    //   setIsHovered(false);
    // };
    // const handleHeartClick = (event: MouseEvent<HTMLDivElement>) => {
    //   event.preventDefault();
    //   setIsClicked(!isClicked);
    // };
    var hasUnavailableStockPerBranch = maximumStockPerBranch === 0 || Number(maximumStockPerBranch) < 1 * ((ref4 = packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.packingQuantity) !== null && ref4 !== void 0 ? ref4 : 1);
    var hasUnavailableTag = tag === null || tag === void 0 ? void 0 : tag.isUnavailable;
    var boxProductTestId = "box-product-box-value";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxProduct_styles_Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-product-container")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionBox, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("image-box-section-box")), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ImagesProduct */.eY, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-product-images-product")), {
                    mediaLinks: mediaLinks
                }))
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionBox, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-product-section-box")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderBox, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TagProductWrapper, {
                                children: [
                                    isBlackTheme && /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxTags, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-product-box-tags")), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagCampaignBoxProduct, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            backgroundColor: ui.theme.colors.blackFriday[125],
                                            borderColor: ui.theme.colors.blackFriday[125]
                                        }, (0,application/* buildTestIds */.Fek)("tag-campaign-box-product")), {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagTextCampaignBoxProduct, {
                                                children: "Oferta Black Friday"
                                            })
                                        }))
                                    })),
                                    (tag === null || tag === void 0 ? void 0 : tag.title) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxTags, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-product-box-tags")), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagProductPriceOnlySiteContainer, {
                                            backgroundColor: tag === null || tag === void 0 ? void 0 : tag.color,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagProductPriceOnlySiteText, {
                                                children: tag === null || tag === void 0 ? void 0 : tag.title
                                            })
                                        })
                                    })) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title1, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                existSomeTag: Boolean(isBlackFriday || (tag === null || tag === void 0 ? void 0 : tag.title))
                            }, (0,application/* buildTestIds */.Fek)("box-product-title")), {
                                children: description
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBoxCenter, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-product-flex-box-center")), {
                                className: "new-product__sold",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_SubTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-product-title-3")), {
                                        children: "Vendido e entregue por"
                                    })),
                                    (packageCurrentState === null || packageCurrentState === void 0 ? void 0 : (ref = packageCurrentState.marketplace) === null || ref === void 0 ? void 0 : ref.fantasy) === "Ferreira Costa" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-product-marketplace-image")), {
                                        src: "https://fercos-s3-ecommerce.s3.amazonaws.com/logo/logo_fc.svg",
                                        width: "64px",
                                        height: "16px",
                                        alt: "logo marca da Ferreira Costa",
                                        layout: "fixed"
                                    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NameMarketplace, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-product-name-marketplace")), {
                                        children: packageCurrentState === null || packageCurrentState === void 0 ? void 0 : (ref1 = packageCurrentState.marketplace) === null || ref1 === void 0 ? void 0 : ref1.fantasy
                                    }))
                                ]
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxValue, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        margin: "2rem 0 0 0"
                    }, (0,application/* buildTestIds */.Fek)("box-product-value")), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BoxPriceProduct, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            isBlackFriday: isBlackFriday
                        }, (0,application/* buildTestIds */.Fek)("box-product-box-price-product")), {
                            packageCurrentState: packageCurrentState,
                            measuredUnity: measuredUnity,
                            notShouldShowOldPriceAndDiscount: notShouldShowOldPriceAndDiscount
                        }))
                    })),
                    (PACKAGES_PRODUCT === null || PACKAGES_PRODUCT === void 0 ? void 0 : PACKAGES_PRODUCT.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SelectPricePackage, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-product-select-price-package")), {
                        measuredUnity: measuredUnity,
                        PACKAGES_PRODUCT: PACKAGES_PRODUCT,
                        packingSelection: packageCurrentState,
                        setSelectPackage: setPackageCurrent
                    })),
                    (productFamilies === null || productFamilies === void 0 ? void 0 : productFamilies.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxValue, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)(boxProductTestId)), {
                        children: productFamilies === null || productFamilies === void 0 ? void 0 : productFamilies.map(function(param) {
                            var category = param.category, families = param.families;
                            if ((families === null || families === void 0 ? void 0 : families.length) === 1) {
                                return null;
                            }
                            return /*#__PURE__*/ (0,react.createElement)(components_SelectorOptions, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-product-selector-options")), {
                                key: category,
                                title: category,
                                data: families
                            }));
                        })
                    })) : null,
                    !hasUnavailableTag && !hasUnavailableStockPerBranch ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxValue, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        margin: "2rem 0 2rem 0"
                    }, (0,application/* buildTestIds */.Fek)(boxProductTestId)), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CountQuantityProduct */.Qk, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-product-count-quantity-product")), {
                            limitQuantityItem: limitTotalQuantityItem,
                            totalStockFC: totalStockFC,
                            maximumStockPerBranch: maximumStockPerBranch,
                            measuredUnity: measuredUnity,
                            factPackaged: factPackaged,
                            descriptionPackagingUnitPlural: packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.descriptionPackagingUnitPlural,
                            descriptionPackagingUnitSingular: packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.descriptionPackagingUnitSingular,
                            packingUnity: packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.packingUnity,
                            packingQuantity: packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.packingQuantity,
                            setProductQuantity: setQuantityProductSelected,
                            debounceTime: 0
                        }))
                    })) : null,
                    (coupons === null || coupons === void 0 ? void 0 : coupons.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxValue, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        margin: "2rem 0 2rem 0"
                    }, (0,application/* buildTestIds */.Fek)(boxProductTestId)), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxCoupons, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-product-box-coupons")), {
                            coupons: coupons,
                            useToast: application/* useToast */.pmc
                        }))
                    })) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxButtons, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-product-box-buttons")), {
                        children: hasUnavailableTag || hasUnavailableStockPerBranch ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCartUnavailable, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-product-button-cart-unavailable")), {
                            buttonText: tag === null || tag === void 0 ? void 0 : tag.descriptionButton,
                            buttonBgColor: tag === null || tag === void 0 ? void 0 : tag.buttonColor,
                            unavailableDesc: tag === null || tag === void 0 ? void 0 : tag.descriptionReason,
                            shouldShowUnavailableBoxIcon: !hasUnavailableStockPerBranch
                        })) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxProduct_ButtonCart, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-product-button-cart")), {
                                    actionButton: actionAddItemCart,
                                    sendingItemToCart: sendingItemToCart
                                })),
                                activeButtonWeddingList ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ButtonAddProductToWeddingList, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-product-button-add-product-to-wedding-list")), {
                                    actionAddToGift: actionAddToGift
                                })) : null
                            ]
                        })
                    })),
                    !hasUnavailableTag && !hasUnavailableStockPerBranch ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ViewZipCodeSearch, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-product-view-zipCode-search")), {
                        quantityProductSelected: quantityProductSelected,
                        packingLevel: packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.packingLevel,
                        idProduct: idProduct,
                        description: description,
                        sellerId: packageCurrentState === null || packageCurrentState === void 0 ? void 0 : (ref2 = packageCurrentState.marketplace) === null || ref2 === void 0 ? void 0 : ref2.storeId
                    })) : null
                ]
            }))
        ]
    }));
};
/* harmony default export */ var sections_BoxProduct = (BoxProduct);

// EXTERNAL MODULE: ../../packages/infra/index.ts + 47 modules
var infra = __webpack_require__(11338);
// EXTERNAL MODULE: ./src/screens/Product/components/ButtonCart/styles.ts
var styles = __webpack_require__(35299);
;// CONCATENATED MODULE: ./src/screens/Product/sections/HeaderProductFixed/styles.ts

function HeaderProductFixed_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\nfrom {\n  opacity: 0;\n}\n\nto {\n  opacity: 1;\n}\n"
    ]);
    HeaderProductFixed_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HeaderProductFixed_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        " !important;\n    "
    ]);
    HeaderProductFixed_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HeaderProductFixed_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 0;\n  background: ",
        ";\n  width: 100vw;\n  max-height: fit-content;\n  overflow: hidden;\n  display: none;\n  z-index: 12;\n  padding-top: 0.8rem;\n  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 10%);\n\n  animation: ",
        " 0.125s ease-in;\n\n  ",
        "\n\n  @media ",
        " {\n    bottom: 0;\n    top: auto;\n    box-shadow: 0px -2px 3px 0px rgb(0 0 0 / 10%);\n  }\n\n  @media ",
        " {\n    bottom: -1px;\n    top: auto;\n    box-shadow: 0px -2px 3px 0px rgb(0 0 0 / 10%);\n  }\n"
    ]);
    HeaderProductFixed_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HeaderProductFixed_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 0 0.65rem 1.5rem;\n"
    ]);
    HeaderProductFixed_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HeaderProductFixed_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  max-width: 45%;\n\n  @media ",
        " {\n    align-items: ",
        " !important;\n  }\n"
    ]);
    HeaderProductFixed_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function HeaderProductFixed_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: ",
        ";\n  align-items: ",
        ";\n  justify-content: center;\n  gap: 1.5rem;\n  width: max-content;\n\n  //artur.castro essa media query muito especifica para ajuste futuro\n  @media (min-width: 1025px) {\n    flex-direction: ",
        ";\n    padding: ",
        ";\n  }\n\n  @media ",
        " {\n    flex-direction: ",
        ";\n    gap: 0.5rem;\n  }\n\n  @media ",
        " {\n    gap: 0.5rem;\n\n    ",
        " {\n      height: ",
        ";\n      width: ",
        ";\n    }\n  }\n"
    ]);
    HeaderProductFixed_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function HeaderProductFixed_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  gap: 2.5rem;\n\n  ",
        ":first-child {\n    display: flex;\n    align-items: center !important;\n    gap: 1rem;\n  }\n\n  ",
        ":last-child {\n    align-items: flex-end;\n    gap: 2rem;\n  }\n\n  @media ",
        " {\n    ",
        ":first-child {\n      flex-direction: row;\n    }\n\n    ",
        ":last-child {\n      flex-direction: column;\n      align-items: flex-end;\n      max-width: 50%;\n      gap: 0;\n    }\n  }\n\n  @media ",
        " {\n    ",
        ":first-child {\n      flex-direction: row;\n    }\n\n    ",
        ":last-child {\n      gap: 2rem;\n      flex-direction: row;\n      align-items: flex-start;\n    }\n  }\n\n  @media ",
        " {\n    ",
        ":first-child {\n      flex-direction: row;\n    }\n\n    ",
        ":last-child {\n      flex-direction: column;\n    }\n  }\n\n  @media ",
        " {\n    ",
        ":first-child {\n      display: flex;\n      align-items: flex-start !important;\n      gap: 1rem;\n      padding-right: 1.5rem;\n    }\n\n    ",
        ":last-child {\n      align-items: flex-end !important;\n      padding-right: 1.5rem;\n      gap: 1rem;\n    }\n  }\n"
    ]);
    HeaderProductFixed_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function HeaderProductFixed_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.5rem;\n  color: ",
        ";\n"
    ]);
    HeaderProductFixed_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function HeaderProductFixed_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: end;\n\n  ",
        " {\n    text-align: right !important;\n  }\n\n  @media ",
        " {\n    padding-right: 2rem;\n  }\n\n  @media ",
        " {\n    padding-right: 0;\n  }\n"
    ]);
    HeaderProductFixed_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function HeaderProductFixed_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 7rem;\n  max-width: 7rem;\n  height: 7rem;\n  margin-right: 1rem;\n\n  img {\n    border-radius: 8px;\n    padding: 4px;\n    background: ",
        ";\n  }\n\n  @media ",
        " {\n    margin-top: 0;\n    margin-right: 0;\n    min-width: 5rem;\n    max-width: 6rem;\n    display: flex;\n    align-items: center;\n\n    span {\n      padding: 0.75rem !important;\n    }\n  }\n\n  @media ",
        " {\n    min-width: 4rem;\n    max-width: 4rem;\n    padding-bottom: 2rem;\n\n    span {\n      padding: 0.75rem !important;\n    }\n  }\n"
    ]);
    HeaderProductFixed_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function HeaderProductFixed_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        color: ",
        " !important;\n      "
    ]);
    HeaderProductFixed_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function HeaderProductFixed_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border-bottom: 2px solid ",
        " !important;\n      "
    ]);
    HeaderProductFixed_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function HeaderProductFixed_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-start;\n  gap: 2rem;\n  position: relative;\n  top: 7px;\n\n  a {\n    font-size: 1.2rem;\n    color: ",
        ";\n    cursor: pointer;\n    padding: 1rem 0 0.25rem 0;\n    ",
        "\n  }\n\n  @media ",
        " {\n    display: none;\n  }\n\n  .active {\n    border-bottom: 2px solid ",
        ";\n\n    ",
        ";\n\n    color: ",
        ";\n  }\n"
    ]);
    HeaderProductFixed_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function HeaderProductFixed_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n\n  font-size: 1.45rem;\n  min-width: 156px;\n  max-width: 156px;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  white-space: pre-wrap;\n  user-select: none;\n  font-weight: 600;\n\n  @media ",
        " {\n    max-width: 476px;\n    padding-top: 1rem;\n    align-self: normal;\n  }\n\n  @media ",
        " {\n    min-width: 124px;\n    font-size: 1.45rem;\n  }\n\n  @media ",
        " {\n    font-size: 1.25rem;\n  }\n"
    ]);
    HeaderProductFixed_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}





var styles_showMoreSoftly = (0,styled_components_browser_esm/* keyframes */.F4)(HeaderProductFixed_styles_templateObject());
var Header = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    displayName: "styles__Header",
    componentId: "sc-beccd7a5-0"
})(HeaderProductFixed_styles_templateObject2(), themes/* theme.colors.neutral.white */.rS.colors.neutral.white, styles_showMoreSoftly, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme && (0,styled_components_browser_esm/* css */.iv)(HeaderProductFixed_styles_templateObject1(), themes/* theme.colors.blackFriday.175 */.rS.colors.blackFriday[175]);
}, themes/* theme.device.desktopFirst.tabletS */.rS.device.desktopFirst.tabletS, themes/* theme.device.desktopFirst.mobileXL */.rS.device.desktopFirst.mobileXL);
var HeaderContent = (0,styled_components_browser_esm/* default */.ZP)(ui.Container).withConfig({
    displayName: "styles__HeaderContent",
    componentId: "sc-beccd7a5-1"
})(HeaderProductFixed_styles_templateObject3());
var SectionContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__SectionContainer",
    componentId: "sc-beccd7a5-2"
})(HeaderProductFixed_styles_templateObject4(), themes/* theme.device.desktopFirst.mobileXL */.rS.device.desktopFirst.mobileXL, function(param) {
    var shouldAlignToRight = param.shouldAlignToRight;
    return shouldAlignToRight ? "center" : "flex-start";
});
var styles_BoxButtons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxButtons",
    componentId: "sc-beccd7a5-3"
})(HeaderProductFixed_styles_templateObject5(), function(param) {
    var activeButtonWeddingList = param.activeButtonWeddingList;
    return activeButtonWeddingList ? "row-reverse" : "column";
}, function(param) {
    var activeButtonWeddingList = param.activeButtonWeddingList;
    return activeButtonWeddingList ? "center" : "end";
}, function(param) {
    var activeButtonWeddingList = param.activeButtonWeddingList;
    return activeButtonWeddingList ? "column" : "row";
}, function(param) {
    var activeButtonWeddingList = param.activeButtonWeddingList;
    return activeButtonWeddingList ? "0rem 2rem 0 0" : "1rem 2rem 0 0";
}, themes/* theme.device.mobileFirst.mobileXL */.rS.device.mobileFirst.mobileXL, function(param) {
    var activeButtonWeddingList = param.activeButtonWeddingList;
    return activeButtonWeddingList ? "column" : "row";
}, themes/* theme.device.desktopFirst.mobileXL */.rS.device.desktopFirst.mobileXL, styles/* Button */.zx, function(param) {
    var activeButtonWeddingList = param.activeButtonWeddingList;
    return activeButtonWeddingList ? "36px" : "38px";
}, function(param) {
    var activeButtonWeddingList = param.activeButtonWeddingList;
    return activeButtonWeddingList ? "56px" : "116px";
});
var styles_BoxInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxInfo",
    componentId: "sc-beccd7a5-4"
})(HeaderProductFixed_styles_templateObject6(), SectionContainer, SectionContainer, themes/* theme.device.mobileFirst.tabletS */.rS.device.mobileFirst.tabletS, SectionContainer, SectionContainer, themes/* theme.device.mobileFirst.laptop */.rS.device.mobileFirst.laptop, SectionContainer, SectionContainer, themes/* theme.device.desktopFirst.tabletS */.rS.device.desktopFirst.tabletS, SectionContainer, SectionContainer, themes/* theme.device.desktopFirst.mobileXL */.rS.device.desktopFirst.mobileXL, SectionContainer, SectionContainer);
var ValueProduct = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "styles__ValueProduct",
    componentId: "sc-beccd7a5-5"
})(HeaderProductFixed_styles_templateObject7(), themes/* theme.colors.primary.200 */.rS.colors.primary[200]);
var BoxValueDescription = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__BoxValueDescription",
    componentId: "sc-beccd7a5-6"
})(HeaderProductFixed_styles_templateObject8(), DescriptionParcels, themes/* theme.device.mobileFirst.mobileXL */.rS.device.mobileFirst.mobileXL, themes/* theme.device.mobileFirst.laptop */.rS.device.mobileFirst.laptop);
var BoxImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxImage",
    componentId: "sc-beccd7a5-7"
})(HeaderProductFixed_styles_templateObject9(), themes/* theme.colors.neutral.white */.rS.colors.neutral.white, themes/* theme.device.desktopFirst.tabletS */.rS.device.desktopFirst.tabletS, themes/* theme.device.desktopFirst.mobileXL */.rS.device.desktopFirst.mobileXL);
var BoxNav = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    displayName: "styles__BoxNav",
    componentId: "sc-beccd7a5-8"
})(HeaderProductFixed_styles_templateObject12(), themes/* theme.colors.neutral.600 */.rS.colors.neutral[600], function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme && (0,styled_components_browser_esm/* css */.iv)(HeaderProductFixed_styles_templateObject10(), themes/* theme.colors.blackFriday.white */.rS.colors.blackFriday.white);
}, themes/* theme.device.desktopFirst.tabletS */.rS.device.desktopFirst.tabletS, themes/* theme.colors.primary.200 */.rS.colors.primary[200], function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme && (0,styled_components_browser_esm/* css */.iv)(HeaderProductFixed_styles_templateObject11(), themes/* theme.colors.secondary.310 */.rS.colors.secondary[310]);
}, themes/* theme.colors.primary.200 */.rS.colors.primary[200]);
var HeaderProductFixed_styles_Description = styled_components_browser_esm/* default.text.withConfig */.ZP.text.withConfig({
    displayName: "styles__Description",
    componentId: "sc-beccd7a5-9"
})(HeaderProductFixed_styles_templateObject13(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? themes/* theme.colors.blackFriday.white */.rS.colors.blackFriday.white : themes/* theme.colors.neutral.600 */.rS.colors.neutral[600];
}, themes/* theme.device.mobileFirst.laptop */.rS.device.mobileFirst.laptop, themes/* theme.device.desktopFirst.mobileM */.rS.device.desktopFirst.mobileM, themes/* theme.device.desktopFirst.mobileS */.rS.device.desktopFirst.mobileS);

;// CONCATENATED MODULE: ./src/screens/Product/sections/HeaderProductFixed/index.tsx










var HeaderProductFixed_ButtonCart = (0,application/* lazyLoading */.jfz)(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 20140)).then(function(module) {
        return module;
    });
});
var HeaderProductFixed_ButtonCartUnavailable = (0,application/* lazyLoading */.jfz)(function() {
    return __webpack_require__.e(/* import() */ 3650).then(__webpack_require__.bind(__webpack_require__, 13650)).then(function(module) {
        return module;
    });
});
var HeaderProductFixed = function(param) {
    var mediaLinks = param.mediaLinks, description = param.description, packageCurrentState = param.packageCurrentState, measuredUnity = param.measuredUnity, sectionIdItemsMenu = param.sectionIdItemsMenu, tag = param.tag, sendingItemToCart = param.sendingItemToCart, addItemCart = param.addItemCart, actionAddToGift = param.actionAddToGift, maximumStockPerBranch = param.maximumStockPerBranch, _activeButtonWeddingList = param.activeButtonWeddingList, activeButtonWeddingList = _activeButtonWeddingList === void 0 ? false : _activeButtonWeddingList, isBlackTheme = param.isBlackTheme;
    var isClientMobile = (0,application/* useAppContext */.bp4)().isClientMobile;
    var containerRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(), thumbImage = ref[0], setImageThumb = ref[1];
    var ref1 = (0,react.useState)([]), listItemsMenu = ref1[0], setItemsMenu = ref1[1];
    var mediaScaleBottom = isClientMobile ? 0.7 : 0.8;
    (0,react.useEffect)(function() {
        window.onscroll = function() {
            if (!containerRef.current) {
                return;
            }
            var top = window.pageYOffset || document.documentElement.scrollTop;
            if (top >= 250) {
                containerRef.current.style.display = "block";
                return;
            }
            containerRef.current.style.display = "none";
        };
        setImageThumb(mediaLinks === null || mediaLinks === void 0 ? void 0 : mediaLinks.find(function(item) {
            return item.isDefault ? item.isDefault : item.linkType === "THUMB";
        }));
        // wellington.braga Procurar posteriormente uma solução melhor para resolver o problema de não encontrar o elemento no DOM ao carregar a página
        setTimeout(function() {
            setItemsMenu(sectionIdItemsMenu.filter(function(param) {
                var idReference = param.idReference;
                return document.getElementById(idReference);
            }));
        }, 1000);
    }, [
        mediaLinks,
        sectionIdItemsMenu
    ]);
    var ref2;
    var hasUnavailableStockPerBranch = maximumStockPerBranch === 0 || Number(maximumStockPerBranch) < 1 * ((ref2 = packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.packingQuantity) !== null && ref2 !== void 0 ? ref2 : 1);
    var hasUnavailableTag = tag === null || tag === void 0 ? void 0 : tag.isUnavailable;
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-product-fixed")), {
        isBlackTheme: isBlackTheme,
        ref: containerRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-product-fixed-content")), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_BoxInfo, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-product-fixed-box-info")), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-product-fixed-section-container")), {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxImage, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-product-fixed-box-image")), {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-product-fixed-image")), {
                                        src: (ref3 = thumbImage === null || thumbImage === void 0 ? void 0 : thumbImage.imageUrl) !== null && ref3 !== void 0 ? ref3 : "https://fcx-s3-fercos-backoffice.ferreiracosta.com/thumb/default/default_thumb.svg",
                                        alt: "thumb do produto",
                                        height: "100%",
                                        width: "100%",
                                        layout: "intrinsic"
                                    }))
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderProductFixed_styles_Description, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-product-fixed-description")), {
                                    isBlackTheme: isBlackTheme,
                                    children: description
                                }))
                            ]
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-product-fixed-section-container")), {
                            shouldAlignToRight: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxValueDescription, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-product-fixed-box-value-description")), {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BoxPriceProduct, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-product-fixed-box-price-product")), {
                                        descriptionParcelsFontColor: ui.theme.colors.neutral.white,
                                        isBlackFriday: isBlackTheme,
                                        flexDirectionTextDescount: "column-reverse",
                                        packageCurrentState: packageCurrentState,
                                        installmentsIsVisibled: !isClientMobile,
                                        measuredUnity: measuredUnity,
                                        modalViewMore: false,
                                        marginBottomPrice: false,
                                        fontSizeDiscount: isClientMobile ? "0.9rem" : "1rem",
                                        fontSizePrice: isClientMobile ? "1.5rem" : "2rem",
                                        maxWidth: "18rem",
                                        fontSizeDescriptionParcels: "1.15rem",
                                        fontSizeDetailsValue: isClientMobile ? "1.1875rem" : "1.15rem",
                                        notShouldShowOldPrice: true,
                                        notShouldShowTagOff: true,
                                        shouldShowTextSpotPriceOnHeaderFixedMobile: isClientMobile
                                    }))
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_BoxButtons, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-product-fixed-box-buttons")), {
                                    activeButtonWeddingList: activeButtonWeddingList,
                                    children: hasUnavailableTag || hasUnavailableStockPerBranch ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderProductFixed_ButtonCartUnavailable, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-product-fixed-button-cart-unavailable")), {
                                        isHeaderProduct: true,
                                        buttonText: tag === null || tag === void 0 ? void 0 : tag.descriptionButton,
                                        buttonBgColor: tag === null || tag === void 0 ? void 0 : tag.buttonColor,
                                        unavailableDesc: tag === null || tag === void 0 ? void 0 : tag.descriptionReason,
                                        mediaScaleBottom: mediaScaleBottom,
                                        textVisibleMobile: true
                                    })) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderProductFixed_ButtonCart, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-product-fixed-button-cart")), {
                                                actionButton: addItemCart,
                                                mediaScaleBottom: mediaScaleBottom,
                                                textVisibleMobile: true,
                                                sendingItemToCart: sendingItemToCart,
                                                sizeProps: !activeButtonWeddingList && isClientMobile,
                                                buttonInTheFixedHeader: isClientMobile
                                            })),
                                            activeButtonWeddingList ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ButtonAddProductToWeddingList, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-product-fixed-button-add-product-to-wedding-list")), {
                                                isBlackTheme: isBlackTheme,
                                                actionAddToGift: actionAddToGift,
                                                textVisibleMobile: true,
                                                borderLine: true,
                                                scaleMedia: mediaScaleBottom
                                            })) : null
                                        ]
                                    })
                                }))
                            ]
                        }))
                    ]
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxNav, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-product-fixed-box-nav")), {
                    isBlackTheme: isBlackTheme,
                    children: listItemsMenu === null || listItemsMenu === void 0 ? void 0 : listItemsMenu.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(infra/* ScrollToLink */.Aw, {
                            activeClass: "active",
                            offset: -130,
                            spy: true,
                            to: item === null || item === void 0 ? void 0 : item.idReference,
                            children: (0,application/* capitalizeFirstLetterAndLowercaseRest */.G4p)(item === null || item === void 0 ? void 0 : item.description)
                        }, item === null || item === void 0 ? void 0 : item.idReference);
                    })
                }))
            ]
        }))
    }));
};
/* harmony default export */ var sections_HeaderProductFixed = (HeaderProductFixed);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
;// CONCATENATED MODULE: ./src/screens/Product/sections/ProductSpec/components/FlixMedia/index.tsx




var flixMediaObject = {
    availableBrands: [
        "LG",
        "SAMSUNG",
        "Tramontina"
    ],
    id: "18128"
};
var FlixMedia = function(param) {
    var productModel = param.productModel, productBrand = param.productBrand, distributorCode = param.distributorCode;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(true), isFirstRender = ref[0], setIsFirstRender = ref[1];
    (0,react.useEffect)(function() {
        var ref;
        var scriptElement;
        var ref1 = (0,_sliced_to_array/* default */.Z)(Array.from(document.getElementsByTagName("head")), 1), headID = ref1[0];
        if (isFirstRender) {
            scriptElement = document.createElement("script");
            scriptElement.type = "text/javascript";
            scriptElement.async = true;
            if (flixMediaObject.availableBrands.includes(productBrand || "")) {
                // Lógica para Tramontina
                if (productBrand === "Tramontina") {
                    var flexMediaContent = document.querySelector(".flix-media-content");
                    var tramontinaContent = document.createElement("tramontina-content");
                    tramontinaContent.setAttribute("data-id", "178");
                    tramontinaContent.setAttribute("data-ref-code", String(productModel));
                    tramontinaContent.setAttribute("data-testid", "".concat(productBrand.toLowerCase(), "-content"));
                    flexMediaContent === null || flexMediaContent === void 0 ? void 0 : flexMediaContent.appendChild(tramontinaContent);
                    scriptElement.src = "https://ce.tramontina.com/dist/tramontina-content.js";
                } else {
                    scriptElement.setAttribute("data-flix-distributor", distributorCode);
                    scriptElement.setAttribute("data-flix-language", "br");
                    scriptElement.setAttribute("data-flix-fallback-language", "");
                    scriptElement.setAttribute("data-flix-brand", productBrand || "");
                    scriptElement.setAttribute("data-flix-ean", "");
                    scriptElement.setAttribute("data-flix-mpn", String(productModel));
                    scriptElement.setAttribute("data-flix-inpage", "flix-inpage");
                    scriptElement.setAttribute("data-flix-price", "");
                    scriptElement.src = "//media.flixfacts.com/js/loader.js";
                }
            }
            headID.appendChild(scriptElement);
            setIsFirstRender(false);
            return undefined;
        }
        var removeHeadChild = function() {
            if ((router === null || router === void 0 ? void 0 : router.pathname) !== "/produto/[idProduct]/[nameProduct]") {
                headID.removeChild(scriptElement);
            }
        };
        router === null || router === void 0 ? void 0 : (ref = router.events) === null || ref === void 0 ? void 0 : ref.on("routeChangeStart", removeHeadChild);
        return function() {
            var ref;
            router === null || router === void 0 ? void 0 : (ref = router.events) === null || ref === void 0 ? void 0 : ref.off("routeChangeStart", removeHeadChild);
        };
    }, [
        distributorCode,
        isFirstRender,
        productBrand,
        productModel,
        router === null || router === void 0 ? void 0 : router.events,
        router === null || router === void 0 ? void 0 : router.pathname, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flix-media-content",
        children: ((productBrand === null || productBrand === void 0 ? void 0 : productBrand.toLowerCase()) === "samsung" || (productBrand === null || productBrand === void 0 ? void 0 : productBrand.toLowerCase()) === "lg") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: "ContentFlixMedia",
            "data-testid": "".concat(productBrand.toLowerCase(), "-content"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "flix-inpage",
                "data-testid": "flix-inpage"
            })
        })
    });
};
/* harmony default export */ var components_FlixMedia = (FlixMedia);

;// CONCATENATED MODULE: ./src/screens/Product/sections/ProductSpec/components/StandOut/styles.ts

function StandOut_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    StandOut_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Tag = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Tag",
    componentId: "sc-fa373e15-0"
})(StandOut_styles_templateObject());

;// CONCATENATED MODULE: ./src/screens/Product/sections/ProductSpec/components/StandOut/index.tsx


var StandOut = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
        id: "standoutDivAutomatico"
    });
};
/* harmony default export */ var components_StandOut = (StandOut);

;// CONCATENATED MODULE: ./src/screens/Product/sections/ProductSpec/components/Syndigo/index.tsx


var Syndigo = function(param) {
    var codeInside = param.codeInside;
    (0,react.useEffect)(function() {
        var ref;
        var URL = "https://content.syndigo.com/site/8ef9426f-0b66-fce1-e06c-680274471457/tag.js?cv=";
        var tagScript = document.createElement("script");
        tagScript.type = "text/javascript";
        tagScript.async = true;
        tagScript.src = URL + Math.floor(Date.now() / 86400000);
        var tagPrimaryScript = document.getElementsByTagName("script")[0];
        tagPrimaryScript === null || tagPrimaryScript === void 0 ? void 0 : (ref = tagPrimaryScript.parentNode) === null || ref === void 0 ? void 0 : ref.insertBefore(tagScript, tagPrimaryScript);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.SYNDI = window.SYNDI || [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.SYNDI.push(codeInside);
    }, [
        codeInside
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "syndi_inline"
    });
};
/* harmony default export */ var components_Syndigo = (Syndigo);

;// CONCATENATED MODULE: ./src/screens/Product/sections/ProductSpec/styles.ts

function ProductSpec_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 1.5rem;\n  margin-top: 1.5rem;\n"
    ]);
    ProductSpec_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductSpec_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n"
    ]);
    ProductSpec_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductSpec_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 0.3;\n  @media ",
        " {\n    flex: 1;\n  }\n\n  @media ",
        " {\n    margin-top: 0.5rem;\n  }\n"
    ]);
    ProductSpec_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProductSpec_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 1rem;\n  ",
        "\n\n  @media ",
        " {\n    flex-direction: column;\n  }\n"
    ]);
    ProductSpec_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ProductSpec_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 1rem;\n"
    ]);
    ProductSpec_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ProductSpec_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin-top: 0.5rem;\n"
    ]);
    ProductSpec_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ProductSpec_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin-top: 0.5rem;\n  font-size: 1.3rem;\n  color: ",
        ";\n\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  overflow-wrap: anywhere;\n"
    ]);
    ProductSpec_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ProductSpec_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n\n  font-size: ",
        ";\n\n  padding: 1rem 0;\n  font-weight: 500;\n  border-bottom: thin solid\n    ",
        ";\n"
    ]);
    ProductSpec_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ProductSpec_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 2rem;\n  padding: 0.5rem 1rem;\n  width: 50%;\n  display: ",
        ";\n  flex-direction: column;\n  font-size: ",
        ";\n"
    ]);
    ProductSpec_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function ProductSpec_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  :nth-child(",
        ") {\n    background-color: ",
        ";\n  }\n  ",
        ":first-child {\n    font-weight: 700;\n    color: ",
        ";\n  }\n  ",
        ":last-child {\n    color: ",
        ";\n  }\n"
    ]);
    ProductSpec_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function ProductSpec_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ProductSpec_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function ProductSpec_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 1.2rem;\n  margin-top: 0.5rem;\n"
    ]);
    ProductSpec_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function ProductSpec_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  background-color: ",
        ";\n  border-radius: 2px;\n  border: thin solid\n    ",
        ";\n  border-radius: 8px;\n  padding: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    ProductSpec_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function ProductSpec_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  background-color: ",
        ";\n  border: thin solid\n    ",
        ";\n  border-radius: 8px;\n  padding: 1rem;\n  margin-top: 1rem;\n"
    ]);
    ProductSpec_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function ProductSpec_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  border-radius: 2px;\n  border: thin solid\n    ",
        ";\n  border-radius: 8px;\n  padding: 1rem;\n  background-color: ",
        ";\n"
    ]);
    ProductSpec_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function ProductSpec_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-bottom: 1.5rem;\n  font-size: ",
        ";\n  font-weight: 500;\n"
    ]);
    ProductSpec_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function ProductSpec_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    ProductSpec_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function ProductSpec_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-bottom: 1.5rem;\n  font-size: 1.3rem;\n"
    ]);
    ProductSpec_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function ProductSpec_styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.15rem;\n  font-weight: 500;\n  margin-left: 0.5rem;\n  color: ",
        ";\n"
    ]);
    ProductSpec_styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function ProductSpec_styles_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 1rem;\n"
    ]);
    ProductSpec_styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function ProductSpec_styles_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 0;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    ProductSpec_styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function styles_templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n\n  @media ",
        " {\n    font-size: 1.5rem;\n    padding-left: ",
        ";\n  }\n"
    ]);
    styles_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function styles_templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  box-shadow: 0px 3px 6px ",
        ";\n  padding: ",
        ";\n  -webkit-tap-highlight-color: transparent !important;\n\n  background: ",
        ";\n\n  border: thin solid\n    ",
        ";\n\n  border-radius: 2px;\n\n  &:hover {\n    background-color: initial;\n  }\n"
    ]);
    styles_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function styles_templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styles_templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function styles_templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styles_templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function styles_templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styles_templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function styles_templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styles_templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function styles_templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styles_templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function styles_templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styles_templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function styles_templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styles_templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}


var ProductSpec_styles_Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__Container",
    componentId: "sc-f38b2ed2-0"
})(ProductSpec_styles_templateObject());
var SectionInfo = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__SectionInfo",
    componentId: "sc-f38b2ed2-1"
})(ProductSpec_styles_templateObject1());
var SectionSub = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__SectionSub",
    componentId: "sc-f38b2ed2-2"
})(ProductSpec_styles_templateObject2(), ui.theme.device.desktopFirst.tablet, ui.theme.device.desktopFirst.mobileXL);
var ContainerInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ContainerInfo",
    componentId: "sc-f38b2ed2-3"
})(ProductSpec_styles_templateObject3(), function(param) {
    var Collapse = param.Collapse;
    return Collapse ? "\n        display: none;\n      " : "\n        display: flex;";
}, ui.theme.device.desktopFirst.tablet);
var BoxAlign = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxAlign",
    componentId: "sc-f38b2ed2-4"
})(ProductSpec_styles_templateObject4());
var Group = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Group",
    componentId: "sc-f38b2ed2-5"
})(ProductSpec_styles_templateObject5());
var LinkPDF = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    displayName: "styles__LinkPDF",
    componentId: "sc-f38b2ed2-6"
})(ProductSpec_styles_templateObject6(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday[300]) : "".concat(ui.theme.colors.blackFriday[480]);
});
var TitleBlockTable = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "styles__TitleBlockTable",
    componentId: "sc-f38b2ed2-7"
})(ProductSpec_styles_templateObject7(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.neutral.white) : "".concat(ui.theme.colors.blackFriday[115]);
}, function(param) {
    var isClientMobile = param.isClientMobile, isClientTablet = param.isClientTablet;
    return isClientMobile ? "1.3rem" : isClientTablet ? "1.3rem" : "1.6rem";
}, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday[100]) : "".concat(ui.theme.colors.blackFriday[33]);
});
var CellTable = styled_components_browser_esm/* default.td.withConfig */.ZP.td.withConfig({
    displayName: "styles__CellTable",
    componentId: "sc-f38b2ed2-8"
})(ProductSpec_styles_templateObject8(), function(param) {
    var isClientMobile = param.isClientMobile, isClientTablet = param.isClientTablet;
    return isClientMobile ? "flex" : isClientTablet ? "flex" : "";
}, function(param) {
    var isClientMobile = param.isClientMobile, isClientTablet = param.isClientTablet;
    return isClientMobile ? "1.2rem" : isClientTablet ? "1.2rem" : "initial";
});
var styles_LineTable = styled_components_browser_esm/* default.tr.withConfig */.ZP.tr.withConfig({
    displayName: "styles__LineTable",
    componentId: "sc-f38b2ed2-9"
})(ProductSpec_styles_templateObject9(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "odd" : "even";
}, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday[150]) : "".concat(ui.theme.colors.blackFriday[5]);
}, CellTable, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.neutral.white) : "".concat(ui.theme.colors.blackFriday[115]);
}, CellTable, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.neutral.white) : "".concat(ui.theme.colors.blackFriday[80]);
});
var BodyTable = styled_components_browser_esm/* default.tbody.withConfig */.ZP.tbody.withConfig({
    displayName: "styles__BodyTable",
    componentId: "sc-f38b2ed2-10"
})(ProductSpec_styles_templateObject10());
var Table = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    displayName: "styles__Table",
    componentId: "sc-f38b2ed2-11"
})(ProductSpec_styles_templateObject11());
var BoxSpecs = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__BoxSpecs",
    componentId: "sc-f38b2ed2-12"
})(ProductSpec_styles_templateObject12(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday[175]) : "".concat(ui.theme.colors.blackFriday.white);
}, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday[100]) : "".concat(ui.theme.colors.blackFriday[30]);
}, function(param) {
    var isClientMobile = param.isClientMobile, isClientTablet = param.isClientTablet;
    return isClientMobile ? "0.1rem 1rem" : isClientTablet ? "0.1rem 1rem" : "2rem 1rem";
}, function(param) {
    var isClientMobile = param.isClientMobile, isClientTablet = param.isClientTablet;
    return isClientMobile ? "-0.9rem" : isClientTablet ? "-0.9rem" : "initial";
});
var BoxLinks = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxLinks",
    componentId: "sc-f38b2ed2-13"
})(ProductSpec_styles_templateObject13(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday[175]) : "".concat(ui.theme.colors.blackFriday.white);
}, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday[100]) : "".concat(ui.theme.colors.blackFriday[30]);
});
var BoxDimension = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxDimension",
    componentId: "sc-f38b2ed2-14"
})(ProductSpec_styles_templateObject14(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday[100]) : "".concat(ui.theme.colors.blackFriday[30]);
}, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday[175]) : "".concat(ui.theme.colors.blackFriday.white);
});
var ProductSpec_styles_Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "styles__Title",
    componentId: "sc-f38b2ed2-15"
})(ProductSpec_styles_templateObject15(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday.white) : "".concat(ui.theme.colors.neutral[520]);
}, ui.theme.typography.fontSize.md.x3);
var Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Row",
    componentId: "sc-f38b2ed2-16"
})(ProductSpec_styles_templateObject16());
var SubtitleDimension = styled_components_browser_esm/* default.strong.withConfig */.ZP.strong.withConfig({
    displayName: "styles__SubtitleDimension",
    componentId: "sc-f38b2ed2-17"
})(ProductSpec_styles_templateObject17(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.neutral.white) : "".concat(ui.theme.colors.blackFriday[115]);
});
var Value = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__Value",
    componentId: "sc-f38b2ed2-18"
})(ProductSpec_styles_templateObject18(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.neutral.white) : "".concat(ui.theme.colors.blackFriday.black);
});
var Margin1 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Margin1",
    componentId: "sc-f38b2ed2-19"
})(ProductSpec_styles_templateObject19());
var styles_AggregatorCustom = (0,styled_components_browser_esm/* default */.ZP)(ui.Aggregator).withConfig({
    displayName: "styles__AggregatorCustom",
    componentId: "sc-f38b2ed2-20"
})(ProductSpec_styles_templateObject20());
var styles_TextCustom = (0,styled_components_browser_esm/* default */.ZP)(ui.Text).withConfig({
    displayName: "styles__TextCustom",
    componentId: "sc-f38b2ed2-21"
})(styles_templateObject21(), ui.theme.colors.neutral[520], ui.theme.typography.fontSize.md.x3, ui.theme.typography.fontWeight[500], function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday.white) : "".concat(ui.theme.colors.neutral[520]);
}, ui.theme.device.desktopFirst.tablet, ui.theme.space["x2.5"]);
var styles_ButtonCustom = (0,styled_components_browser_esm/* default */.ZP)(ui.Button).withConfig({
    displayName: "styles__ButtonCustom",
    componentId: "sc-f38b2ed2-22"
})(styles_templateObject22(), ui.theme.colors.neutral["999-opacity-10"], ui.theme.space.x1, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday[175]) : "".concat(ui.theme.colors.neutral.white);
}, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday[100]) : "".concat(ui.theme.colors.blackFriday[30]);
});
var DimensionArrowWidth = (0,styled_components_browser_esm/* default */.ZP)(ui.ArrowWidth).withConfig({
    displayName: "styles__DimensionArrowWidth",
    componentId: "sc-f38b2ed2-23"
})(styles_templateObject23());
var DimensionArrowHeight = (0,styled_components_browser_esm/* default */.ZP)(ui.Truck).withConfig({
    displayName: "styles__DimensionArrowHeight",
    componentId: "sc-f38b2ed2-24"
})(styles_templateObject24());
var DimensionArrowLength = (0,styled_components_browser_esm/* default */.ZP)(ui.ArrowLength).withConfig({
    displayName: "styles__DimensionArrowLength",
    componentId: "sc-f38b2ed2-25"
})(styles_templateObject25());
var DimensionWeightIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.WeighIcon).withConfig({
    displayName: "styles__DimensionWeightIcon",
    componentId: "sc-f38b2ed2-26"
})(styles_templateObject26());
var PDFArrow = (0,styled_components_browser_esm/* default */.ZP)(ui.ArrowRight).withConfig({
    displayName: "styles__PDFArrow",
    componentId: "sc-f38b2ed2-27"
})(styles_templateObject27());
var CollapseArrowUp = (0,styled_components_browser_esm/* default */.ZP)(ui.ArrowUp).withConfig({
    displayName: "styles__CollapseArrowUp",
    componentId: "sc-f38b2ed2-28"
})(styles_templateObject28());
var CollapseArrowDown = (0,styled_components_browser_esm/* default */.ZP)(ui.ArrowDown).withConfig({
    displayName: "styles__CollapseArrowDown",
    componentId: "sc-f38b2ed2-29"
})(styles_templateObject29());

;// CONCATENATED MODULE: ./src/screens/Product/sections/ProductSpec/index.tsx









var ProductSpec = function(param) {
    var idProduct = param.idProduct, brand = param.brand, idSection = param.idSection, hasProductSpecCalled = param.hasProductSpecCalled, handleSize = param.handleSize, handleModel = param.handleModel, isBlackTheme = param.isBlackTheme, bareanId13 = param.bareanId13;
    var ref = implementations/* catalogApi.getProductDimension */.dZ.getProductDimension(idProduct || "", Boolean(idProduct)), dimensionData = ref.data;
    var ref1 = implementations/* catalogApi.getProductUseLinks */.dZ.getProductUseLinks(idProduct || "", Boolean(idProduct)), linksData = ref1.data;
    var ref2 = implementations/* catalogApi.getProductSpecs */.dZ.getProductSpecs(idProduct || "", Boolean(idProduct)), tmp = ref2.data, specsData = tmp === void 0 ? [] : tmp, isLoading = ref2.isLoading;
    var ref3 = (0,react.useState)(), modelProduct = ref3[0], setModelProduct = ref3[1];
    var ref4 = (0,react.useState)(false), isModelValueLoaded = ref4[0], setIsModelValueLoaded = ref4[1];
    var ref5 = (0,react.useState)(), sizeProduct = ref5[0], setSizeProduct = ref5[1];
    var ref6 = (0,react.useState)(false), isSizeValueLoaded = ref6[0], setIsSizeValueLoaded = ref6[1];
    var buildUrlUsefulLinks = (0,react.useCallback)(function(document) {
        return decodeURIComponent((document === null || document === void 0 ? void 0 : document.s3Url) || "https://fcx-s3-fercos-backoffice.ferreiracosta.com/documento_produto/".concat(document.codeCD, "/").concat(document.sequenceNumber, "_").concat(document.imageTypeCode, "_").concat(document.codeCD, ".pdf"));
    }, []);
    (0,react.useEffect)(function() {
        if (specsData && (specsData === null || specsData === void 0 ? void 0 : specsData.length) > 0) {
            var REF_MODEL_CODE = specsData === null || specsData === void 0 ? void 0 : specsData.find(function(item) {
                return item.id === 0;
            });
            var REF_MODEL = REF_MODEL_CODE === null || REF_MODEL_CODE === void 0 ? void 0 : REF_MODEL_CODE.specs.find(function(item) {
                return item.name === "Modelo";
            });
            setModelProduct(REF_MODEL === null || REF_MODEL === void 0 ? void 0 : REF_MODEL.value);
            setIsModelValueLoaded(true);
            var REF_SIZE_CODE = specsData === null || specsData === void 0 ? void 0 : specsData[1];
            var REF_SIZE = REF_SIZE_CODE === null || REF_SIZE_CODE === void 0 ? void 0 : REF_SIZE_CODE.specs.find(function(item) {
                return item.name === "Tamanho";
            });
            setSizeProduct(REF_SIZE === null || REF_SIZE === void 0 ? void 0 : REF_SIZE.value);
            setIsSizeValueLoaded(true);
        }
    }, [
        specsData,
        brand
    ]);
    (0,react.useEffect)(function() {
        if (modelProduct && handleModel) {
            handleModel(modelProduct);
        }
    }, [
        handleModel,
        modelProduct
    ]);
    (0,react.useEffect)(function() {
        if (sizeProduct && handleSize) {
            handleSize(sizeProduct);
        }
    }, [
        handleSize,
        sizeProduct
    ]);
    (0,react.useEffect)(function() {
        if (isLoading === false && isModelValueLoaded && isSizeValueLoaded) {
            hasProductSpecCalled(isLoading);
        }
    }, [
        hasProductSpecCalled,
        isLoading,
        isModelValueLoaded,
        isSizeValueLoaded
    ]);
    var isClientMobile = (0,application/* useAppContext */.bp4)().isClientMobile;
    var isClientTablet = (0,application/* useAppContext */.bp4)().isClientTablet;
    var ref7 = (0,react.useState)(false), isProductSpecsCollapsed = ref7[0], setIsProductSpecsCollapsed = ref7[1];
    var toggleShowCollapsible = function() {
        setIsProductSpecsCollapsed(function(state) {
            return !state;
        });
    };
    var shouldShowBoxSpecs = isClientMobile ? isProductSpecsCollapsed : true;
    var iconsColor = isBlackTheme ? ui.theme.colors.blackFriday.white : ui.theme.colors.neutral[550];
    var weigthIconColor = isBlackTheme ? ui.theme.colors.blackFriday.white : ui.theme.colors.blackFriday.black;
    var arrowColor = isBlackTheme ? ui.theme.colors.blackFriday.white : ui.theme.colors.primary[200];
    var PDFArrowColor = isBlackTheme ? ui.theme.colors.blackFriday[300] : ui.theme.colors.blackFriday[480];
    var souldFlixMediaAppear = modelProduct && brand !== "Tramontina" || bareanId13 && brand === "Tramontina";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductSpec_styles_Container, {
        id: idSection,
        children: [
            isClientTablet && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_AggregatorCustom, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_ButtonCustom, {
                    onClick: toggleShowCollapsible,
                    isBlackTheme: isBlackTheme,
                    "data-testid": "product-specs-button",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_TextCustom, {
                            isClientTablet: isClientTablet,
                            isClientMobile: isClientMobile,
                            isBlackTheme: isBlackTheme,
                            "data-testid": "product-specs-button-text",
                            children: "Ficha t\xe9cnica"
                        }),
                        isProductSpecsCollapsed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapseArrowUp, {
                            color: arrowColor
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapseArrowDown, {
                            color: arrowColor
                        })
                    ]
                })
            }),
            !isClientTablet && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSpec_styles_Title, {
                isBlackTheme: isBlackTheme,
                children: "Ficha t\xe9cnica"
            }),
            souldFlixMediaAppear ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FlixMedia, {
                productModel: brand === "Tramontina" ? bareanId13 : modelProduct,
                productBrand: brand,
                distributorCode: flixMediaObject.id
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Syndigo, {
                codeInside: idProduct
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_StandOut, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerInfo, {
                Collapse: isClientTablet && !isProductSpecsCollapsed,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionInfo, {
                        children: shouldShowBoxSpecs && /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxSpecs, {
                            isClientMobile: isClientMobile,
                            isClientTablet: isClientTablet,
                            isBlackTheme: isBlackTheme,
                            children: (specsData === null || specsData === void 0 ? void 0 : specsData.length) ? specsData === null || specsData === void 0 ? void 0 : specsData.map(function(item, index) {
                                var ref;
                                var currentIndex = index;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleBlockTable, {
                                            isClientMobile: isClientMobile,
                                            isClientTablet: isClientTablet,
                                            isBlackTheme: isBlackTheme,
                                            children: item === null || item === void 0 ? void 0 : item.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Table, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyTable, {
                                                children: item === null || item === void 0 ? void 0 : (ref = item.specs) === null || ref === void 0 ? void 0 : ref.map(function(itemSpec) {
                                                    var ref;
                                                    return (itemSpec === null || itemSpec === void 0 ? void 0 : itemSpec.value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_LineTable, {
                                                        isBlackTheme: isBlackTheme,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CellTable, {
                                                                isClientMobile: isClientMobile,
                                                                isClientTablet: isClientTablet,
                                                                children: itemSpec === null || itemSpec === void 0 ? void 0 : itemSpec.name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CellTable, {
                                                                isClientMobile: isClientMobile,
                                                                isClientTablet: isClientTablet,
                                                                children: "".concat(itemSpec === null || itemSpec === void 0 ? void 0 : itemSpec.value, " ").concat((itemSpec === null || itemSpec === void 0 ? void 0 : (ref = itemSpec.unitMeasurement) === null || ref === void 0 ? void 0 : ref.includes("kwh")) ? itemSpec === null || itemSpec === void 0 ? void 0 : itemSpec.unitMeasurement : "")
                                                            })
                                                        ]
                                                    }, "".concat(itemSpec === null || itemSpec === void 0 ? void 0 : itemSpec.id, "-").concat(itemSpec === null || itemSpec === void 0 ? void 0 : itemSpec.name));
                                                })
                                            })
                                        })
                                    ]
                                }, "".concat(item === null || item === void 0 ? void 0 : item.id, "-").concat(currentIndex));
                            }) : null
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionSub, {
                        isClientMobile: isClientMobile,
                        isClientTablet: isClientTablet,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxDimension, {
                                isClientMobile: isClientMobile,
                                isClientTablet: isClientTablet,
                                Collapse: isClientTablet && !isProductSpecsCollapsed,
                                isBlackTheme: isBlackTheme,
                                children: (dimensionData === null || dimensionData === void 0 ? void 0 : dimensionData.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleBlockTable, {
                                            isClientMobile: isClientMobile,
                                            isClientTablet: isClientTablet,
                                            isBlackTheme: isBlackTheme,
                                            children: "Dimens\xf5es do produto"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Margin1, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxAlign, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DimensionArrowWidth, {
                                                            width: 20,
                                                            height: 20,
                                                            color: iconsColor
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubtitleDimension, {
                                                            isBlackTheme: isBlackTheme,
                                                            children: "Largura:"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Value, {
                                                    isBlackTheme: isBlackTheme,
                                                    children: [
                                                        (0,application/* formatNumber */.ufS)((dimensionData === null || dimensionData === void 0 ? void 0 : dimensionData.width) || 0),
                                                        " cm"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxAlign, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DimensionArrowHeight, {
                                                            width: 18,
                                                            height: 18,
                                                            color: iconsColor
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubtitleDimension, {
                                                            isBlackTheme: isBlackTheme,
                                                            children: "Altura:"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Value, {
                                                    isBlackTheme: isBlackTheme,
                                                    children: [
                                                        (0,application/* formatNumber */.ufS)((dimensionData === null || dimensionData === void 0 ? void 0 : dimensionData.height) || 0),
                                                        " cm"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxAlign, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DimensionArrowLength, {
                                                            width: 18,
                                                            height: 18,
                                                            color: iconsColor
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubtitleDimension, {
                                                            isBlackTheme: isBlackTheme,
                                                            children: "Profundidade:"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Value, {
                                                    isBlackTheme: isBlackTheme,
                                                    children: [
                                                        (0,application/* formatNumber */.ufS)((dimensionData === null || dimensionData === void 0 ? void 0 : dimensionData.length) || 0),
                                                        " cm"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxAlign, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DimensionWeightIcon, {
                                                            width: 16,
                                                            height: 16,
                                                            color: weigthIconColor
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubtitleDimension, {
                                                            isBlackTheme: isBlackTheme,
                                                            children: "Peso:"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Value, {
                                                    isBlackTheme: isBlackTheme,
                                                    children: [
                                                        (0,application/* formatNumber */.ufS)((dimensionData === null || dimensionData === void 0 ? void 0 : dimensionData.weightUnity) || 0),
                                                        " kg"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxAlign, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DimensionWeightIcon, {
                                                            width: 16,
                                                            height: 16,
                                                            color: weigthIconColor
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubtitleDimension, {
                                                            isBlackTheme: isBlackTheme,
                                                            children: "Peso Embalado:"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Value, {
                                                    isBlackTheme: isBlackTheme,
                                                    children: [
                                                        (0,application/* formatNumber */.ufS)((dimensionData === null || dimensionData === void 0 ? void 0 : dimensionData.grossWeight) || 0),
                                                        " kg"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }) : null
                            }),
                            (linksData === null || linksData === void 0 ? void 0 : linksData.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxLinks, {
                                isClientTablet: isClientTablet,
                                isClientMobile: isClientMobile,
                                Collapse: isClientTablet && !isProductSpecsCollapsed,
                                isBlackTheme: isBlackTheme,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group, {
                                    isClientMobile: isClientMobile,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleBlockTable, {
                                            isClientMobile: isClientMobile,
                                            isClientTablet: isClientTablet,
                                            isBlackTheme: isBlackTheme,
                                            children: "Links \xfateis"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Margin1, {}),
                                        linksData === null || linksData === void 0 ? void 0 : linksData.map(function(document) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(LinkPDF, {
                                                target: "_blank",
                                                href: buildUrlUsefulLinks(document),
                                                isBlackTheme: isBlackTheme,
                                                children: [
                                                    document === null || document === void 0 ? void 0 : document.linkName,
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PDFArrow, {
                                                        height: 25,
                                                        color: PDFArrowColor
                                                    })
                                                ]
                                            }, "".concat(document.codeCD, "#").concat(document.sequenceNumber));
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var sections_ProductSpec = (ProductSpec);

;// CONCATENATED MODULE: ./src/screens/Product/Product.ui.tsx



















var ProductPageUI = function(param) {
    var blackFridayTheme = param.blackFridayTheme, cartId = param.cartId, hasChangesInClientBranchFromRegionIdParam = param.hasChangesInClientBranchFromRegionIdParam, siteUrl = param.siteUrl, dataProduct = param.dataProduct, productPrices = param.productPrices, activeWeddingList = param.activeWeddingList, branchId = param.branchId, productId = param.productId;
    var ref, ref1, ref2, ref3;
    var setShowSaleChatbot = (0,application/* useChatbot */.dpv)((0,application/* useShallow */.NL6)(function(state) {
        return {
            setShowSaleChatbot: state.setShowSaleChatbot
        };
    })).setShowSaleChatbot;
    var router = (0,next_router.useRouter)();
    var accessToken = implementations/* cookie.getCookie */.pR.getCookie({
        name: cookieAccessToken
    });
    var setDefaultBranchLocation = (0,application/* useBranchLocation */.vKz)().setDefaultBranchLocation;
    var cart = (0,application/* useCartContext */.iQs)();
    var ref4 = (0,react.useState)(), dataProductDetails = ref4[0], setDataProduct = ref4[1];
    var ref5 = (0,react.useState)(), packageCurrentState = ref5[0], setPackageCurrent = ref5[1];
    var ref6 = (0,react.useState)(false), isVoltageModalOpen = ref6[0], setIsVoltageModalOpen = ref6[1];
    var ref7 = (0,react.useState)(true), firstRender = ref7[0], setFirstRender = ref7[1];
    var ref8 = (0,react.useState)(false), isWeddingListPopUpOpened = ref8[0], setIsWeddingListPopUpOpened = ref8[1];
    var ref9 = (0,react.useState)(false), weddingListModalError = ref9[0], setWeddingListModalError = ref9[1];
    var ref10 = (0,react.useState)(1), quantityItems = ref10[0], setQuantityItems = ref10[1];
    var ref11 = (0,react.useState)(), limitQuantityItem = ref11[0], setLimitQuantityItem = ref11[1];
    var ref12 = (0,react.useState)(false), sendingItemToCart = ref12[0], setSendingItemToCart = ref12[1];
    var ref13 = (0,react.useState)(false), isLoadingOpen = ref13[0], setIsLoadingOpen = ref13[1];
    var addProductsToWeddingList = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var response, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    if (!dataProduct || quantityItems === 0 || !(activeWeddingList === null || activeWeddingList === void 0 ? void 0 : activeWeddingList.id)) {
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        implementations/* weddingGiftListApi.addProductsToWeddingList */._6.addProductsToWeddingList(accessToken, [
                            {
                                packaging: (dataProduct === null || dataProduct === void 0 ? void 0 : dataProduct.packingLevel) || 0,
                                productId: (dataProduct === null || dataProduct === void 0 ? void 0 : dataProduct.id) || "",
                                listId: Number(activeWeddingList === null || activeWeddingList === void 0 ? void 0 : activeWeddingList.id),
                                listEnviroment: LIST_ENVIRONMENT_DEFAULT,
                                productQuantity: quantityItems,
                                branchId: branchId
                            }
                        ])
                    ];
                case 1:
                    response = _state.sent();
                    if (response === null || response === void 0 ? void 0 : response.isValid) {
                        setIsWeddingListPopUpOpened(true);
                    } else {
                        setWeddingListModalError(true);
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    implementations/* appMonitoringClient.captureException */.pE.captureException(error, {
                        level: "error"
                    });
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        dataProduct,
        quantityItems,
        activeWeddingList === null || activeWeddingList === void 0 ? void 0 : activeWeddingList.id,
        accessToken,
        branchId, 
    ]);
    var price = (packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.spotPrice) || ((packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.salePrice) !== (packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.priceList) ? packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.salePrice : packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.priceList);
    var ref14 = (0,react.useState)(false), clientIsWaitingActionAfterClickOnSendItemToCartButton = ref14[0], setClientIsWaitingActionAfterClickOnSendItemToCartButton = ref14[1];
    var sendItemToCart = (0,react.useCallback)(function() {
        setClientIsWaitingActionAfterClickOnSendItemToCartButton(false);
        var dataAnalytic = function() {
            if (!dataProduct) {
                return;
            }
            implementations/* gtag.addToCart */.SX.addToCart(price, dataProduct);
        };
        var VALIDATE_VOLTAGE = (dataProductDetails === null || dataProductDetails === void 0 ? void 0 : dataProductDetails.voltage) !== " " && Boolean(dataProductDetails === null || dataProductDetails === void 0 ? void 0 : dataProductDetails.voltage);
        if (VALIDATE_VOLTAGE && !isVoltageModalOpen) {
            setIsVoltageModalOpen(true);
            setIsLoadingOpen(false);
            setSendingItemToCart(false);
            return;
        }
        setSendingItemToCart(true);
        setIsLoadingOpen(true);
        cart.addProductToControlledCart({
            productId: (dataProduct === null || dataProduct === void 0 ? void 0 : dataProduct.id) || "",
            quantity: quantityItems,
            package: (packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.packingLevel) || 0,
            packingQuantity: (packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.packingQuantity) || 0,
            sellerId: (packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.sellerId) || 0,
            cartId: Number(cartId),
            price: packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.salePrice
        }).then(function(res) {
            setIsVoltageModalOpen(false);
            var response = res;
            if (response === null || response === void 0 ? void 0 : response.limitTotalItens) {
                setLimitQuantityItem(Number(response.limitTotalItens));
                setSendingItemToCart(false);
                setIsLoadingOpen(false);
                return;
            }
            if (response === null || response === void 0 ? void 0 : response.hasError) {
                setSendingItemToCart(false);
                setIsLoadingOpen(false);
                return;
            }
            router.push("/checkout/meu-carrinho");
            setSendingItemToCart(false);
            dataAnalytic();
        }).catch(function() {
            setSendingItemToCart(false);
            setIsLoadingOpen(false);
        });
    }, [
        cart,
        cartId,
        dataProduct,
        dataProductDetails === null || dataProductDetails === void 0 ? void 0 : dataProductDetails.voltage,
        isVoltageModalOpen,
        packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.packingLevel,
        packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.packingQuantity,
        packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.salePrice,
        packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.sellerId,
        price,
        quantityItems,
        router, 
    ]);
    (0,react.useEffect)(function() {
        if ((packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.packingQuantity) && clientIsWaitingActionAfterClickOnSendItemToCartButton) {
            sendItemToCart();
        }
    }, [
        clientIsWaitingActionAfterClickOnSendItemToCartButton,
        packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.packingQuantity,
        sendItemToCart, 
    ]);
    var handleSendItemToCart = (0,react.useCallback)(function(packingQuantity) {
        setClientIsWaitingActionAfterClickOnSendItemToCartButton(true);
        setSendingItemToCart(true);
        if (packingQuantity) {
            sendItemToCart();
        }
    }, [
        sendItemToCart
    ]);
    (0,react.useEffect)(function() {
        if (dataProduct) {
            setDataProduct(dataProduct);
        }
    }, [
        dataProduct,
        productId
    ]);
    (0,react.useLayoutEffect)(function() {
        if (!Number.isNaN(branchId)) {
            setDefaultBranchLocation(String(branchId));
        }
    }, [
        branchId,
        setDefaultBranchLocation
    ]);
    var emitEvent = (0,application/* useWebSocket */.sOn)().emitEvent;
    var handleHasChangesInClientBranchFromRegionIdParam = (0,react.useCallback)(function(hasChanges, newBranchId) {
        if (hasChanges) {
            var currentClientLocation = (0,application/* getClientLocationDetails */.tKK)(implementations/* cookie */.pR);
            emitEvent("branchChanged", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentClientLocation), {
                clientBranchId: newBranchId,
                clientZipCode: ""
            }));
            implementations/* cookie.setCookie */.pR.setCookie({
                name: cookieBranchLocationStr,
                value: String(branchId)
            });
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.removeItem(keyZipCodeStr);
        }
    }, [
        emitEvent,
        branchId
    ]);
    (0,react.useEffect)(function() {
        if (dataProduct && firstRender && productPrices) {
            var ref, ref1;
            implementations/* gtag.viewItem */.SX.viewItem((productPrices === null || productPrices === void 0 ? void 0 : (ref = productPrices[0]) === null || ref === void 0 ? void 0 : ref.spotPrice) || (productPrices === null || productPrices === void 0 ? void 0 : (ref1 = productPrices[0]) === null || ref1 === void 0 ? void 0 : ref1.salePrice), dataProduct);
            implementations/* crm.pageObject */.XE.pageObject("Product");
            handleHasChangesInClientBranchFromRegionIdParam(hasChangesInClientBranchFromRegionIdParam, branchId);
            setFirstRender(false);
        }
    }, [
        branchId,
        dataProduct,
        firstRender,
        handleHasChangesInClientBranchFromRegionIdParam,
        hasChangesInClientBranchFromRegionIdParam,
        productPrices, 
    ]);
    var breadcrumbItems = (0,application/* getProductBreadcrumbItems */.COg)(dataProduct);
    var ref15 = (0,application/* useAppContext */.bp4)(), isClientMobile = ref15.isClientMobile, setPageThemeMap = ref15.setPageThemeMap;
    // Refatorar renderização do componente de ProductSpec para lógica do Insider Object.
    var ref16 = (0,react.useState)(), productSize = ref16[0], setProductSize = ref16[1];
    var ref17 = (0,react.useState)(), productModel = ref17[0], setProductModel = ref17[1];
    var ref18 = (0,react.useState)(true), firstRenderInsiderObjectProduct = ref18[0], setFirstRenderInsiderObjectProduct = ref18[1];
    var ref19 = (0,react.useState)(true), hasCalledProductSpecs = ref19[0], setHasCalledProductSpecs = ref19[1];
    var taxonomy = breadcrumbItems === null || breadcrumbItems === void 0 ? void 0 : (ref = breadcrumbItems.items) === null || ref === void 0 ? void 0 : ref.common.map(function(item) {
        return item.description;
    });
    var selectedProductColor = dataProduct === null || dataProduct === void 0 ? void 0 : (ref1 = dataProduct.productFamilies) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.families.find(function(item) {
        return item.selectedValue;
    });
    var handleSize = function(size) {
        setProductSize(size);
    };
    var handleModel = function(model) {
        setProductModel(model);
    };
    var hasProductSpecCalled = function(value) {
        setHasCalledProductSpecs(value);
    };
    (0,react.useEffect)(function() {
        setPageThemeMap(function(currentPageThemeMap) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentPageThemeMap), {
                product: (blackFridayTheme === null || blackFridayTheme === void 0 ? void 0 : blackFridayTheme.isBlackTheme) ? "black" : "default"
            });
        });
    }, [
        blackFridayTheme,
        setPageThemeMap
    ]);
    (0,react.useEffect)(function() {
        var regexToRemoveTheFirstSlash = /^\/(.*)/;
        if (firstRenderInsiderObjectProduct && !hasCalledProductSpecs && dataProduct && taxonomy && productPrices) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
            var productCrmProps = {
                product_id: dataProduct === null || dataProduct === void 0 ? void 0 : dataProduct.id,
                name: dataProduct === null || dataProduct === void 0 ? void 0 : dataProduct.description,
                taxonomy: taxonomy === null || taxonomy === void 0 ? void 0 : taxonomy.slice(0, 3),
                url: "".concat(siteUrl).concat(router.asPath.replace(regexToRemoveTheFirstSlash, "$1")),
                image_url: ((ref1 = dataProduct === null || dataProduct === void 0 ? void 0 : (ref = dataProduct.mediaLinks) === null || ref === void 0 ? void 0 : ref.find(function(link) {
                    return link.isDefault && link.linkType === "IMAGEM";
                })) === null || ref1 === void 0 ? void 0 : ref1.imageUrl) || "",
                price: (packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.priceList) || 0,
                currency: "BRL",
                color: (selectedProductColor === null || selectedProductColor === void 0 ? void 0 : (ref2 = selectedProductColor.color) === null || ref2 === void 0 ? void 0 : ref2.name) || "",
                voucherName: (dataProduct === null || dataProduct === void 0 ? void 0 : (ref3 = dataProduct.coupons) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.couponName) || "",
                size: productSize || "",
                salePrice: (packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.salePrice) || (packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.priceList) || 0,
                spotPrice: (packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.spotPrice) || (packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.salePrice) || 0,
                voucherDiscountPercentage: (dataProduct === null || dataProduct === void 0 ? void 0 : (ref5 = dataProduct.coupons) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.discountPercentage) || 0,
                voucherDiscountValue: (dataProduct === null || dataProduct === void 0 ? void 0 : (ref7 = dataProduct.coupons) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[0]) === null || ref8 === void 0 ? void 0 : ref8.discountValue) || 0,
                product_tag: (dataProduct === null || dataProduct === void 0 ? void 0 : (ref9 = dataProduct.tag) === null || ref9 === void 0 ? void 0 : ref9.title) || "",
                branch_id: branchId.toString(),
                model: productModel || "",
                brand: (dataProduct === null || dataProduct === void 0 ? void 0 : dataProduct.brand) || ""
            };
            implementations/* crm.productObject */.XE.productObject(productCrmProps);
            // crm.reinitializeTag();
            setFirstRenderInsiderObjectProduct(false);
        }
    }, [
        branchId,
        dataProduct,
        firstRenderInsiderObjectProduct,
        hasCalledProductSpecs,
        packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.priceList,
        packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.salePrice,
        packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.spotPrice,
        productModel,
        productPrices,
        productSize,
        router.asPath,
        selectedProductColor === null || selectedProductColor === void 0 ? void 0 : (ref3 = selectedProductColor.color) === null || ref3 === void 0 ? void 0 : ref3.name,
        siteUrl,
        taxonomy, 
    ]);
    var getImageUrl = function() {
        var mediaLinks = dataProduct === null || dataProduct === void 0 ? void 0 : dataProduct.mediaLinks;
        if (mediaLinks) {
            var imageLink = mediaLinks.find(function(link) {
                return link.linkType === "IMAGEM";
            });
            if (imageLink) {
                return imageLink.imageUrl;
            }
        }
        return "";
    };
    (0,react.useEffect)(function() {
        if (accessToken && (dataProduct === null || dataProduct === void 0 ? void 0 : dataProduct.isChatbotEnabled)) {
            setShowSaleChatbot(true);
            return;
        }
        setShowSaleChatbot(false);
    }, [
        setShowSaleChatbot,
        accessToken,
        dataProduct
    ]);
    (0,react.useEffect)(function() {
        return function() {
            setShowSaleChatbot(false);
        };
    }, [
        setShowSaleChatbot
    ]);
    var ref20, ref21;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_HeaderProductFixed, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                isBlackTheme: blackFridayTheme === null || blackFridayTheme === void 0 ? void 0 : blackFridayTheme.isBlackTheme
            }, dataProduct), {
                idProduct: String(productId),
                packageCurrentState: packageCurrentState,
                addItemCart: function() {
                    return handleSendItemToCart((packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.packingQuantity) || 0);
                },
                sectionIdItemsMenu: SECTIONS_ITEMS_MENU,
                actionAddToGift: addProductsToWeddingList,
                activeButtonWeddingList: Boolean(activeWeddingList === null || activeWeddingList === void 0 ? void 0 : activeWeddingList.id),
                sendingItemToCart: sendingItemToCart,
                maximumStockPerBranch: (ref20 = dataProduct === null || dataProduct === void 0 ? void 0 : dataProduct.maximumStockPerBranch) !== null && ref20 !== void 0 ? ref20 : 0
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainProductContainer, {
                isBlackTheme: blackFridayTheme === null || blackFridayTheme === void 0 ? void 0 : blackFridayTheme.isBlackTheme,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Row, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.SpaceWrapper, {
                                padding: "".concat(ui.theme.space.x5, " ").concat(ui.theme.space.x0, " ").concat(ui.theme.space["x3.5"]),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BreadcrumbProduct, {
                                    items: (breadcrumbItems === null || breadcrumbItems === void 0 ? void 0 : breadcrumbItems.items) || null
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_BoxProduct, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            isBlackTheme: !!(dataProduct === null || dataProduct === void 0 ? void 0 : dataProduct.isBlackFriday)
                        }, dataProduct), {
                            idProduct: String(productId),
                            prices: productPrices,
                            setPackageCurrent: setPackageCurrent,
                            packageCurrentState: packageCurrentState,
                            actionAddItemCart: function() {
                                return handleSendItemToCart((packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.packingQuantity) || 0);
                            },
                            setProductQuantity: setQuantityItems,
                            actionAddToGift: addProductsToWeddingList,
                            activeButtonWeddingList: Boolean(activeWeddingList === null || activeWeddingList === void 0 ? void 0 : activeWeddingList.id),
                            limitTotalQuantityItem: limitQuantityItem,
                            sendingItemToCart: sendingItemToCart,
                            isBlackFriday: blackFridayTheme === null || blackFridayTheme === void 0 ? void 0 : blackFridayTheme.isBlackTheme
                        })),
                        isLoadingOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperLoading, {
                            isClientMobile: isClientMobile,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ButtonSubmit */.GX, {
                                underAction: true,
                                color: "transparent",
                                contentColor: ui.theme.colors.secondary[300],
                                height: "4rem",
                                minWidth: "200px",
                                buttonType: "button",
                                hoveredColor: "trasnparent",
                                textUnderAction: "Carregando",
                                border: "2px solid",
                                borderColor: ui.theme.colors.secondary[300]
                            })
                        }),
                        dataProduct ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                (dataProduct === null || dataProduct === void 0 ? void 0 : dataProduct.detailedDescription) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_AboutTheProduct, {
                                    idSection: SECTIONS_ITEMS_MENU[0].idReference,
                                    productDetails: dataProduct === null || dataProduct === void 0 ? void 0 : dataProduct.detailedDescription,
                                    isBlackTheme: blackFridayTheme === null || blackFridayTheme === void 0 ? void 0 : blackFridayTheme.isBlackTheme
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_ProductSpec, {
                                    idSection: SECTIONS_ITEMS_MENU[1].idReference,
                                    brand: dataProduct === null || dataProduct === void 0 ? void 0 : dataProduct.brand,
                                    idProduct: String(productId),
                                    handleSize: handleSize,
                                    handleModel: handleModel,
                                    hasProductSpecCalled: hasProductSpecCalled,
                                    isBlackTheme: blackFridayTheme === null || blackFridayTheme === void 0 ? void 0 : blackFridayTheme.isBlackTheme,
                                    bareanId13: dataProduct === null || dataProduct === void 0 ? void 0 : dataProduct.bareanId13
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_AlsoSee, {
                                    idSection: SECTIONS_ITEMS_MENU[2].idReference,
                                    idProduct: String(productId),
                                    isBlackTheme: blackFridayTheme === null || blackFridayTheme === void 0 ? void 0 : blackFridayTheme.isBlackTheme
                                })
                            ]
                        }) : null
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ModalVoltage, {
                stateModal: isVoltageModalOpen,
                actionCloseModal: function() {
                    return setIsVoltageModalOpen(false);
                },
                actionSuccess: function() {
                    return handleSendItemToCart((ref21 = packageCurrentState === null || packageCurrentState === void 0 ? void 0 : packageCurrentState.packingQuantity) !== null && ref21 !== void 0 ? ref21 : 0);
                },
                sendingItemToCart: sendingItemToCart,
                infoText: dataProduct === null || dataProduct === void 0 ? void 0 : dataProduct.voltage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PopupAlertAddProductToWeddingList */.zR, {
                textDescriptionProduct: dataProduct === null || dataProduct === void 0 ? void 0 : dataProduct.description,
                titleAlert: "ADICIONADO \xc0 LISTA",
                imageUrlProduct: getImageUrl(),
                isOpen: isWeddingListPopUpOpened,
                handlerStatusPopup: setIsWeddingListPopUpOpened
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PopUpAlertConfirm */.Oj, {
                textHeader: "Falha ao adicionar produto",
                isOpen: weddingListModalError,
                actionCloseButton: function() {
                    return setWeddingListModalError(false);
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/screens/Product/index.tsx










var Product = function(param) {
    var dataProduct = param.dataProduct, blackFridayTheme = param.blackFridayTheme, hasChangesInClientBranchFromRegionIdParam = param.hasChangesInClientBranchFromRegionIdParam, siteUrl = param.siteUrl, cartId = param.cartId, branchId = param.branchId, productId = param.productId, schema = param.schema;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var router = (0,next_router.useRouter)();
    var ID_PRODUCT = router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.idProduct;
    var BRANCH_ID_ROUTER = Number(router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.region_id) === null || ref2 === void 0 ? void 0 : ref2.at(0));
    var accessToken = implementations/* cookie.getCookie */.pR.getCookie({
        name: cookieAccessToken
    });
    var getBranchLocationClient = (0,application/* useBranchLocation */.vKz)().getBranchLocationClient;
    var BRANCH_ID = Number.isNaN(BRANCH_ID_ROUTER) ? Number(getBranchLocationClient()) : BRANCH_ID_ROUTER;
    var sellerId = dataProduct === null || dataProduct === void 0 ? void 0 : (ref3 = dataProduct.prices) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.sellerId;
    var data = implementations/* catalogApi.getProduct */.dZ.getProduct(Number(ID_PRODUCT), BRANCH_ID, !!(ID_PRODUCT && BRANCH_ID), dataProduct).data;
    var ref11 = implementations/* catalogApi.getProductPrices */.dZ.getProductPrices(Number(ID_PRODUCT), BRANCH_ID, (dataProduct === null || dataProduct === void 0 ? void 0 : dataProduct.packingLevel) || 0, sellerId, !!(ID_PRODUCT && BRANCH_ID && dataProduct && !Number.isNaN(sellerId))), productPrices = ref11.data;
    var ref12 = implementations/* weddingGiftListApi.getWeddingList */._6.getWeddingList(accessToken, undefined, Boolean(accessToken)), activeWeddingList = ref12.data;
    var regexToRemoveTheFirstSlash = /^\/(.*)/;
    var product = {
        id: dataProduct === null || dataProduct === void 0 ? void 0 : dataProduct.id,
        brand: dataProduct === null || dataProduct === void 0 ? void 0 : dataProduct.brand,
        productName: dataProduct === null || dataProduct === void 0 ? void 0 : dataProduct.description,
        productTitle: "".concat(dataProduct === null || dataProduct === void 0 ? void 0 : dataProduct.description, " | Ferreira Costa"),
        description: "Aqui na Ferreira Costa voc\xea encontra ".concat(dataProduct === null || dataProduct === void 0 ? void 0 : dataProduct.description, " e muito mais em promo\xe7\xe3o. Acesse j\xe1 e confira."),
        value: productPrices === null || productPrices === void 0 ? void 0 : (ref5 = productPrices[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.unitaryValue) === null || ref6 === void 0 ? void 0 : ref6.toString(),
        url: "".concat(siteUrl).concat(router.asPath.replace(regexToRemoveTheFirstSlash, "$1")),
        image: (ref8 = dataProduct === null || dataProduct === void 0 ? void 0 : (ref7 = dataProduct.mediaLinks) === null || ref7 === void 0 ? void 0 : ref7.at(0)) === null || ref8 === void 0 ? void 0 : ref8.imageUrl,
        // Em alinhamento com Pedro(Peixoto) a disponibilidade de um produto deve sempre estar como "instock", pois o produto pode ter em outra filial
        availability: "instock"
    };
    var priceProduct = (0,application/* valueProduct */.zrv)(productPrices === null || productPrices === void 0 ? void 0 : productPrices[0]);
    var ref13 = useViewPaymentMethods({
        discountPercentage: String(productPrices === null || productPrices === void 0 ? void 0 : (ref9 = productPrices[0]) === null || ref9 === void 0 ? void 0 : ref9.discountPercentage),
        maxNumberInstallments: Number(productPrices === null || productPrices === void 0 ? void 0 : (ref10 = productPrices[0]) === null || ref10 === void 0 ? void 0 : ref10.maxNumberInstallments),
        salePrice: (productPrices === null || productPrices === void 0 ? void 0 : productPrices[0].salePrice) || priceProduct,
        spotPrice: productPrices === null || productPrices === void 0 ? void 0 : productPrices[0].spotPrice
    }), isViewMoreComponentOpen = ref13.isViewMoreComponentOpen, setIsViewMorePaymentMethodsOpen = ref13.setIsViewMorePaymentMethodsOpen, paymentMethodsData = ref13.paymentMethodsData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* AddToHead */.oC, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "product:brand",
                        content: product === null || product === void 0 ? void 0 : product.brand
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "product:price:amount",
                        content: product === null || product === void 0 ? void 0 : product.value
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "product:retailer_item_id",
                        content: product === null || product === void 0 ? void 0 : product.id
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "product:availability",
                        content: product === null || product === void 0 ? void 0 : product.availability
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "product:condition",
                        content: "new"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "product:price:currency",
                        content: "BRL"
                    }),
                    schema && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        id: "structured_data",
                        children: JSON.stringify(schema)
                    })
                ]
            }),
            isViewMoreComponentOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethodsMobileContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethods_PaymentMethods, {
                    data: paymentMethodsData,
                    isMobile: true,
                    onClickBackButton: function() {
                        return setIsViewMorePaymentMethodsOpen(false);
                    }
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageUI, {
                blackFridayTheme: blackFridayTheme,
                hasChangesInClientBranchFromRegionIdParam: hasChangesInClientBranchFromRegionIdParam,
                siteUrl: siteUrl,
                cartId: cartId,
                dataProduct: data,
                isBlackTheme: blackFridayTheme === null || blackFridayTheme === void 0 ? void 0 : blackFridayTheme.isBlackTheme,
                activeWeddingList: activeWeddingList,
                productPrices: productPrices,
                productId: productId,
                branchId: branchId
            })
        ]
    });
};
/* harmony default export */ var screens_Product = (Product);


/***/ })

}]);